<!-- <div class="right-container" *ngIf="field_config_access">

  <mat-stepper class="example-stepper" #stepper linear [orientation]="stepperOrientation" labelPosition="bottom">
    <ng-container *ngFor="let section of sections">
      <mat-step *ngIf="field_config_access[section.fieldID]">
        <ng-template matStepLabel>
          {{field_config_access[section.fieldID].label | translate}}
        </ng-template>
        <ng-template matStepContent>

          <div>
            <ng-container *ngIf="section.id == 1">
              <form [formGroup]="personal_details_form">
                <div class="row">

                  <div class="col-md-2">
                    <div class="avatar-upload">
                      <div class="avatar-capture-camera" [title]="'RESUME.Capture photo by camera'|translate"
                        [ngStyle]="{'justify-content':(personal_details_form.get('profilePhoto').value && personal_details_form.get('profilePhoto').value !='')?'space-around':'flex-start'}">
                        <i class="fa fa-camera pointer camera-icon " (click)="setupDevices({isCamShot : true})"></i>

                        <i class="fa fa-trash orange pointer camera-icon " [title]="'RESUME.delete'|translate"
                          *ngIf="personal_details_form.get('profilePhoto').value && personal_details_form.get('profilePhoto').value !=''"
                          (click)="removeUploadedFile()"></i>

                      </div>
                      <div class="avatar-edit">
                        <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg" #fileInput
                          (change)="fileInputChanged($event)" />

                      </div>
                      <div class="avatar-preview" [style.height.px]="100" [style.width.px]="100">
                        <span *ngIf="personal_details_form.get('profilePhoto').value" class="delete-profile">
                          <i class="fa fa-pencil pointer delete-icon" (click)="fileInput.click()">
                          </i>
                          <div class="overlay"></div>
                        </span>

                        <ng-container
                          *ngIf="personal_details_form.get('profilePhoto').value && personal_details_form.get('profilePhoto').value[0] && personal_details_form.get('profilePhoto').value[0].cdnPath; else elseTemplate">

                          <div class="jump" (click)="fileInput.click()" id="imagePreview"
                            [style.backgroundImage]="'url('+ storage_url + personal_details_form.get('profilePhoto').value[0].cdnPath +')'">
                          </div>
                        </ng-container>
                        <ng-template #elseTemplate>

                          <div class="jump" (click)="fileInput.click()"
                            *ngIf="personal_details_form.get('profilePhoto').value" id="imagePreview"
                            [style.backgroundImage]="'url('+personal_details_form.get('profilePhoto').value +')'">
                          </div>
                        </ng-template>


                        <div (click)="fileInput.click()" *ngIf="!personal_details_form.get('profilePhoto').value"
                          id="imagePreviewDefault">
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-md-4" *ngIf="field_config_access['firstName']">
                        <mat-form-field floatLabel="always">
                          <mat-label>
                            {{field_config_access['firstName']['label'] |translate}}
                          </mat-label>
                          <input matInput formControlName="firstName"
                            [placeholder]="(field_config_access['firstName']['placeholder'] | translate)"
                            [readonly]="((field_config_access['firstName']['validators'] && field_config_access['firstName']['validators']['disable'] && field_config_access['firstName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                            [minlength]="(field_config_access['firstName']['validators'] && field_config_access['firstName']['validators']['minLength'])"
                            [maxlength]="(field_config_access['firstName']['validators'] && field_config_access['firstName']['validators']['maxLength'])"
                            [required]="(field_config_access['firstName']['validators'] && field_config_access['firstName']['validators']['mandatory']?true:false)">

                          <mat-error *ngIf="personal_details_form.get('firstName').invalid">
                            <ng-container
                              *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('firstName'),field_config_access:field_config_access['firstName']}">
                            </ng-container>
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-md-4" *ngIf="field_config_access['middleName']">
                        <mat-form-field floatLabel="always">
                          <mat-label>
                            {{field_config_access['middleName']['label'] |translate}}
                          </mat-label>
                          <input matInput formControlName="middleName"
                            [placeholder]="(field_config_access['middleName']['placeholder'] | translate)"
                            [readonly]="((field_config_access['middleName']['validators'] && field_config_access['middleName']['validators']['disable'] && field_config_access['middleName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                            [minlength]="(field_config_access['middleName']['validators'] && field_config_access['middleName']['validators']['minLength'])"
                            [maxlength]="(field_config_access['middleName']['validators'] && field_config_access['middleName']['validators']['maxLength'])"
                            [required]="(field_config_access['middleName']['validators'] && field_config_access['middleName']['validators']['mandatory']?true:false)">

                          <mat-error *ngIf="personal_details_form.get('middleName').invalid">
                            <ng-container
                              *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('middleName'),field_config_access:field_config_access['middleName']}">
                            </ng-container>
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-md-4" *ngIf="field_config_access['lastName']">
                        <mat-form-field floatLabel="always">
                          <mat-label>
                            {{field_config_access['lastName']['label'] |translate}}
                          </mat-label>
                          <input matInput formControlName="lastName"
                            [placeholder]="(field_config_access['lastName']['placeholder'] | translate)"
                            [readonly]="((field_config_access['lastName']['validators'] && field_config_access['lastName']['validators']['disable'] && field_config_access['lastName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                            [minlength]="(field_config_access['lastName']['validators'] && field_config_access['lastName']['validators']['minLength'])"
                            [maxlength]="(field_config_access['lastName']['validators'] && field_config_access['lastName']['validators']['maxLength'])"
                            [required]="(field_config_access['lastName']['validators'] && field_config_access['lastName']['validators']['mandatory']?true:false)">

                          <mat-error *ngIf="personal_details_form.get('lastName').invalid">
                            <ng-container
                              *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('lastName'),field_config_access:field_config_access['lastName']}">
                            </ng-container>
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-md-4" *ngIf="field_config_access['gender']">
                        <tm-select
                          [options]="masters[field_config_access['gender']['masterPropName'] || 'genderList'] || []"
                          [form_group]="personal_details_form" form_control="gender" title_property="title"
                          id_property="id" float_label="always"
                          [label]="field_config_access['gender']['label'] |translate"
                          [data]="personal_details_form.value.gender"
                          [placeholder]="((field_config_access['gender']['placeholder'])| translate)"
                          [label_overflow]="1">
                        </tm-select>
                      </div>

                      <div class="col-md-4" *ngIf="field_config_access['dob']">

                        <tm-date-picker [form]="personal_details_form" [controlName]="'dob'"
                          [placeholder]="((field_config_access['dob']['placeholder']) | translate) "
                          [label]="field_config_access['dob']['label'] |translate"
                          [value]="personal_details_form.value.dob"
                          [minValue]="(field_config_access['dob']['validators'] && field_config_access['dob']['validators']['minValue'])"
                          [maxValue]="(field_config_access['dob']['validators'] && field_config_access['dob']['validators']['maxValue'])">
                          [required]="(field_config_access['dob']['validators'] &&
                          field_config_access['dob']['validators']['mandatory'] ? true :false)"
                          [disabled]="((field_config_access['dob']['validators'] &&
                          field_config_access['dob']['validators']['disable'] &&
                          field_config_access['dob']['validators']['disable'] != '0')?true:false)
                          ||disabled_fields "

                        </tm-date-picker>
                      </div>

                      <div class="col-md-4" *ngIf="field_config_access['nationalityId']">
                        <tm-select
                          [options]="masters[field_config_access['nationalityId']['masterPropName'] || 'nationalityList'] || []"
                          [form_group]="personal_details_form" form_control="nationalityId" title_property="title"
                          id_property="id" float_label="always" [data]="personal_details_form.value.nationalityId"
                          [label]="field_config_access['nationalityId']['label'] |translate"
                          [placeholder]="((field_config_access['nationalityId']['placeholder'])| translate)"
                          [mandatory]="(field_config_access['nationalityId']['validators'] && field_config_access['nationalityId']['validators']['mandatory']?true:false)"
                          [disabled]="((field_config_access['nationalityId']['validators'] && field_config_access['nationalityId']['validators']['disable'] && field_config_access['nationalityId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                          [label_overflow]="1">
                        </tm-select>
                      </div>

                    </div>

                  </div>

                  <div class="col-md-6 mb-2" *ngIf="field_config_access['localAddress']">

                    <div class="card-box-shadow">
                      <div class="card-info-header header">
                        {{field_config_access['localAddress']['label'] |translate}}
                      </div>
                      <form [formGroup]="personal_details_form.get('localAddress')">
                        <div class="row p-3">

                          <div class="col-md-12" *ngIf="field_config_access['addressLine1']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['addressLine1']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="addressLine1"
                                [placeholder]="(field_config_access['addressLine1']['placeholder'] | translate)"
                                [readonly]="((field_config_access['addressLine1']['validators'] && field_config_access['addressLine1']['validators']['disable'] && field_config_access['addressLine1']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['addressLine1']['validators'] && field_config_access['addressLine1']['validators']['minLength'])"
                                [maxlength]="(field_config_access['addressLine1']['validators'] && field_config_access['addressLine1']['validators']['maxLength'])"
                                [required]="(field_config_access['addressLine1']['validators'] && field_config_access['addressLine1']['validators']['mandatory']?true:false)">

                              <mat-error
                                *ngIf="(personal_details_form.get('localAddress')).get('addressLine1').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:(personal_details_form.get('localAddress')).get('addressLine1'),field_config_access:field_config_access['addressLine1']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>

                          </div>

                          <div class="col-md-12" *ngIf="field_config_access['addressLine2']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['addressLine2']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="addressLine2"
                                [placeholder]="(field_config_access['addressLine2']['placeholder'] | translate)"
                                [readonly]="((field_config_access['addressLine2']['validators'] && field_config_access['addressLine2']['validators']['disable'] && field_config_access['addressLine2']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['addressLine2']['validators'] && field_config_access['addressLine2']['validators']['minLength'])"
                                [maxlength]="(field_config_access['addressLine2']['validators'] && field_config_access['addressLine2']['validators']['maxLength'])"
                                [required]="(field_config_access['addressLine2']['validators'] && field_config_access['addressLine2']['validators']['mandatory']?true:false)">

                              <mat-error
                                *ngIf="(personal_details_form.get('localAddress')).get('addressLine2').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:(personal_details_form.get('localAddress')).get('addressLine2'),field_config_access:field_config_access['addressLine2']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-md-6" *ngIf="field_config_access['cityId']">
                            <tm-select
                              [options]="masters[field_config_access['cityId']['masterPropName'] || 'cityList'] || []"
                              [form_group]="personal_details_form.get('localAddress')" form_control="cityId"
                              id_property="id" title_property="title"
                              [data]="personal_details_form.get('localAddress').value.cityId" float_label="always"
                              [label]="field_config_access['cityId']['label'] |translate"
                              [placeholder]="((field_config_access['cityId']['placeholder'])| translate)"
                              [mandatory]="(field_config_access['cityId']['validators'] && field_config_access['cityId']['validators']['mandatory']?true:false)"
                              [disabled]="((field_config_access['cityId']['validators'] && field_config_access['cityId']['validators']['disable'] && field_config_access['cityId']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                            </tm-select>
                          </div>
                          <div class="col-md-6" *ngIf="field_config_access['stateId']">
                            <tm-select
                              [options]="masters[field_config_access['stateId']['masterPropName'] || 'stateList'] || []"
                              [form_group]="personal_details_form.get('localAddress')" form_control="stateId"
                              id_property="id" title_property="title"
                              [data]="personal_details_form.get('localAddress').value.stateId" float_label="always"
                              [label]="field_config_access['stateId']['label'] |translate"
                              [placeholder]="((field_config_access['stateId']['placeholder'])| translate)"
                              [mandatory]="(field_config_access['stateId']['validators'] && field_config_access['stateId']['validators']['mandatory']?true:false)"
                              [disabled]="((field_config_access['stateId']['validators'] && field_config_access['stateId']['validators']['disable'] && field_config_access['stateId']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                            </tm-select>
                          </div>
                          <div class="col-md-6" *ngIf="field_config_access['countryId']">
                            <tm-select
                              [options]="masters[field_config_access['countryId']['masterPropName'] || 'countryList'] || []"
                              [form_group]="personal_details_form.get('localAddress')" form_control="countryId"
                              id_property="id" title_property="title"
                              [data]="personal_details_form.get('localAddress').value.countryId" float_label="always"
                              [label]="field_config_access['countryId']['label'] |translate"
                              [placeholder]="((field_config_access['countryId']['placeholder'])| translate)"
                              [mandatory]="(field_config_access['countryId']['validators'] && field_config_access['countryId']['validators']['mandatory']?true:false)"
                              [disabled]="((field_config_access['countryId']['validators'] && field_config_access['countryId']['validators']['disable'] && field_config_access['countryId']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                            </tm-select>
                          </div>
                          <div class="col-md-6">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['postalCode']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="postalCode"
                                [placeholder]="(field_config_access['postalCode']['placeholder'] | translate)"
                                [readonly]="((field_config_access['postalCode']['validators'] && field_config_access['postalCode']['validators']['disable'] && field_config_access['postalCode']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['postalCode']['validators'] && field_config_access['postalCode']['validators']['minLength'])"
                                [maxlength]="(field_config_access['postalCode']['validators'] && field_config_access['postalCode']['validators']['maxLength'])"
                                [required]="(field_config_access['postalCode']['validators'] && field_config_access['postalCode']['validators']['mandatory']?true:false)">

                              <mat-error *ngIf="(personal_details_form.get('localAddress')).get('postalCode').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:(personal_details_form.get('localAddress')).get('postalCode'),field_config_access:field_config_access['postalCode']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-md-12" *ngIf="field_config_access['attachments']">
                            <tm-files-v2 [form_group]="personal_details_form.get('localAddress')"
                              [form_control]="'attachments'"
                              [result]="(personal_details_form.get('localAddress')).value.attachments"
                              [label]="field_config_access['attachments']['label'] " [multiple]="0"
                              [disabled]="((field_config_access['attachments']['validators'] && field_config_access['attachments']['validators']['disable'] && field_config_access['attachments']['validators']['disable']!='0')?true:false) ||disabled_fields"
                              [required]="(field_config_access['attachments']['validators'] && field_config_access['attachments']['validators']['mandatory']?true:false)">
                              >
                            </tm-files-v2>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <div class="col-md-6 mb-2" *ngIf="field_config_access['permanentAddress']">

                    <div class="card-box-shadow">
                      <div class="card-info-header header">
                        {{field_config_access['permanentAddress']['label'] |translate}}
                        <span class="mx-1 link" style="font-style: italic" (click)="copyAddress()">
                          {{ "OFFER.copy_permanent_address" | translate}}
                        </span>
                      </div>
                      <form [formGroup]="personal_details_form.get('permanentAddress')">
                        <div class="row p-3">
                          <div class="col-md-12" *ngIf="field_config_access['addressLine1']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['addressLine1']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="addressLine1"
                                [placeholder]="(field_config_access['addressLine1']['placeholder'] | translate)"
                                [readonly]="((field_config_access['addressLine1']['validators'] && field_config_access['addressLine1']['validators']['disable'] && field_config_access['addressLine1']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['addressLine1']['validators'] && field_config_access['addressLine1']['validators']['minLength'])"
                                [maxlength]="(field_config_access['addressLine1']['validators'] && field_config_access['addressLine1']['validators']['maxLength'])"
                                [required]="(field_config_access['addressLine1']['validators'] && field_config_access['addressLine1']['validators']['mandatory']?true:false)">

                              <mat-error
                                *ngIf="(personal_details_form.get('permanentAddress')).get('addressLine1').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:(personal_details_form.get('permanentAddress')).get('addressLine1'),field_config_access:field_config_access['addressLine1']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>

                          </div>

                          <div class="col-md-12" *ngIf="field_config_access['addressLine2']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['addressLine2']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="addressLine2"
                                [placeholder]="(field_config_access['addressLine2']['placeholder'] | translate)"
                                [readonly]="((field_config_access['addressLine2']['validators'] && field_config_access['addressLine2']['validators']['disable'] && field_config_access['addressLine2']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['addressLine2']['validators'] && field_config_access['addressLine2']['validators']['minLength'])"
                                [maxlength]="(field_config_access['addressLine2']['validators'] && field_config_access['addressLine2']['validators']['maxLength'])"
                                [required]="(field_config_access['addressLine2']['validators'] && field_config_access['addressLine2']['validators']['mandatory']?true:false)">

                              <mat-error
                                *ngIf="(personal_details_form.get('permanentAddress')).get('addressLine2').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:(personal_details_form.get('permanentAddress')).get('addressLine2'),field_config_access:field_config_access['addressLine2']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-md-6" *ngIf="field_config_access['cityId']">
                            <tm-select
                              [options]="masters[field_config_access['cityId']['masterPropName'] || 'cityList'] || []"
                              [form_group]="personal_details_form.get('permanentAddress')" form_control="cityId"
                              id_property="id" title_property="title"
                              [data]="personal_details_form.get('permanentAddress').value.cityId" float_label="always"
                              [label]="field_config_access['cityId']['label'] |translate"
                              [placeholder]="((field_config_access['cityId']['placeholder'])| translate)"
                              [mandatory]="(field_config_access['cityId']['validators'] && field_config_access['cityId']['validators']['mandatory']?true:false)"
                              [disabled]="((field_config_access['cityId']['validators'] && field_config_access['cityId']['validators']['disable'] && field_config_access['cityId']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                            </tm-select>
                          </div>
                          <div class="col-md-6" *ngIf="field_config_access['stateId']">
                            <tm-select
                              [options]="masters[field_config_access['stateId']['masterPropName'] || 'stateList'] || []"
                              [form_group]="personal_details_form.get('permanentAddress')" form_control="stateId"
                              id_property="id" title_property="title"
                              [data]="personal_details_form.get('permanentAddress').value.stateId" float_label="always"
                              [label]="field_config_access['stateId']['label'] |translate"
                              [placeholder]="((field_config_access['stateId']['placeholder'])| translate)"
                              [mandatory]="(field_config_access['stateId']['validators'] && field_config_access['stateId']['validators']['mandatory']?true:false)"
                              [disabled]="((field_config_access['stateId']['validators'] && field_config_access['stateId']['validators']['disable'] && field_config_access['stateId']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                            </tm-select>
                          </div>
                          <div class="col-md-6" *ngIf="field_config_access['countryId']">
                            <tm-select
                              [options]="masters[field_config_access['countryId']['masterPropName'] || 'countryList'] || []"
                              [form_group]="personal_details_form.get('permanentAddress')" form_control="countryId"
                              id_property="id" title_property="title"
                              [data]="personal_details_form.get('permanentAddress').value.countryId"
                              float_label="always" [label]="field_config_access['countryId']['label'] |translate"
                              [placeholder]="((field_config_access['countryId']['placeholder'])| translate)"
                              [mandatory]="(field_config_access['countryId']['validators'] && field_config_access['countryId']['validators']['mandatory']?true:false)"
                              [disabled]="((field_config_access['countryId']['validators'] && field_config_access['countryId']['validators']['disable'] && field_config_access['countryId']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                            </tm-select>
                          </div>
                          <div class="col-md-6" *ngIf="field_config_access['postalCode']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['postalCode']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="postalCode"
                                [placeholder]="(field_config_access['postalCode']['placeholder'] | translate)"
                                [readonly]="((field_config_access['postalCode']['validators'] && field_config_access['postalCode']['validators']['disable'] && field_config_access['postalCode']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['postalCode']['validators'] && field_config_access['postalCode']['validators']['minLength'])"
                                [maxlength]="(field_config_access['postalCode']['validators'] && field_config_access['postalCode']['validators']['maxLength'])"
                                [required]="(field_config_access['postalCode']['validators'] && field_config_access['postalCode']['validators']['mandatory']?true:false)">

                              <mat-error
                                *ngIf="(personal_details_form.get('permanentAddress')).get('postalCode').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:(personal_details_form.get('permanentAddress')).get('postalCode'),field_config_access:field_config_access['postalCode']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-md-12" *ngIf="field_config_access['attachments']">
                            <tm-files-v2 [form_group]="personal_details_form.get('permanentAddress')"
                              [form_control]="'attachments'"
                              [result]="(personal_details_form.get('permanentAddress')).value.attachments"
                              [label]="field_config_access['attachments']['label'] " [multiple]="0"
                              [disabled]="((field_config_access['attachments']['validators'] && field_config_access['attachments']['validators']['disable'] && field_config_access['attachments']['validators']['disable']!='0')?true:false) ||disabled_fields"
                              [required]="(field_config_access['attachments']['validators'] && field_config_access['attachments']['validators']['mandatory']?true:false)">
                              >
                            </tm-files-v2>
                          </div>

                        </div>
                      </form>
                    </div>
                  </div>

                  <div class="col-md-4" *ngIf="field_config_access['mobileIsd'] && field_config_access['mobileNumber']">
                    <div class="prefix-control" style="width: 35%;">
                      <tm-select
                        [options]="masters[field_config_access['mobileIsd']['masterPropName'] || 'isdCountryList'] || []"
                        [form_group]="personal_details_form" form_control="mobileIsd" title_property="title"
                        id_property="id" float_label="always" [data]="personal_details_form.value.mobileIsd"
                        [label_overflow]="1" [label]="field_config_access['mobileIsd']['label'] |translate"
                        [placeholder]="((field_config_access['mobileIsd']['placeholder'])| translate)"
                        [mandatory]="(field_config_access['mobileIsd']['validators'] && field_config_access['mobileIsd']['validators']['mandatory']?true:false)"
                        [disabled]="((field_config_access['mobileIsd']['validators'] && field_config_access['mobileIsd']['validators']['disable'] && field_config_access['mobileIsd']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                      </tm-select>
                    </div>
                    <div class="main-control" style="width: 65%;">
                      <app-phone-number
                        [options]="masters[field_config_access['mobileIsd']['masterPropName'] || 'isdCountryList'] || []"
                        [options_data]="personal_details_form.value.mobileIsd" [form]="personal_details_form"
                        controlName="mobileNumber" [data]="personal_details_form.controls['mobileNumber'].value"
                        [disabledDial]="1" [hide_label]="1"
                        [label]="field_config_access['mobileNumber']['label'] |translate"
                        [placeholder]="((field_config_access['mobileNumber']['placeholder'])| translate)"
                        [required]="(field_config_access['mobileNumber']['validators'] && field_config_access['mobileNumber']['validators']['mandatory']?true:false)"
                        [readonly]="((field_config_access['mobileNumber']['validators'] && field_config_access['mobileNumber']['validators']['disable'] && field_config_access['mobileNumber']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                        [pattern_desc]="(field_config_access['mobileNumber']['validators'] &&
                        field_config_access['mobileNumber']['validators']['finalPattern'] )|| '^[0-9]*$'" >
                      </app-phone-number>
                    </div>
                  </div>

                  <div class="col-md-4"
                    *ngIf="field_config_access['altMobileIsd'] && field_config_access['altMobileNumber']">
                    <div class="prefix-control" style="width: 35%;">
                      <tm-select
                        [options]="masters[field_config_access['altMobileIsd']['masterPropName'] || 'isdCountryList'] || []"
                        [form_group]="personal_details_form" form_control="altMobileIsd" title_property="title"
                        id_property="id" float_label="always" [data]="personal_details_form.value.altMobileIsd"
                        [label_overflow]="1" [label]="field_config_access['altMobileIsd']['label'] |translate"
                        [placeholder]="((field_config_access['altMobileIsd']['placeholder'])| translate)"
                        [mandatory]="(field_config_access['altMobileIsd']['validators'] && field_config_access['altMobileIsd']['validators']['mandatory']?true:false)"
                        [disabled]="((field_config_access['altMobileIsd']['validators'] && field_config_access['altMobileIsd']['validators']['disable'] && field_config_access['altMobileIsd']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                      </tm-select>
                    </div>
                    <div class="main-control" style="width: 65%;">
                      <app-phone-number
                        [options]="masters[field_config_access['altMobileIsd']['masterPropName'] || 'isdCountryList'] || []"
                        [options_data]="personal_details_form.value.altMobileIsd" [form]="personal_details_form"
                        controlName="altMobileNumber" [data]="personal_details_form.controls['altMobileNumber'].value"
                        [disabledDial]="1" [hide_label]="1"
                        [label]="field_config_access['altMobileNumber']['label'] |translate"
                        [placeholder]="((field_config_access['altMobileNumber']['placeholder'])| translate)"
                        [required]="(field_config_access['altMobileNumber']['validators'] && field_config_access['altMobileNumber']['validators']['mandatory']?true:false)"
                        [readonly]="((field_config_access['altMobileNumber']['validators'] && field_config_access['altMobileNumber']['validators']['disable'] && field_config_access['altMobileNumber']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                        [pattern_desc]="(field_config_access['altMobileNumber']['validators'] &&
                        field_config_access['altMobileNumber']['validators']['finalPattern']) || '^[0-9]*$'"
                        >
                      </app-phone-number>
                    </div>
                  </div>

                  <div class="col-md-4" *ngIf="field_config_access['emailId']">
                    <mat-form-field floatLabel="always">
                      <mat-label>
                        {{field_config_access['emailId']['label'] |translate}}
                      </mat-label>
                      <input matInput formControlName="emailId" name="emailId"
                        [placeholder]="((field_config_access['emailId']['placeholder'])| translate)"
                        [required]="(field_config_access['emailId']['validators'] && field_config_access['emailId']['validators']['mandatory']?true:false)"
                        [minlength]="(field_config_access['emailId']['validators'] && field_config_access['emailId']['validators']['minLength'])"
                        [maxlength]="(field_config_access['emailId']['validators'] && field_config_access['emailId']['validators']['maxLength'])"
                        [readonly]="((field_config_access['emailId']['validators'] && field_config_access['emailId']['validators']['disable'] && field_config_access['emailId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                        [pattern]="(field_config_access['emailId']['validators'] &&
                        field_config_access['emailId']['validators']['finalPattern']) " />

                      <mat-error *ngIf="personal_details_form.get('emailId').invalid">
                        <ng-container
                          *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('emailId'),field_config_access:field_config_access['emailId']}">
                        </ng-container>
                      </mat-error>

                    </mat-form-field>
                  </div>

                  <div class="col-md-4" *ngIf="field_config_access['altEmailId']">
                    <mat-form-field floatLabel="always">
                      <mat-label>
                        {{field_config_access['altEmailId']['label'] |translate}}
                      </mat-label>
                      <input matInput formControlName="altEmailId" name="altEmailId"
                        [placeholder]="((field_config_access['altEmailId']['placeholder'])| translate)"
                        [required]="(field_config_access['altEmailId']['validators'] && field_config_access['altEmailId']['validators']['mandatory']?true:false)"
                        [minlength]="(field_config_access['altEmailId']['validators'] && field_config_access['altEmailId']['validators']['minLength'])"
                        [maxlength]="(field_config_access['altEmailId']['validators'] && field_config_access['altEmailId']['validators']['maxLength'])"
                        [readonly]="((field_config_access['altEmailId']['validators'] && field_config_access['altEmailId']['validators']['disable'] && field_config_access['altEmailId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                        [pattern]="(field_config_access['altEmailId']['validators'] &&
                        field_config_access['altEmailId']['validators']['finalPattern']) " />

                      <mat-error *ngIf="personal_details_form.get('altEmailId').invalid">
                        <ng-container
                          *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('altEmailId'),field_config_access:field_config_access['altEmailId']}">
                        </ng-container>
                      </mat-error>


                    </mat-form-field>
                  </div>

                  <div class="col-md-4" *ngIf="field_config_access['sourceId']">
                    <tm-select
                      [options]="masters[field_config_access['sourceId']['masterPropName'] || 'sourceList'] || []"
                      [form_group]="personal_details_form" form_control="sourceId" title_property="title"
                      id_property="id" float_label="always" [data]="personal_details_form.value.sourceId"
                      [label]="field_config_access['sourceId']['label'] |translate"
                      [placeholder]="((field_config_access['sourceId']['placeholder'])| translate)"
                      [mandatory]="(field_config_access['sourceId']['validators'] && field_config_access['sourceId']['validators']['mandatory']?true:false)"
                      [disabled]="((field_config_access['sourceId']['validators'] && field_config_access['sourceId']['validators']['disable'] && field_config_access['sourceId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                      [label_overflow]="1" (selected_obj)="sourceRefCheck($event)">
                    </tm-select>
                  </div>

                  <div class="col-md-4" *ngIf="field_config_access['sourceRefText'] && enableSourceRef">
                    <mat-form-field floatLabel="always">
                      <mat-label>
                        {{field_config_access['sourceRefText']['label'] |translate}}
                      </mat-label>
                      <input matInput formControlName="sourceRefText" name="sourceRefText"
                        [placeholder]="((field_config_access['sourceRefText']['placeholder'])| translate)"
                        [required]="(field_config_access['sourceRefText']['validators'] && field_config_access['sourceRefText']['validators']['mandatory']?true:false)"
                        [minlength]="(field_config_access['sourceRefText']['validators'] && field_config_access['sourceRefText']['validators']['minLength'])"
                        [maxlength]="(field_config_access['sourceRefText']['validators'] && field_config_access['sourceRefText']['validators']['maxLength'])"
                        [readonly]="((field_config_access['sourceRefText']['validators'] && field_config_access['sourceRefText']['validators']['disable'] && field_config_access['sourceRefText']['validators']['disable']!='0')?true:false) ||disabled_fields "
                        [pattern]="(field_config_access['sourceRefText']['validators'] &&
                        field_config_access['sourceRefText']['validators']['finalPattern'])" />

                      <mat-error *ngIf="personal_details_form.get('sourceRefText').invalid">
                        <ng-container
                          *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('sourceRefText'),field_config_access:field_config_access['sourceRefText']}">
                        </ng-container>
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-md-4" *ngIf="field_config_access['maritalStatusId']">
                    <tm-select
                      [options]="masters[field_config_access['maritalStatusId']['masterPropName'] || 'maritalStatusList'] || []"
                      [form_group]="personal_details_form" form_control="maritalStatusId" title_property="title"
                      id_property="id" float_label="always" [data]="personal_details_form.value.maritalStatusId"
                      [label]="field_config_access['maritalStatusId']['label'] |translate"
                      [placeholder]="((field_config_access['maritalStatusId']['placeholder'])| translate)"
                      [mandatory]="(field_config_access['maritalStatusId']['validators'] && field_config_access['maritalStatusId']['validators']['mandatory']?true:false)"
                      [disabled]="((field_config_access['maritalStatusId']['validators'] && field_config_access['maritalStatusId']['validators']['disable'] && field_config_access['maritalStatusId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                      [label_overflow]="1">
                    </tm-select>
                  </div>

                  <div class="col-md-4"
                    *ngIf="field_config_access['marriageDate'] && personal_details_form.value.maritalStatusId==2">
                    <tm-date-picker [form]="personal_details_form" [controlName]="'marriageDate'"
                      [placeholder]="((field_config_access['marriageDate']['placeholder']) | translate) "
                      [label]="field_config_access['marriageDate']['label'] |translate"
                      [value]="personal_details_form.value.marriageDate"
                      [minValue]="(field_config_access['marriageDate']['validators'] && field_config_access['marriageDate']['validators']['minValue'])"
                      [maxValue]="(field_config_access['marriageDate']['validators'] && field_config_access['marriageDate']['validators']['maxValue'])">
                      [required]="(field_config_access['marriageDate']['validators'] &&
                      field_config_access['marriageDate']['validators']['mandatory']?true:false)"
                      [disabled]="((field_config_access['marriageDate']['validators'] &&
                      field_config_access['marriageDate']['validators']['disable'] &&
                      field_config_access['marriageDate']['validators']['disable']!='0')?true:false)
                      ||disabled_fields "

                    </tm-date-picker>
                  </div>

                  <div class="col-md-12" *ngIf="field_config_access['hasValidPassport']">
                    <mat-accordion class="example-headers-align">
                      <mat-expansion-panel #panel (expandedChange)="passportPanelClosed($event,panel)"
                        [disabled]="((field_config_access['hasValidPassport']['validators'] && field_config_access['hasValidPassport']['validators']['disable'] && field_config_access['hasValidPassport']['validators']['disable']!='0')?true:false)">
                        <mat-expansion-panel-header>
                          <mat-panel-title> {{field_config_access['hasValidPassport']['label']}} </mat-panel-title>
                          <mat-panel-description>
                            <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                              formControlName="hasValidPassport">
                              <mat-radio-button class="example-radio-button"
                                *ngFor="let item of masters[field_config_access['hasValidPassport']['masterPropName'] || 'yesNoList'] || []"
                                [value]="item.id">
                                {{item.title}}
                              </mat-radio-button>
                            </mat-radio-group>

                          </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div class="row">
                          <div class="col-md-4" *ngIf="field_config_access['ppNumber']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['ppNumber']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="ppNumber"
                                [placeholder]="(field_config_access['ppNumber']['placeholder'] | translate)"
                                [readonly]="((field_config_access['ppNumber']['validators'] && field_config_access['ppNumber']['validators']['disable'] && field_config_access['ppNumber']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['ppNumber']['validators'] && field_config_access['ppNumber']['validators']['minLength'])"
                                [maxlength]="(field_config_access['ppNumber']['validators'] && field_config_access['ppNumber']['validators']['maxLength'])"
                                [required]="(field_config_access['ppNumber']['validators'] && field_config_access['ppNumber']['validators']['mandatory']&& personal_details_form.get('hasValidPassport').value?true:false)"
                                [pattern]="(field_config_access['ppNumber']['validators'] &&
                              field_config_access['ppNumber']['validators']['finalPattern'])" />
                              <mat-error *ngIf="personal_details_form.get('ppNumber').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('ppNumber'),field_config_access:field_config_access['ppNumber']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-md-2" *ngIf="field_config_access['ppIssueDate']">
                            <tm-date-picker [form]="personal_details_form" [controlName]="'ppIssueDate'"
                              [placeholder]="((field_config_access['ppIssueDate']['placeholder']) | translate) "
                              [label]="field_config_access['ppIssueDate']['label'] |translate"
                              [value]="personal_details_form.value.ppIssueDate"
                              [minValue]="(field_config_access['ppIssueDate']['validators'] && field_config_access['ppIssueDate']['validators']['minValue'])"
                              [maxValue]="(field_config_access['ppIssueDate']['validators'] && field_config_access['ppIssueDate']['validators']['maxValue'])">
                              [required]="(field_config_access['ppIssueDate']['validators'] &&
                              field_config_access['ppIssueDate']['validators']['mandatory']&&personal_details_form.get('hasValidPassport').value?true:false)"
                              [disabled]="((field_config_access['ppIssueDate']['validators'] &&
                              field_config_access['ppIssueDate']['validators']['disable'] &&
                              field_config_access['ppIssueDate']['validators']['disable']!='0')?true:false)
                              ||disabled_fields "

                            </tm-date-picker>
                          </div>
                          <div class="col-md-2" *ngIf="field_config_access['ppExpiryDate']">
                            <tm-date-picker [form]="personal_details_form" [controlName]="'ppExpiryDate'"
                              [placeholder]="((field_config_access['ppExpiryDate']['placeholder']) | translate) "
                              [label]="field_config_access['ppExpiryDate']['label'] |translate"
                              [value]="personal_details_form.value.ppExpiryDate"
                              [minValue]="(field_config_access['ppExpiryDate']['validators'] && field_config_access['ppExpiryDate']['validators']['minValue'])"
                              [maxValue]="(field_config_access['ppExpiryDate']['validators'] && field_config_access['ppExpiryDate']['validators']['maxValue'])">
                              [required]="(field_config_access['ppExpiryDate']['validators'] &&
                              field_config_access['ppExpiryDate']['validators']['mandatory']&&personal_details_form.get('hasValidPassport').value?true:false)"
                              [disabled]="((field_config_access['ppExpiryDate']['validators'] &&
                              field_config_access['ppExpiryDate']['validators']['disable'] &&
                              field_config_access['ppExpiryDate']['validators']['disable']!='0')?true:false)
                              ||disabled_fields "

                            </tm-date-picker>
                          </div>
                          <div class="col-md-4 no-underline hide-underline" *ngIf="field_config_access['isECR']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['isECR']['label'] |translate}}
                              </mat-label>
                              <input matInput class="d-none" />
                              <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                                formControlName="isECR">
                                <mat-radio-button class="example-radio-button"
                                  *ngFor="let item of masters[field_config_access['isECR']['masterPropName'] || 'yesNoList'] || []"
                                  [value]="item.id">
                                  {{item.title}}
                                </mat-radio-button>
                              </mat-radio-group>
                            </mat-form-field>

                          </div>
                        </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>

                  <div class="col-md-12"
                    *ngIf="field_config_access['hasValidPassport'] && field_config_access['hasValidVisa']">
                    <mat-accordion class="example-headers-align">
                      <mat-expansion-panel #visaPanel (expandedChange)="visaPanelClosed($event,visaPanel)"
                        [disabled]="((field_config_access['hasValidVisa']['validators'] && field_config_access['hasValidVisa']['validators']['disable'] && field_config_access['hasValidVisa']['validators']['disable']!='0')?true:false)">
                        <mat-expansion-panel-header>
                          <mat-panel-title> {{field_config_access['hasValidVisa']['label']}} </mat-panel-title>
                          <mat-panel-description>
                            <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                              formControlName="hasValidVisa">
                              <mat-radio-button class="example-radio-button"
                                *ngFor="let item of masters[field_config_access['hasValidVisa']['masterPropName'] || 'yesNoList'] || []"
                                [value]="item.id">
                                {{item.title}}
                              </mat-radio-button>
                            </mat-radio-group>

                          </mat-panel-description>
                        </mat-expansion-panel-header>
                        <form [formGroup]="visaForm" class="col-md-12">
                          <div class="row">
                            <div class="col-md-5" *ngIf="field_config_access['visaPermitTypeId']">
                              <tm-select
                                [options]="masters[field_config_access['visaPermitTypeId']['masterPropName'] || 'visaPermitList'] || []"
                                [form_group]="visaForm" form_control="visaPermitTypeId" title_property="title"
                                id_property="id" float_label="always" [data]="visaForm.value.visaPermitTypeId"
                                [label]="field_config_access['visaPermitTypeId']['label'] |translate"
                                [placeholder]="((field_config_access['visaPermitTypeId']['placeholder'])| translate)"
                                [mandatory]="(field_config_access['visaPermitTypeId']['validators'] && field_config_access['visaPermitTypeId']['validators']['mandatory']&& personal_details_form.get('hasValidVisa').value?true:false)"
                                [disabled]="((field_config_access['visaPermitTypeId']['validators'] && field_config_access['visaPermitTypeId']['validators']['disable'] && field_config_access['visaPermitTypeId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [label_overflow]="1">
                              </tm-select>
                            </div>
                            <div class="col-md-5" *ngIf="field_config_access['visaCountryId']">
                              <tm-select
                                [options]="masters[field_config_access['visaCountryId']['masterPropName'] || 'visaCountryList'] || []"
                                [form_group]="visaForm" form_control="visaCountryId" title_property="title"
                                id_property="id" float_label="always" [data]="visaForm.value.visaCountryId"
                                [label]="field_config_access['visaCountryId']['label'] |translate"
                                [placeholder]="((field_config_access['visaCountryId']['placeholder'])| translate)"
                                [mandatory]="(field_config_access['visaCountryId']['validators'] && field_config_access['visaCountryId']['validators']['mandatory']&&personal_details_form.get('hasValidVisa').value?true:false)"
                                [disabled]="((field_config_access['visaCountryId']['validators'] && field_config_access['visaCountryId']['validators']['disable'] && field_config_access['visaCountryId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [label_overflow]="1">
                              </tm-select>
                            </div>
                            <div class="col-md-2 text-right">
                              <button (click)="addToTable(personal_details_form,'visaPermits',visaForm)"
                                class="btn btn-sm mat-mt js-btn-save">
                                <i class="fa fa-plus-square mx-1"></i>
                                {{'BTN.add'|translate}}
                              </button>
                            </div>
                            <div class="col-md-12 table-responsive tm-data-table">
                              <table class="table table-striped "
                                *ngIf="personal_details_form.get('visaPermits').value ">
                                <thead>
                                  <tr>
                                    <th *ngIf="field_config_access['visaPermitTypeId']">
                                      {{field_config_access['visaPermitTypeId']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['visaCountryId']['label'] |translate}}
                                    </th>
                                    <th class="text-center">
                                      Action
                                    </th>
                                  </tr>

                                </thead>
                                <tbody>
                                  <tr
                                    *ngFor="let item of personal_details_form.get('visaPermits').value  || [];let i = index">
                                    <td>{{item.visaPermitTypeId | DynamicPipe
                                      : masters[field_config_access['visaPermitTypeId']['masterPropName'] ||
                                      'visaPermitList'] || []:'id':'title' }}</td>
                                    <td>
                                      {{ item.visaCountryId | DynamicPipe
                                      : masters[field_config_access['visaCountryId']['masterPropName'] ||
                                      'visaCountryList'] || []:'id':'title' }} </td>

                                    <td class="text-center">
                                      <button class="btn btn-sm btn-default mx-1 "
                                        (click)="editTableItem(i,personal_details_form,'visaPermits',visaForm)">
                                        <i class="fa fa-pencil mx-1"></i>
                                        {{'BTN.edit'|translate}}
                                      </button>
                                      <button class="btn btn-sm btn-default mx-1 "
                                        (click)="deleteTableItem(i,personal_details_form,'visaPermits',visaForm)">
                                        <i class="fa fa-trash orange mx-1"></i>
                                        {{'BTN.delete'|translate}}
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>

                          </div>
                        </form>

                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>

                  <div class="col-md-12" *ngIf="field_config_access['hasDrivingLicense']">
                    <mat-accordion class="example-headers-align">
                      <mat-expansion-panel #dl_panel (expandedChange)="DLPanelClosed($event,dl_panel)"
                        [disabled]="((field_config_access['hasDrivingLicense']['validators'] && field_config_access['hasDrivingLicense']['validators']['disable'] && field_config_access['hasDrivingLicense']['validators']['disable']!='0')?true:false)">
                        <mat-expansion-panel-header>
                          <mat-panel-title> {{field_config_access['hasDrivingLicense']['label']}} </mat-panel-title>
                          <mat-panel-description>
                            <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                              formControlName="hasDrivingLicense">
                              <mat-radio-button class="example-radio-button"
                                *ngFor="let item of masters[field_config_access['hasDrivingLicense']['masterPropName'] || 'yesNoList'] || []"
                                [value]="item.id">
                                {{item.title}}
                              </mat-radio-button>
                            </mat-radio-group>

                          </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div class="row">
                          <div class="col-md-4" *ngIf="field_config_access['drivingLicense']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['drivingLicense']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="drivingLicense"
                                [placeholder]="(field_config_access['drivingLicense']['placeholder'] | translate)"
                                [readonly]="((field_config_access['drivingLicense']['validators'] && field_config_access['drivingLicense']['validators']['disable'] && field_config_access['drivingLicense']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['drivingLicense']['validators'] && field_config_access['drivingLicense']['validators']['minLength'])"
                                [maxlength]="(field_config_access['drivingLicense']['validators'] && field_config_access['drivingLicense']['validators']['maxLength'])"
                                [required]="(field_config_access['drivingLicense']['validators'] && field_config_access['drivingLicense']['validators']['mandatory'] && personal_details_form.get('hasDrivingLicense').value?true:false)"
                                [pattern]="(field_config_access['drivingLicense']['validators'] &&
                              field_config_access['drivingLicense']['validators']['finalPattern'])" />
                              <mat-error *ngIf="personal_details_form.get('drivingLicense').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('drivingLicense'),field_config_access:field_config_access['drivingLicense']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-md-4" *ngIf="field_config_access['DLIssueDate']">
                            <tm-date-picker [form]="personal_details_form" [controlName]="'DLIssueDate'"
                              [placeholder]="((field_config_access['DLIssueDate']['placeholder']) | translate) "
                              [label]="field_config_access['DLIssueDate']['label'] |translate"
                              [value]="personal_details_form.value.DLIssueDate"
                              [minValue]="(field_config_access['DLIssueDate']['validators'] && field_config_access['DLIssueDate']['validators']['minValue'])"
                              [maxValue]="(field_config_access['DLIssueDate']['validators'] && field_config_access['DLIssueDate']['validators']['maxValue'])">
                              [required]="(field_config_access['DLIssueDate']['validators'] &&
                              field_config_access['DLIssueDate']['validators']['mandatory'] &&
                              personal_details_form.get('hasDrivingLicense').value?true:false)"
                              [disabled]="((field_config_access['DLIssueDate']['validators'] &&
                              field_config_access['DLIssueDate']['validators']['disable'] &&
                              field_config_access['DLIssueDate']['validators']['disable']!='0')?true:false)
                              ||disabled_fields "

                            </tm-date-picker>
                          </div>
                          <div class="col-md-4" *ngIf="field_config_access['DLExpiryDate']">
                            <tm-date-picker [form]="personal_details_form" [controlName]="'DLExpiryDate'"
                              [placeholder]="((field_config_access['DLExpiryDate']['placeholder']) | translate) "
                              [label]="field_config_access['DLExpiryDate']['label'] |translate"
                              [value]="personal_details_form.value.DLExpiryDate"
                              [minValue]="(field_config_access['DLExpiryDate']['validators'] && field_config_access['DLExpiryDate']['validators']['minValue'])"
                              [maxValue]="(field_config_access['DLExpiryDate']['validators'] && field_config_access['DLExpiryDate']['validators']['maxValue'])">
                              [required]="(field_config_access['DLExpiryDate']['validators'] &&
                              field_config_access['DLExpiryDate']['validators']['mandatory']?true:false)"
                              [disabled]="((field_config_access['DLExpiryDate']['validators'] &&
                              field_config_access['DLExpiryDate']['validators']['disable'] &&
                              field_config_access['DLExpiryDate']['validators']['disable']!='0')?true:false)
                              ||disabled_fields "

                            </tm-date-picker>
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>

                  <div class="col-md-12" *ngIf="field_config_access['languages']">
                    <mat-accordion class="example-headers-align">
                      <mat-expansion-panel
                        [disabled]="((field_config_access['languages']['validators'] && field_config_access['languages']['validators']['disable'] && field_config_access['languages']['validators']['disable']!='0')?true:false)">
                        <mat-expansion-panel-header>
                          <mat-panel-title> {{field_config_access['languages']['label']}} </mat-panel-title>
                          <mat-panel-description>
                          </mat-panel-description>
                        </mat-expansion-panel-header>
                        <form [formGroup]="languages_form" class="col-md-12">
                          <div class="row">
                            <div class="col-md-4">
                              <tm-select [options]="masters['languageList'] || []" [form_group]="languages_form"
                                form_control="id" title_property="title" id_property="id" float_label="always"
                                [data]="languages_form.value.id" [label]="'Language' |translate"
                                [placeholder]="'< - - Select - - >'| translate" [mandatory]="1"
                                [disabled]="disabled_fields" [label_overflow]="1" (selected_obj)="lanSelected($event)">
                              </tm-select>
                            </div>

                            <div class="col-md-1">
                              <tm-checkbox [label]="'Read'" [form_group]="languages_form" form_control="isRead"
                                [data]="languages_form.value.isRead">

                              </tm-checkbox>
                            </div>
                            <div class="col-md-1">
                              <tm-checkbox [label]="'Write'" [form_group]="languages_form" form_control="iswrite"
                                [data]="languages_form.value.iswrite">

                              </tm-checkbox>
                            </div>
                            <div class="col-md-1">
                              <tm-checkbox [label]="'Speak'" [form_group]="languages_form" form_control="isSpeak"
                                [data]="languages_form.value.isSpeak">

                              </tm-checkbox>
                            </div>
                            <div class="col-md-1">
                              <tm-checkbox [label]="'Understand'" [form_group]="languages_form"
                                form_control="isUnderstand" [data]="languages_form.value.isUnderstand">

                              </tm-checkbox>
                            </div>
                            <div class="col-md-4 text-right">
                              <button (click)="addToTable(personal_details_form,'languages',languages_form)"
                                class="btn btn-sm mat-mt js-btn-save">
                                <i class="fa fa-plus-square mx-1"></i>
                                {{'BTN.add'|translate}}
                              </button>
                            </div>
                            <div class="col-md-12 table-responsive tm-data-table">
                              <table class="table table-striped" *ngIf="personal_details_form.get('languages').value ">
                                <thead>
                                  <tr>
                                    <th>
                                      {{'Languages'|translate}}
                                    </th>
                                    <th class="text-center">
                                      Read
                                    </th>
                                    <th class="text-center">
                                      Write
                                    </th>

                                    <th class="text-center">
                                      Speak
                                    </th>
                                    <th class="text-center">
                                      Understand
                                    </th>
                                    <th class="text-center">
                                      Action
                                    </th>
                                  </tr>

                                </thead>
                                <tbody>
                                  <tr
                                    *ngFor="let item of personal_details_form.get('languages').value  || [];let i = index">
                                    <td>
                                      {{ item.id | DynamicPipe : (masters['languageList'] || []):'id':'title' }}
                                    </td>

                                    <td class="text-center">
                                      <ng-container *ngIf="item.isRead">
                                        <i class="fa checkbox-icons fa-check-square-o"></i>
                                      </ng-container>

                                    </td>

                                    <td class="text-center">
                                      <ng-container *ngIf="item.iswrite">
                                        <i class="fa checkbox-icons fa-check-square-o"></i>
                                      </ng-container>
                                    </td>

                                    <td class="text-center">
                                      <ng-container *ngIf="item.isSpeak">
                                        <i class="fa checkbox-icons fa-check-square-o"></i>
                                      </ng-container>
                                    </td>

                                    <td class="text-center">
                                      <ng-container *ngIf="item.isUnderstand">
                                        <i class="fa checkbox-icons fa-check-square-o"></i>
                                      </ng-container>
                                    </td>

                                    <td class="text-center">
                                      <button class="btn btn-sm btn-default mx-1 "
                                        (click)="editTableItem(i,personal_details_form,'languages',languages_form)">
                                        <i class="fa fa-pencil mx-1"></i>
                                        {{'BTN.edit'|translate}}
                                      </button>
                                      <button class="btn btn-sm btn-default mx-1 "
                                        (click)="deleteTableItem(i,personal_details_form,'languages',languages_form)">
                                        <i class="fa fa-trash orange mx-1"></i>
                                        {{'BTN.delete'|translate}}
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>

                          </div>
                        </form>

                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>

                  <div class="col-md-12" *ngIf="field_config_access['personalInfo_otherDetails']">
                    <mat-accordion class="example-headers-align">
                      <mat-expansion-panel #panel
                        [disabled]="((field_config_access['personalInfo_otherDetails']['validators'] && field_config_access['personalInfo_otherDetails']['validators']['disable'] && field_config_access['personalInfo_otherDetails']['validators']['disable']!='0')?true:false)">
                        <mat-expansion-panel-header>
                          <mat-panel-title> {{field_config_access['personalInfo_otherDetails']['label']}}
                          </mat-panel-title>
                          <mat-panel-description>
                          </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div class="row">
                          <div class="col-md-4" *ngIf="field_config_access['panCardNumber']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['panCardNumber']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="panCardNumber"
                                [placeholder]="(field_config_access['panCardNumber']['placeholder'] | translate)"
                                [readonly]="((field_config_access['panCardNumber']['validators'] && field_config_access['panCardNumber']['validators']['disable'] && field_config_access['panCardNumber']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['panCardNumber']['validators'] && field_config_access['panCardNumber']['validators']['minLength'])"
                                [maxlength]="(field_config_access['panCardNumber']['validators'] && field_config_access['panCardNumber']['validators']['maxLength'])"
                                [required]="(field_config_access['panCardNumber']['validators'] && field_config_access['panCardNumber']['validators']['mandatory']?true:false)"
                                [pattern]="(field_config_access['panCardNumber']['validators'] &&
                              field_config_access['panCardNumber']['validators']['finalPattern'])" />
                              <mat-error *ngIf="personal_details_form.get('panCardNumber').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('panCardNumber'),field_config_access:field_config_access['panCardNumber']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['aadharNumber']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['aadharNumber']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="aadharNumber" type="number"
                                [placeholder]="(field_config_access['aadharNumber']['placeholder'] | translate)"
                                [readonly]="((field_config_access['aadharNumber']['validators'] && field_config_access['aadharNumber']['validators']['disable'] && field_config_access['aadharNumber']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['aadharNumber']['validators'] && field_config_access['aadharNumber']['validators']['minLength'])"
                                [maxlength]="(field_config_access['aadharNumber']['validators'] && field_config_access['aadharNumber']['validators']['maxLength'])"
                                [required]="(field_config_access['aadharNumber']['validators'] && field_config_access['aadharNumber']['validators']['mandatory']?true:false)"
                                [pattern]="(field_config_access['aadharNumber']['validators'] &&
                              field_config_access['aadharNumber']['validators']['finalPattern'])" />
                              <mat-error *ngIf="personal_details_form.get('aadharNumber').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('aadharNumber'),field_config_access:field_config_access['aadharNumber']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['personalIdentificationMarks']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['personalIdentificationMarks']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="personalIdentificationMarks"
                                [placeholder]="(field_config_access['personalIdentificationMarks']['placeholder'] | translate)"
                                [readonly]="((field_config_access['personalIdentificationMarks']['validators'] && field_config_access['personalIdentificationMarks']['validators']['disable'] && field_config_access['personalIdentificationMarks']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['personalIdentificationMarks']['validators'] && field_config_access['personalIdentificationMarks']['validators']['minLength'])"
                                [maxlength]="(field_config_access['personalIdentificationMarks']['validators'] && field_config_access['personalIdentificationMarks']['validators']['maxLength'])"
                                [required]="(field_config_access['personalIdentificationMarks']['validators'] && field_config_access['personalIdentificationMarks']['validators']['mandatory']?true:false)"
                                [pattern]="(field_config_access['personalIdentificationMarks']['validators'] &&
                              field_config_access['personalIdentificationMarks']['validators']['finalPattern'])" />
                              <mat-error *ngIf="personal_details_form.get('personalIdentificationMarks').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('personalIdentificationMarks'),field_config_access:field_config_access['personalIdentificationMarks']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['personalInfo_bloodGroup']">
                            <tm-select
                              [options]="masters[field_config_access['personalInfo_bloodGroup']['masterPropName'] || 'bloodGroupList'] || []"
                              [form_group]="familyDetails_singleForm" form_control="bloodGroup" title_property="title"
                              id_property="id" float_label="always" [data]="familyDetails_singleForm.value.bloodGroup"
                              [label]="field_config_access['personalInfo_bloodGroup']['label'] |translate"
                              [placeholder]="((field_config_access['personalInfo_bloodGroup']['placeholder'])| translate)"
                              [mandatory]="(field_config_access['personalInfo_bloodGroup']['validators'] && field_config_access['personalInfo_bloodGroup']['validators']['mandatory']?true:false)"
                              [disabled]="((field_config_access['personalInfo_bloodGroup']['validators'] && field_config_access['personalInfo_bloodGroup']['validators']['disable'] && field_config_access['personalInfo_bloodGroup']['validators']['disable']!='0')?true:false) ||disabled_fields "
                              [label_overflow]="1">
                            </tm-select>
                          </div>

                          <div class="col-md-2" *ngIf="field_config_access['height']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['height']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="height" type="number"
                                [placeholder]="(field_config_access['height']['placeholder'] | translate)"
                                [readonly]="((field_config_access['height']['validators'] && field_config_access['height']['validators']['disable'] && field_config_access['height']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['height']['validators'] && field_config_access['height']['validators']['minLength'])"
                                [maxlength]="(field_config_access['height']['validators'] && field_config_access['height']['validators']['maxLength'])"
                                [required]="(field_config_access['height']['validators'] && field_config_access['height']['validators']['mandatory']?true:false)"
                                [pattern]="(field_config_access['height']['validators'] &&
                              field_config_access['height']['validators']['finalPattern'])" />
                              <mat-error *ngIf="personal_details_form.get('height').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('height'),field_config_access:field_config_access['height']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-md-2" *ngIf="field_config_access['weight']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['weight']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="weight" type="number"
                                [placeholder]="(field_config_access['weight']['placeholder'] | translate)"
                                [readonly]="((field_config_access['weight']['validators'] && field_config_access['weight']['validators']['disable'] && field_config_access['weight']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['weight']['validators'] && field_config_access['weight']['validators']['minLength'])"
                                [maxlength]="(field_config_access['weight']['validators'] && field_config_access['weight']['validators']['maxLength'])"
                                [required]="(field_config_access['weight']['validators'] && field_config_access['weight']['validators']['mandatory']?true:false)"
                                [pattern]="(field_config_access['weight']['validators'] &&
                              field_config_access['weight']['validators']['finalPattern'])" />
                              <mat-error *ngIf="personal_details_form.get('weight').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('weight'),field_config_access:field_config_access['weight']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['placeOfBirth']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['placeOfBirth']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="placeOfBirth"
                                [placeholder]="(field_config_access['placeOfBirth']['placeholder'] | translate)"
                                [readonly]="((field_config_access['placeOfBirth']['validators'] && field_config_access['placeOfBirth']['validators']['disable'] && field_config_access['placeOfBirth']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['placeOfBirth']['validators'] && field_config_access['placeOfBirth']['validators']['minLength'])"
                                [maxlength]="(field_config_access['placeOfBirth']['validators'] && field_config_access['placeOfBirth']['validators']['maxLength'])"
                                [required]="(field_config_access['placeOfBirth']['validators'] && field_config_access['placeOfBirth']['validators']['mandatory']?true:false)">

                              <mat-error *ngIf="personal_details_form.get('placeOfBirth').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('placeOfBirth'),field_config_access:field_config_access['placeOfBirth']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['bankName']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['bankName']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="bankName"
                                [placeholder]="(field_config_access['bankName']['placeholder'] | translate)"
                                [readonly]="((field_config_access['bankName']['validators'] && field_config_access['bankName']['validators']['disable'] && field_config_access['bankName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['bankName']['validators'] && field_config_access['bankName']['validators']['minLength'])"
                                [maxlength]="(field_config_access['bankName']['validators'] && field_config_access['bankName']['validators']['maxLength'])"
                                [required]="(field_config_access['bankName']['validators'] && field_config_access['bankName']['validators']['mandatory']?true:false)"
                                [pattern]="(field_config_access['bankName']['validators'] &&
                              field_config_access['bankName']['validators']['finalPattern'])" />
                              <mat-error *ngIf="personal_details_form.get('bankName').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('bankName'),field_config_access:field_config_access['bankName']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['bankBranch']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['bankBranch']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="bankBranch"
                                [placeholder]="(field_config_access['bankBranch']['placeholder'] | translate)"
                                [readonly]="((field_config_access['bankBranch']['validators'] && field_config_access['bankBranch']['validators']['disable'] && field_config_access['bankBranch']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['bankBranch']['validators'] && field_config_access['bankBranch']['validators']['minLength'])"
                                [maxlength]="(field_config_access['bankBranch']['validators'] && field_config_access['bankBranch']['validators']['maxLength'])"
                                [required]="(field_config_access['bankBranch']['validators'] && field_config_access['bankBranch']['validators']['mandatory']?true:false)"
                                [pattern]="(field_config_access['bankBranch']['validators'] &&
                              field_config_access['bankBranch']['validators']['finalPattern'])" />
                              <mat-error *ngIf="personal_details_form.get('bankBranch').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('bankBranch'),field_config_access:field_config_access['bankBranch']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['accountNumber']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['accountNumber']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="accountNumber" type="number"
                                [placeholder]="(field_config_access['accountNumber']['placeholder'] | translate)"
                                [readonly]="((field_config_access['accountNumber']['validators'] && field_config_access['accountNumber']['validators']['disable'] && field_config_access['accountNumber']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['accountNumber']['validators'] && field_config_access['accountNumber']['validators']['minLength'])"
                                [maxlength]="(field_config_access['accountNumber']['validators'] && field_config_access['accountNumber']['validators']['maxLength'])"
                                [required]="(field_config_access['accountNumber']['validators'] && field_config_access['accountNumber']['validators']['mandatory']?true:false)"
                                [pattern]="(field_config_access['accountNumber']['validators'] &&
                              field_config_access['accountNumber']['validators']['finalPattern'])" />
                              <mat-error *ngIf="personal_details_form.get('accountNumber').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('accountNumber'),field_config_access:field_config_access['accountNumber']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['emergencyContactPerson']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['emergencyContactPerson']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="emergencyContactPerson"
                                [placeholder]="(field_config_access['emergencyContactPerson']['placeholder'] | translate)"
                                [readonly]="((field_config_access['emergencyContactPerson']['validators'] && field_config_access['emergencyContactPerson']['validators']['disable'] && field_config_access['emergencyContactPerson']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [minlength]="(field_config_access['emergencyContactPerson']['validators'] && field_config_access['emergencyContactPerson']['validators']['minLength'])"
                                [maxlength]="(field_config_access['emergencyContactPerson']['validators'] && field_config_access['emergencyContactPerson']['validators']['maxLength'])"
                                [required]="(field_config_access['emergencyContactPerson']['validators'] && field_config_access['emergencyContactPerson']['validators']['mandatory']?true:false)"
                                [pattern]="(field_config_access['emergencyContactPerson']['validators'] &&
                              field_config_access['emergencyContactPerson']['validators']['finalPattern'])" />
                              <mat-error *ngIf="personal_details_form.get('emergencyContactPerson').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('emergencyContactPerson'),field_config_access:field_config_access['emergencyContactPerson']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-md-4"
                            *ngIf="field_config_access['emergencyContactIsd'] && field_config_access['emergencyContactNumber']">
                            <div class="prefix-control" style="width: 35%;">
                              <tm-select
                                [options]="masters[field_config_access['emergencyContactIsd']['masterPropName'] || 'isdCountryList'] || []"
                                [form_group]="personal_details_form" form_control="emergencyContactIsd"
                                title_property="title" id_property="id" float_label="always"
                                [data]="personal_details_form.value.emergencyContactIsd" [label_overflow]="1"
                                [label]="field_config_access['emergencyContactIsd']['label'] |translate"
                                [placeholder]="((field_config_access['emergencyContactIsd']['placeholder'])| translate)"
                                [mandatory]="(field_config_access['emergencyContactIsd']['validators'] && field_config_access['emergencyContactIsd']['validators']['mandatory']?true:false)"
                                [disabled]="((field_config_access['emergencyContactIsd']['validators'] && field_config_access['emergencyContactIsd']['validators']['disable'] && field_config_access['emergencyContactIsd']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                              </tm-select>
                            </div>
                            <div class="main-control" style="width: 65%;">
                              <app-phone-number
                                [options]="masters[field_config_access['emergencyContactIsd']['masterPropName'] || 'isdCountryList'] || []"
                                [options_data]="personal_details_form.value.emergencyContactIsd"
                                [form]="personal_details_form" controlName="emergencyContactNumber"
                                [data]="personal_details_form.controls['emergencyContactNumber'].value"
                                [disabledDial]="1" [hide_label]="1"
                                [label]="field_config_access['emergencyContactNumber']['label'] |translate"
                                [placeholder]="((field_config_access['emergencyContactNumber']['placeholder'])| translate)"
                                [required]="(field_config_access['emergencyContactNumber']['validators'] && field_config_access['emergencyContactNumber']['validators']['mandatory']?true:false)"
                                [readonly]="((field_config_access['emergencyContactNumber']['validators'] && field_config_access['emergencyContactNumber']['validators']['disable'] && field_config_access['emergencyContactNumber']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                                [pattern_desc]="(field_config_access['emergencyContactNumber']['validators'] &&
                                field_config_access['emergencyContactNumber']['validators']['finalPattern']) ||
                                '^[0-9]*$'"
                                >
                              </app-phone-number>
                            </div>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['emergencyContactEmailId']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['emergencyContactEmailId']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="emergencyContactEmailId" name="emergencyContactEmailId"
                                [placeholder]="((field_config_access['emergencyContactEmailId']['placeholder'])| translate)"
                                [required]="(field_config_access['emergencyContactEmailId']['validators'] && field_config_access['emergencyContactEmailId']['validators']['mandatory']?true:false)"
                                [minlength]="(field_config_access['emergencyContactEmailId']['validators'] && field_config_access['emergencyContactEmailId']['validators']['minLength'])"
                                [maxlength]="(field_config_access['emergencyContactEmailId']['validators'] && field_config_access['emergencyContactEmailId']['validators']['maxLength'])"
                                [readonly]="((field_config_access['emergencyContactEmailId']['validators'] && field_config_access['emergencyContactEmailId']['validators']['disable'] && field_config_access['emergencyContactEmailId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [pattern]="(field_config_access['emergencyContactEmailId']['validators'] &&
                              field_config_access['emergencyContactEmailId']['validators']['finalPattern']) " />

                              <mat-error *ngIf="personal_details_form.get('emergencyContactEmailId').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:personal_details_form.get('emergencyContactEmailId'),field_config_access:field_config_access['emergencyContactEmailId']}">
                                </ng-container>
                              </mat-error>

                            </mat-form-field>
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                </div>
              </form>
            </ng-container>

            <ng-container *ngIf="section.id == 2">
              <form [formGroup]="education_form">
                <div class="row">
                  <div class="col-md-12">
                    <mat-accordion class="example-headers-align" multi>
                      <mat-expansion-panel *ngIf="field_config_access['educations']"
                        [disabled]="((field_config_access['educations']['validators'] && field_config_access['educations']['validators']['disable'] && field_config_access['educations']['validators']['disable']!='0')?true:false)">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{ field_config_access['educations']['label'] | translate}}
                          </mat-panel-title>
                          <mat-panel-description>


                          </mat-panel-description>
                        </mat-expansion-panel-header>

                        <form [formGroup]="edu_info">
                          <div class="row">
                            <div class="col-md-3" *ngIf="field_config_access['educationType']">
                              <tm-select
                                [options]="masters[field_config_access['educationType']['masterPropName'] || 'eduTypeList'] || []"
                                [form_group]="edu_info" form_control="educationType" title_property="title"
                                id_property="id" float_label="always" [data]="edu_info.value.educationType"
                                [label]="field_config_access['educationType']['label'] |translate"
                                [placeholder]="((field_config_access['educationType']['placeholder'])| translate)"
                                [mandatory]="(field_config_access['educationType']['validators'] && field_config_access['educationType']['validators']['mandatory']?true:false)"
                                [disabled]="((field_config_access['educationType']['validators'] && field_config_access['educationType']['validators']['disable'] && field_config_access['educationType']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [label_overflow]="1">
                              </tm-select>
                            </div>

                            <div class="col-md-3" *ngIf="field_config_access['educationCode']">
                              <tm-select
                                [options]="masters[field_config_access['educationCode']['masterPropName'] || 'educationList'] || []"
                                [form_group]="edu_info" form_control="educationCode" title_property="title"
                                id_property="id" float_label="always" [data]="edu_info.value.educationCode"
                                [label]="field_config_access['educationCode']['label'] |translate"
                                [placeholder]="((field_config_access['educationCode']['placeholder'])| translate)"
                                [mandatory]="(field_config_access['educationCode']['validators'] && field_config_access['educationCode']['validators']['mandatory']?true:false)"
                                [disabled]="((field_config_access['educationCode']['validators'] && field_config_access['educationCode']['validators']['disable'] && field_config_access['educationCode']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [label_overflow]="1">
                              </tm-select>
                            </div>

                            <div class="col-md-3" *ngIf="field_config_access['specializationCode']">
                              <tm-select
                                [options]="masters[field_config_access['specializationCode']['masterPropName'] || 'specializationList'] || []"
                                [form_group]="edu_info" form_control="specializationCode" title_property="title"
                                id_property="id" float_label="always" [data]="edu_info.value.specializationCode"
                                [label]="field_config_access['specializationCode']['label'] |translate"
                                [placeholder]="((field_config_access['specializationCode']['placeholder'])| translate)"
                                [mandatory]="(field_config_access['specializationCode']['validators'] && field_config_access['specializationCode']['validators']['mandatory']?true:false)"
                                [disabled]="((field_config_access['specializationCode']['validators'] && field_config_access['specializationCode']['validators']['disable'] && field_config_access['specializationCode']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [label_overflow]="1">
                              </tm-select>
                            </div>

                            <div class="col-md-3" *ngIf="field_config_access['passingMN']">
                              <tm-month-year [form]="edu_info" [controlName]="'passingMN'" [float_label]="'always'"
                                [value]="edu_info.value.passingMN"
                                [label]="field_config_access['passingMN']['label'] |translate"
                                [placeholder]="((field_config_access['passingMN']['placeholder'])| translate)"
                                [required]="(field_config_access['passingMN']['validators'] && field_config_access['passingMN']['validators']['mandatory']?true:false)"
                                [disabled]="((field_config_access['passingMN']['validators'] && field_config_access['passingMN']['validators']['disable'] && field_config_access['passingMN']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                              </tm-month-year>
                            </div>



                            <div class="col-md-3" *ngIf="field_config_access['universityCode']">
                              <tm-select
                                [options]="masters[field_config_access['universityCode']['masterPropName'] || 'universityList'] || []"
                                [form_group]="edu_info" form_control="universityCode" title_property="title"
                                id_property="id" float_label="always" [data]="edu_info.value.universityCode"
                                [label]="field_config_access['universityCode']['label'] |translate"
                                [placeholder]="((field_config_access['universityCode']['placeholder'])| translate)"
                                [mandatory]="(field_config_access['universityCode']['validators'] && field_config_access['universityCode']['validators']['mandatory']?true:false)"
                                [disabled]="((field_config_access['universityCode']['validators'] && field_config_access['universityCode']['validators']['disable'] && field_config_access['universityCode']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [label_overflow]="1">
                              </tm-select>
                            </div>

                            <div class="col-md-3" *ngIf="field_config_access['collegeCode']">
                              <tm-select
                                [options]="masters[field_config_access['collegeCode']['masterPropName'] || 'collegeList'] || []"
                                [form_group]="edu_info" form_control="collegeCode" title_property="title"
                                id_property="id" float_label="always" [data]="edu_info.value.collegeCode"
                                [label]="field_config_access['collegeCode']['label'] |translate"
                                [placeholder]="((field_config_access['collegeCode']['placeholder'])| translate)"
                                [mandatory]="(field_config_access['collegeCode']['validators'] && field_config_access['collegeCode']['validators']['mandatory']?true:false)"
                                [disabled]="((field_config_access['collegeCode']['validators'] && field_config_access['collegeCode']['validators']['disable'] && field_config_access['collegeCode']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [label_overflow]="1">
                              </tm-select>
                            </div>

                            <div class="col-md-3" *ngIf="field_config_access['percentage']">
                              <div class="prefix-control" style="width: 60%;">
                                <mat-form-field floatLabel="always">
                                  <mat-label style="text-align: right;">
                                    {{field_config_access['percentage']['label'] |translate}}
                                  </mat-label>
                                  <input min="1" max="100" type="number" class="w-93" matInput
                                    [required]="field_config_access['percentage']['validators'] && field_config_access['percentage']['validators']['mandatory']?true:false"
                                    [placeholder]="field_config_access['percentage']['placeholder'] |translate"
                                    formControlName="percentage" [min]="1" [max]="100">

                                  <mat-error *ngIf="edu_info.get('percentage').invalid">
                                    <ng-container
                                      *ngTemplateOutlet="error_message; context: {form_control:edu_info.get('percentage'),field_config_access:field_config_access['percentage']}">
                                    </ng-container>
                                  </mat-error>

                                </mat-form-field>
                              </div>
                              <div class="main-control" style="width: 40%;">
                                <tm-select [form_group]="edu_info" [form_control]="'percentageType'" [hide_label]="1"
                                  [options]="masters['educationScoreTypeList'] || []"
                                  [label]="field_config_access['percentageType']['label'] |translate" [mandatory]="1"
                                  [data]="edu_info.value.percentageType"
                                  [placeholder]="field_config_access['percentageType']['placeholder'] |translate">
                                </tm-select>
                              </div>

                            </div>

                            <div class="col-md-3" *ngIf="field_config_access['mediumOfInst']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['mediumOfInst']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="mediumOfInst" name="mediumOfInst"
                                  [placeholder]="((field_config_access['mediumOfInst']['placeholder'])| translate)"
                                  [required]="(field_config_access['mediumOfInst']['validators'] && field_config_access['mediumOfInst']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['mediumOfInst']['validators'] && field_config_access['mediumOfInst']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['mediumOfInst']['validators'] && field_config_access['mediumOfInst']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['mediumOfInst']['validators'] && field_config_access['mediumOfInst']['validators']['disable'] && field_config_access['mediumOfInst']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['mediumOfInst']['validators'] &&
                          field_config_access['mediumOfInst']['validators']['finalPattern'])" />

                                <mat-error *ngIf="edu_info.get('mediumOfInst').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:edu_info.get('mediumOfInst'),field_config_access:field_config_access['mediumOfInst']}">
                                  </ng-container>
                                </mat-error>


                              </mat-form-field>
                            </div>



                            <div class="col-md-12 text-right">
                              <button (click)="addToTable(education_form,'educations',edu_info)"
                                class="btn btn-sm mat-mt js-btn-save">
                                <i class="fa fa-plus-square mx-1"></i>
                                {{'BTN.add'|translate}}
                              </button>
                            </div>


                            <div class="col-md-12 table-responsive tm-data-table">
                              <table class="table table-striped" *ngIf="education_form.get('educations').value">
                                <thead>
                                  <tr>
                                    <th>
                                      {{field_config_access['educationType']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['educationCode']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['specializationCode']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['passingMN']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['universityCode']['label'] |translate}}
                                    </th>

                                    <th>
                                      {{field_config_access['collegeCode']['label'] |translate}}
                                    </th>
                                    <th>{{field_config_access['percentage']['label'] |translate}}</th>
                                    <th>
                                      {{field_config_access['mediumOfInst']['label'] |translate}}
                                    </th>

                                    <th class="text-center">
                                      Action
                                    </th>
                                  </tr>

                                </thead>
                                <tbody>
                                  <tr *ngFor="let item of education_form.get('educations').value  || [];let i = index">
                                    <td>{{item.educationType | DynamicPipe
                                      : masters[field_config_access['educationType']['masterPropName'] || 'eduTypeList']
                                      || []:'id':'title' }}
                                    </td>
                                    <td>
                                      {{ item.educationCode | DynamicPipe
                                      : masters[field_config_access['educationCode']['masterPropName'] ||
                                      'educationList'] || []:'id':'title' }}
                                    </td>



                                    <td>
                                      {{ item.specializationCode | DynamicPipe
                                      : masters[field_config_access['specializationCode']['masterPropName'] ||
                                      'specializationList'] || []:'id':'title' }}
                                    </td>


                                    <td>
                                      {{ item.passingMN |UtcToLocalTime | date: 'MMM-yyyy' }}
                                    </td>



                                    <td>
                                      {{ item.universityCode | DynamicPipe
                                      : masters[field_config_access['universityCode']['masterPropName'] ||
                                      'universityList'] || []:'id':'title' }}
                                    </td>

                                    <td>
                                      {{ item.collegeCode | DynamicPipe
                                      : masters[field_config_access['collegeCode']['masterPropName'] ||
                                      'collegeList'] || []:'id':'title' }}
                                    </td>
                                    <td>
                                      {{ item.percentage}} {{ item.percentageType | DynamicPipe
                                      : masters['educationScoreTypeList'] || []:'id':'title'}}
                                    </td>
                                    <td>
                                      {{ item.mediumOfInst}}
                                    </td>

                                    <td class="text-center">
                                      <button class="btn btn-sm btn-default mx-1 "
                                        (click)="editTableItem(i,education_form,'educations',edu_info)">
                                        <i class="fa fa-pencil mx-1"></i>
                                        {{'BTN.edit'|translate}}
                                      </button>
                                      <button class="btn btn-sm btn-default mx-1 "
                                        (click)="deleteTableItem(i,education_form,'educations',edu_info)">
                                        <i class="fa fa-trash orange mx-1"></i>
                                        {{'BTN.delete'|translate}}
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </form>
                      </mat-expansion-panel>

                      <mat-expansion-panel *ngIf="field_config_access['achievements']"
                        [disabled]="((field_config_access['achievements']['validators'] && field_config_access['achievements']['validators']['disable'] && field_config_access['achievements']['validators']['disable']!='0')?true:false)">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{ field_config_access['achievements']['label'] | translate}}
                          </mat-panel-title>
                          <mat-panel-description>


                          </mat-panel-description>
                        </mat-expansion-panel-header>

                        <form [formGroup]="achievements">
                          <div class="row">
                            <div class="col-md-5" *ngIf="field_config_access['title']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['title']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="title" name="title"
                                  [placeholder]="((field_config_access['title']['placeholder'])| translate)"
                                  [required]="(field_config_access['title']['validators'] && field_config_access['title']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['title']['validators'] && field_config_access['title']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['title']['validators'] && field_config_access['title']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['title']['validators'] && field_config_access['title']['validators']['disable'] && field_config_access['title']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['title']['validators'] &&
                    field_config_access['title']['validators']['finalPattern'])" />

                                <mat-error *ngIf="achievements.get('title').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:achievements.get('title'),field_config_access:field_config_access['title']}">
                                  </ng-container>
                                </mat-error>
                              </mat-form-field>
                            </div>


                            <div class="col-md-5" *ngIf="field_config_access['achievementsAttachments']">
                              <tm-files-v2 [form_group]="achievements.get('achievementsAttachments')"
                                [form_control]="'attachments'"
                                [result]="(achievements.get('achievementsAttachments')).value"
                                [label]="field_config_access['achievementsAttachments']['label'] " [multiple]="1"
                                [disabled]="((field_config_access['achievementsAttachments']['validators'] && field_config_access['achievementsAttachments']['validators']['disable'] && field_config_access['achievementsAttachments']['validators']['disable']!='0')?true:false) ||disabled_fields"
                                [required]="(field_config_access['achievementsAttachments']['validators'] && field_config_access['achievementsAttachments']['validators']['mandatory']?true:false)">
                              </tm-files-v2>
                            </div>


                            <div class="col-md-12 text-right">
                              <button (click)="addToTable(education_form,'achievements',achievements)"
                                class="btn btn-sm mat-mt js-btn-save">
                                <i class="fa fa-plus-square mx-1"></i>
                                {{'BTN.add'|translate}}
                              </button>
                            </div>


                            <div class="col-md-12 table-responsive tm-data-table">
                              <table class="table table-striped " *ngIf="education_form.get('achievements').value">
                                <thead>
                                  <tr>

                                    <th>
                                      {{field_config_access['title']['label'] |translate}}
                                    </th>

                                    <th *ngIf="field_config_access['achievementsAttachments']">
                                      {{ field_config_access['achievementsAttachments']['label'] }}
                                    </th>

                                    <th class="text-center">
                                      Action
                                    </th>
                                  </tr>

                                </thead>
                                <tbody>
                                  <tr
                                    *ngFor="let item of education_form.get('achievements').value  || [];let i = index">

                                    <td>
                                      {{ item.title}}
                                    </td>

                                    <td (click)="viewDocument(item.attachments,[])"
                                      *ngIf="field_config_access['achievementsAttachments']">
                                      View Documents
                                    </td>

                                    <td class="text-center">
                                      <button class="btn btn-sm btn-default mx-1 "
                                        (click)="editTableItem(i,education_form,'achievements',achievements)">
                                        <i class="fa fa-pencil mx-1"></i>
                                        {{'BTN.edit'|translate}}
                                      </button>
                                      <button class="btn btn-sm btn-default mx-1 "
                                        (click)="deleteTableItem(i,education_form,'achievements',achievements)">
                                        <i class="fa fa-trash orange mx-1"></i>
                                        {{'BTN.delete'|translate}}
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                        </form>

                      </mat-expansion-panel>

                      <mat-expansion-panel *ngIf="field_config_access['profQualifications']"
                        [disabled]="((field_config_access['profQualifications']['validators'] && field_config_access['profQualifications']['validators']['disable'] && field_config_access['profQualifications']['validators']['disable']!='0')?true:false)">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{ field_config_access['profQualifications']['label'] | translate}}
                          </mat-panel-title>
                          <mat-panel-description>


                          </mat-panel-description>
                        </mat-expansion-panel-header>

                        <form [formGroup]="proff_qualification">
                          <div class="row">
                            <div class="col-md-3" *ngIf="field_config_access['courseTypeId']">
                              <tm-select
                                [options]="masters[field_config_access['courseTypeId']['masterPropName'] || 'courseTypeList'] || []"
                                [form_group]="proff_qualification" form_control="courseTypeId" title_property="title"
                                id_property="id" float_label="always" [data]="proff_qualification.value.courseTypeId"
                                [label]="field_config_access['courseTypeId']['label'] |translate"
                                [placeholder]="((field_config_access['courseTypeId']['placeholder'])| translate)"
                                [mandatory]="(field_config_access['courseTypeId']['validators'] && field_config_access['courseTypeId']['validators']['mandatory']?true:false)"
                                [disabled]="((field_config_access['courseTypeId']['validators'] && field_config_access['courseTypeId']['validators']['disable'] && field_config_access['courseTypeId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [label_overflow]="1">
                              </tm-select>
                            </div>

                            <div class="col-md-3" *ngIf="field_config_access['course']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['course']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="course" name="course"
                                  [placeholder]="((field_config_access['course']['placeholder'])| translate)"
                                  [required]="(field_config_access['course']['validators'] && field_config_access['course']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['course']['validators'] && field_config_access['course']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['course']['validators'] && field_config_access['course']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['course']['validators'] && field_config_access['course']['validators']['disable'] && field_config_access['course']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['course']['validators'] &&
                                                    field_config_access['course']['validators']['finalPattern'])" />

                                <mat-error *ngIf="proff_qualification.get('course').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:proff_qualification.get('course'),field_config_access:field_config_access['course']}">
                                  </ng-container>
                                </mat-error>


                              </mat-form-field>
                            </div>


                            <div class="col-md-3" *ngIf="field_config_access['instituteName']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['instituteName']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="instituteName" name="instituteName"
                                  [placeholder]="((field_config_access['instituteName']['placeholder'])| translate)"
                                  [required]="(field_config_access['instituteName']['validators'] && field_config_access['instituteName']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['instituteName']['validators'] && field_config_access['instituteName']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['instituteName']['validators'] && field_config_access['instituteName']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['instituteName']['validators'] && field_config_access['instituteName']['validators']['disable'] && field_config_access['instituteName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['instituteName']['validators'] &&
                                                    field_config_access['instituteName']['validators']['finalPattern'])" />

                                <mat-error *ngIf="proff_qualification.get('instituteName').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:proff_qualification.get('instituteName'),field_config_access:field_config_access['instituteName']}">
                                  </ng-container>
                                </mat-error>
                              </mat-form-field>
                            </div>

                            <div class="col-md-3" *ngIf="field_config_access['grade']">
                              <tm-select
                                [options]="masters[field_config_access['grade']['masterPropName'] || 'gradeList'] || []"
                                [form_group]="proff_qualification" form_control="grade" title_property="title"
                                id_property="id" float_label="always" [data]="proff_qualification.value.grade"
                                [label]="field_config_access['grade']['label'] |translate"
                                [placeholder]="((field_config_access['grade']['placeholder'])| translate)"
                                [mandatory]="(field_config_access['grade']['validators'] && field_config_access['grade']['validators']['mandatory']?true:false)"
                                [disabled]="((field_config_access['grade']['validators'] && field_config_access['grade']['validators']['disable'] && field_config_access['grade']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [label_overflow]="1">
                              </tm-select>
                            </div>

                            <div class="col-md-2" *ngIf="field_config_access['yearFrom']">
                              <tm-month-year [form]="proff_qualification" [controlName]="'yearFrom'"
                                [float_label]="'always'" [value]="proff_qualification.value.yearFrom"
                                [label]="field_config_access['yearFrom']['label'] |translate"
                                [placeholder]="((field_config_access['yearFrom']['placeholder'])| translate)"
                                [required]="(field_config_access['yearFrom']['validators'] && field_config_access['yearFrom']['validators']['mandatory']?true:false)"
                                [disabled]="((field_config_access['yearFrom']['validators'] && field_config_access['yearFrom']['validators']['disable'] && field_config_access['yearFrom']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                              </tm-month-year>
                            </div>

                            <div class="col-md-2" *ngIf="field_config_access['yearTo']">
                              <tm-month-year [form]="proff_qualification" [controlName]="'yearTo'"
                                [float_label]="'always'" [value]="proff_qualification.value.yearTo"
                                [label]="field_config_access['yearTo']['label'] |translate"
                                [placeholder]="((field_config_access['yearTo']['placeholder'])| translate)"
                                [required]="(field_config_access['yearTo']['validators'] && field_config_access['yearTo']['validators']['mandatory']?true:false)"
                                [disabled]="((field_config_access['yearTo']['validators'] && field_config_access['yearTo']['validators']['disable'] && field_config_access['yearTo']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                              </tm-month-year>
                            </div>

                            <div class="col-md-4" *ngIf="field_config_access['address']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['address']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="address" name="address"
                                  [placeholder]="((field_config_access['address']['placeholder'])| translate)"
                                  [required]="(field_config_access['address']['validators'] && field_config_access['address']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['address']['validators'] && field_config_access['address']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['address']['validators'] && field_config_access['address']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['address']['validators'] && field_config_access['address']['validators']['disable'] && field_config_access['address']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['address']['validators'] &&
                                                  field_config_access['address']['validators']['finalPattern'])" />

                                <mat-error *ngIf="proff_qualification.get('address').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:proff_qualification.get('address'),field_config_access:field_config_access['address']}">
                                  </ng-container>
                                </mat-error>
                              </mat-form-field>
                            </div>


                            <div class="col-md-12 text-right">
                              <button (click)="addToTable(education_form,'profQualifications',proff_qualification)"
                                class="btn btn-sm mat-mt js-btn-save">
                                <i class="fa fa-plus-square mx-1"></i>
                                {{'BTN.add'|translate}}
                              </button>
                            </div>


                            <div class="col-md-12 table-responsive tm-data-table">
                              <table class="table table-striped "
                                *ngIf="education_form.get('profQualifications').value">
                                <thead>
                                  <tr>
                                    <th>
                                      {{field_config_access['courseTypeId']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['course']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['instituteName']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['grade']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['yearFrom']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['yearTo']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['address']['label'] |translate}}
                                    </th>
                                    <th class="text-center">
                                      Action
                                    </th>
                                  </tr>

                                </thead>
                                <tbody>
                                  <tr
                                    *ngFor="let item of education_form.get('profQualifications').value  || [];let i = index">
                                    <td>{{item.courseTypeId | DynamicPipe
                                      : masters[field_config_access['courseTypeId']['masterPropName'] ||
                                      'courseTypeList']
                                      || []:'id':'title' }}
                                    </td>

                                    <td>
                                      {{ item.course}}
                                    </td>

                                    <td>
                                      {{ item.instituteName}}
                                    </td>
                                    <td>
                                      {{ item.grade | DynamicPipe
                                      : masters[field_config_access['grade']['masterPropName'] ||
                                      'gradeList'] || []:'id':'title' }}
                                    </td>
                                    <td>
                                      {{ item.yearFrom |UtcToLocalTime | date: 'MMM-yyyy' }}
                                    </td>

                                    <td>
                                      {{ item.yearTo |UtcToLocalTime | date: 'MMM-yyyy'}}
                                    </td>
                                    <td>
                                      {{ item.address }}
                                    </td>

                                    <td class="text-center">
                                      <button class="btn btn-sm btn-default mx-1 "
                                        (click)="editTableItem(i,education_form,'profQualifications',proff_qualification)">
                                        <i class="fa fa-pencil mx-1"></i>
                                        {{'BTN.edit'|translate}}
                                      </button>
                                      <button class="btn btn-sm btn-default mx-1 "
                                        (click)="deleteTableItem(i, education_form,'profQualifications',proff_qualification)">
                                        <i class="fa fa-trash orange mx-1"></i>
                                        {{'BTN.delete'|translate}}
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </form>

                      </mat-expansion-panel>
                    </mat-accordion>

                  </div>
                </div>
              </form>
            </ng-container>

            <ng-container *ngIf="section.id == 3">
              <form [formGroup]="familyDetails">
                <mat-accordion class="example-headers-align" multi>

                  <mat-expansion-panel #relativePanel (expandedChange)="relativePanelClosed($event,relativePanel)"
                    [disabled]="((field_config_access['anyRelativeWorkingInCompany']['validators'] && field_config_access['anyRelativeWorkingInCompany']['validators']['disable'] && field_config_access['anyRelativeWorkingInCompany']['validators']['disable']!='0')?true:false)">
                    <mat-expansion-panel-header>
                      <mat-panel-title> {{field_config_access['anyRelativeWorkingInCompany']['label']}}
                      </mat-panel-title>
                      <mat-panel-description>
                        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                          formControlName="anyRelativeWorkingInCompany">
                          <mat-radio-button class="example-radio-button"
                            *ngFor="let item of masters[field_config_access['anyRelativeWorkingInCompany']['masterPropName'] || 'yesNoList'] || []"
                            [value]="item.id">
                            {{item.title}}
                          </mat-radio-button>
                        </mat-radio-group>

                      </mat-panel-description>
                    </mat-expansion-panel-header>

                    <div class="row">

                      <div class="col-md-4" *ngIf="field_config_access['workingRelativeName']">
                        <mat-form-field floatLabel="always">
                          <mat-label>
                            {{field_config_access['workingRelativeName']['label'] |translate}}
                          </mat-label>
                          <input matInput formControlName="workingRelativeName" name="workingRelativeName"
                            [placeholder]="((field_config_access['workingRelativeName']['placeholder'])| translate)"
                            [required]="(field_config_access['workingRelativeName']['validators'] && field_config_access['workingRelativeName']['validators']['mandatory']&&familyDetails.get('anyRelativeWorkingInCompany').value?true:false)"
                            [minlength]="(field_config_access['workingRelativeName']['validators'] && field_config_access['workingRelativeName']['validators']['minLength'])"
                            [maxlength]="(field_config_access['workingRelativeName']['validators'] && field_config_access['workingRelativeName']['validators']['maxLength'])"
                            [readonly]="((field_config_access['workingRelativeName']['validators'] && field_config_access['workingRelativeName']['validators']['disable'] && field_config_access['workingRelativeName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                            [pattern]="(field_config_access['workingRelativeName']['validators'] && field_config_access['workingRelativeName']['validators']['finalPattern'])" />

                          <mat-error *ngIf="familyDetails.get('workingRelativeName').invalid">
                            <ng-container
                              *ngTemplateOutlet="error_message; context: {form_control:familyDetails.get('workingRelativeName'),field_config_access:field_config_access['workingRelativeName']}">
                            </ng-container>
                          </mat-error>


                        </mat-form-field>
                      </div>

                      <div class="col-md-4" *ngIf="field_config_access['workingRelativeDepartment']">
                        <mat-form-field floatLabel="always">
                          <mat-label>
                            {{field_config_access['workingRelativeDepartment']['label'] |translate}}
                          </mat-label>
                          <input matInput formControlName="workingRelativeDepartment" name="workingRelativeDepartment"
                            [placeholder]="((field_config_access['workingRelativeDepartment']['placeholder'])| translate)"
                            [required]="(field_config_access['workingRelativeDepartment']['validators'] && field_config_access['workingRelativeDepartment']['validators']['mandatory']&&familyDetails.get('anyRelativeWorkingInCompany').value?true:false)"
                            [minlength]="(field_config_access['workingRelativeDepartment']['validators'] && field_config_access['workingRelativeDepartment']['validators']['minLength'])"
                            [maxlength]="(field_config_access['workingRelativeDepartment']['validators'] && field_config_access['workingRelativeDepartment']['validators']['maxLength'])"
                            [readonly]="((field_config_access['workingRelativeDepartment']['validators'] && field_config_access['workingRelativeDepartment']['validators']['disable'] && field_config_access['workingRelativeDepartment']['validators']['disable']!='0')?true:false) ||disabled_fields "
                            [pattern]="(field_config_access['workingRelativeDepartment']['validators'] && field_config_access['workingRelativeDepartment']['validators']['finalPattern'])" />

                          <mat-error *ngIf="familyDetails.get('workingRelativeDepartment').invalid">
                            <ng-container
                              *ngTemplateOutlet="error_message; context: {form_control:familyDetails.get('workingRelativeDepartment'),field_config_access:field_config_access['workingRelativeDepartment']}">
                            </ng-container>
                          </mat-error>


                        </mat-form-field>
                      </div>
                    </div>


                  </mat-expansion-panel>
                  <mat-expansion-panel *ngIf="field_config_access['familyDetails']"
                    [disabled]="((field_config_access['familyDetails']['validators'] && field_config_access['familyDetails']['validators']['disable'] && field_config_access['familyDetails']['validators']['disable']!='0')?true:false)">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ field_config_access['familyDetails']['label'] | translate}}
                      </mat-panel-title>
                      <mat-panel-description>


                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <form [formGroup]="familyDetails_singleForm">
                      <div class="row">
                        <div class="col-md-3" *ngIf="field_config_access['relationTypeId']">
                          <tm-select
                            [options]="masters[field_config_access['relationTypeId']['masterPropName'] || 'relationTypeList'] || []"
                            [form_group]="familyDetails_singleForm" form_control="relationTypeId" title_property="title"
                            id_property="id" float_label="always" [data]="familyDetails_singleForm.value.relationTypeId"
                            [label]="field_config_access['relationTypeId']['label'] |translate"
                            [placeholder]="((field_config_access['relationTypeId']['placeholder'])| translate)"
                            [mandatory]="(field_config_access['relationTypeId']['validators'] && field_config_access['relationTypeId']['validators']['mandatory']?true:false)"
                            [disabled]="((field_config_access['relationTypeId']['validators'] && field_config_access['relationTypeId']['validators']['disable'] && field_config_access['relationTypeId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                            [label_overflow]="1">
                          </tm-select>
                        </div>

                        <div class="col-md-3" *ngIf="field_config_access['name']">
                          <mat-form-field floatLabel="always">
                            <mat-label>
                              {{field_config_access['name']['label'] |translate}}
                            </mat-label>
                            <input matInput formControlName="name" name="name"
                              [placeholder]="((field_config_access['name']['placeholder'])| translate)"
                              [required]="(field_config_access['name']['validators'] && field_config_access['name']['validators']['mandatory']?true:false)"
                              [minlength]="(field_config_access['name']['validators'] && field_config_access['name']['validators']['minLength'])"
                              [maxlength]="(field_config_access['name']['validators'] && field_config_access['name']['validators']['maxLength'])"
                              [readonly]="((field_config_access['name']['validators'] && field_config_access['name']['validators']['disable'] && field_config_access['name']['validators']['disable']!='0')?true:false) ||disabled_fields "
                              [pattern]="(field_config_access['name']['validators'] &&
                                            field_config_access['name']['validators']['finalPattern'])" />

                            <mat-error *ngIf="familyDetails_singleForm.get('name').invalid">
                              <ng-container
                                *ngTemplateOutlet="error_message; context: {form_control:familyDetails_singleForm.get('name'),field_config_access:field_config_access['name']}">
                              </ng-container>
                            </mat-error>


                          </mat-form-field>
                        </div>

                        <div class="col-md-3" *ngIf="field_config_access['age']">
                          <mat-form-field floatLabel="always">
                            <mat-label>
                              {{field_config_access['age']['label'] |translate}}
                            </mat-label>
                            <input type="number" matInput formControlName="age" name="age"
                              [placeholder]="((field_config_access['age']['placeholder'])| translate)"
                              [required]="(field_config_access['age']['validators'] && field_config_access['age']['validators']['mandatory']?true:false)"
                              [minlength]="(field_config_access['age']['validators'] && field_config_access['age']['validators']['minLength'])"
                              [maxlength]="(field_config_access['age']['validators'] && field_config_access['age']['validators']['maxLength'])"
                              [readonly]="((field_config_access['age']['validators'] && field_config_access['age']['validators']['disable'] && field_config_access['age']['validators']['disable']!='0')?true:false) ||disabled_fields "
                              [pattern]="(field_config_access['age']['validators'] &&
                                            field_config_access['age']['validators']['finalPattern'])" />

                            <mat-error *ngIf="familyDetails_singleForm.get('age').invalid">
                              <ng-container
                                *ngTemplateOutlet="error_message; context: {form_control:familyDetails_singleForm.get('age'),field_config_access:field_config_access['age']}">
                              </ng-container>
                            </mat-error>
                          </mat-form-field>
                        </div>

                        <div class="col-md-3" *ngIf="field_config_access['qualificationId']">
                          <tm-select
                            [options]="masters[field_config_access['qualificationId']['masterPropName'] || 'educationLevelList'] || []"
                            [form_group]="familyDetails_singleForm" form_control="qualificationId"
                            title_property="title" id_property="id" float_label="always"
                            [data]="familyDetails_singleForm.value.qualificationId"
                            [label]="field_config_access['qualificationId']['label'] |translate"
                            [placeholder]="((field_config_access['qualificationId']['placeholder'])| translate)"
                            [mandatory]="(field_config_access['qualificationId']['validators'] && field_config_access['qualificationId']['validators']['mandatory']?true:false)"
                            [disabled]="((field_config_access['qualificationId']['validators'] && field_config_access['qualificationId']['validators']['disable'] && field_config_access['qualificationId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                            [label_overflow]="1">
                          </tm-select>
                        </div>

                        <div class="col-md-3" *ngIf="field_config_access['companyName']">
                          <mat-form-field floatLabel="always">
                            <mat-label>
                              {{field_config_access['companyName']['label'] |translate}}
                            </mat-label>
                            <input matInput formControlName="companyName" name="companyName"
                              [placeholder]="((field_config_access['companyName']['placeholder'])| translate)"
                              [required]="(field_config_access['companyName']['validators'] && field_config_access['companyName']['validators']['mandatory']?true:false)"
                              [minlength]="(field_config_access['companyName']['validators'] && field_config_access['companyName']['validators']['minLength'])"
                              [maxlength]="(field_config_access['companyName']['validators'] && field_config_access['companyName']['validators']['maxLength'])"
                              [readonly]="((field_config_access['companyName']['validators'] && field_config_access['companyName']['validators']['disable'] && field_config_access['companyName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                              [pattern]="(field_config_access['companyName']['validators'] &&
                                        field_config_access['companyName']['validators']['finalPattern'])" />

                            <mat-error *ngIf="familyDetails_singleForm.get('companyName').invalid">
                              <ng-container
                                *ngTemplateOutlet="error_message; context: {form_control:familyDetails_singleForm.get('companyName'),field_config_access:field_config_access['companyName']}">
                              </ng-container>
                            </mat-error>
                          </mat-form-field>
                        </div>

                        <div class="col-md-3" *ngIf="field_config_access['occupation']">
                          <mat-form-field floatLabel="always">
                            <mat-label>
                              {{field_config_access['occupation']['label'] |translate}}
                            </mat-label>
                            <input matInput formControlName="occupation" name="occupation"
                              [placeholder]="((field_config_access['occupation']['placeholder'])| translate)"
                              [required]="(field_config_access['occupation']['validators'] && field_config_access['occupation']['validators']['mandatory']?true:false)"
                              [minlength]="(field_config_access['occupation']['validators'] && field_config_access['occupation']['validators']['minLength'])"
                              [maxlength]="(field_config_access['occupation']['validators'] && field_config_access['occupation']['validators']['maxLength'])"
                              [readonly]="((field_config_access['occupation']['validators'] && field_config_access['occupation']['validators']['disable'] && field_config_access['occupation']['validators']['disable']!='0')?true:false) ||disabled_fields "
                              [pattern]="(field_config_access['occupation']['validators'] &&
                                          field_config_access['occupation']['validators']['finalPattern'])" />

                            <mat-error *ngIf="familyDetails_singleForm.get('occupation').invalid">
                              <ng-container
                                *ngTemplateOutlet="error_message; context: {form_control:familyDetails_singleForm.get('occupation'),field_config_access:field_config_access['occupation']}">
                              </ng-container>
                            </mat-error>
                          </mat-form-field>
                        </div>

                        <div class="col-md-3" *ngIf="field_config_access['designationId']">
                          <tm-select
                            [options]="masters[field_config_access['designationId']['masterPropName'] || 'jobTitleList'] || []"
                            [form_group]="familyDetails_singleForm" form_control="designationId" title_property="title"
                            id_property="id" float_label="always" [data]="familyDetails_singleForm.value.designationId"
                            [label]="field_config_access['designationId']['label'] |translate"
                            [placeholder]="((field_config_access['designationId']['placeholder'])| translate)"
                            [mandatory]="(field_config_access['designationId']['validators'] && field_config_access['designationId']['validators']['mandatory']?true:false)"
                            [disabled]="((field_config_access['designationId']['validators'] && field_config_access['designationId']['validators']['disable'] && field_config_access['designationId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                            [label_overflow]="1">
                          </tm-select>
                        </div>

                        <div class="col-md-3" *ngIf="field_config_access['fdDob']">
                          <tm-date-picker [form]="familyDetails_singleForm" [controlName]="'dob'"
                            [placeholder]="((field_config_access['fdDob']['placeholder']) | translate) "
                            [label]="field_config_access['fdDob']['label'] |translate"
                            [value]="familyDetails_singleForm.value.dob"
                            [minValue]="(field_config_access['fdDob']['validators'] && field_config_access['fdDob']['validators']['minValue'])"
                            [maxValue]="(field_config_access['fdDob']['validators'] && field_config_access['fdDob']['validators']['maxValue'])">
                            [required]="(field_config_access['fdDob']['validators'] &&
                            field_config_access['fdDob']['validators']['mandatory']?true:false)"
                            [disabled]="((field_config_access['fdDob']['validators'] &&
                            field_config_access['fdDob']['validators']['disable'])?true:false)
                            ||disabled_fields "

                          </tm-date-picker>
                        </div>
                        <div class="col-md-3" *ngIf="field_config_access['bloodGroup']">
                          <tm-select
                            [options]="masters[field_config_access['bloodGroup']['masterPropName'] || 'bloodGroupList'] || []"
                            [form_group]="familyDetails_singleForm" form_control="bloodGroup" title_property="title"
                            id_property="id" float_label="always" [data]="familyDetails_singleForm.value.bloodGroup"
                            [label]="field_config_access['bloodGroup']['label'] |translate"
                            [placeholder]="((field_config_access['bloodGroup']['placeholder'])| translate)"
                            [mandatory]="(field_config_access['bloodGroup']['validators'] && field_config_access['bloodGroup']['validators']['mandatory']?true:false)"
                            [disabled]="((field_config_access['bloodGroup']['validators'] && field_config_access['bloodGroup']['validators']['disable'] && field_config_access['bloodGroup']['validators']['disable']!='0')?true:false) ||disabled_fields "
                            [label_overflow]="1">
                          </tm-select>
                        </div>

                        <div class="col-md-3" *ngIf="field_config_access['dependent']">
                          <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                            formControlName="dependent">
                            <mat-radio-button class="example-radio-button"
                              *ngFor="let item of masters[field_config_access['dependent']['masterPropName'] || 'yesNoList'] || []"
                              [value]="item.id">
                              {{item.title}}
                            </mat-radio-button>
                          </mat-radio-group>
                        </div>

                        <div class="col-md-12 text-right">
                          <button (click)="addToTable(familyDetails,'familyDetails',familyDetails_singleForm)"
                            class="btn btn-sm mat-mt js-btn-save">
                            <i class="fa fa-plus-square mx-1"></i>
                            {{'BTN.add'|translate}}
                          </button>
                        </div>

                        <div class="col-md-12 table-responsive tm-data-table">
                          <table class="table table-striped " *ngIf="familyDetails.get('familyDetails').value">
                            <thead>
                              <tr>
                                <th>
                                  {{field_config_access['relationTypeId']['label'] |translate}}
                                </th>
                                <th>
                                  {{field_config_access['name']['label'] |translate}}
                                </th>
                                <th>
                                  {{field_config_access['age']['label'] |translate}}
                                </th>
                                <th>
                                  {{field_config_access['qualificationId']['label'] |translate}}
                                </th>
                                <th>
                                  {{field_config_access['companyName']['label'] |translate}}
                                </th>
                                <th>
                                  {{field_config_access['occupation']['label'] |translate}}
                                </th>
                                <th>
                                  {{field_config_access['designationId']['label'] |translate}}
                                </th>

                                <th class="text-center">
                                  Action
                                </th>
                              </tr>

                            </thead>
                            <tbody>
                              <tr *ngFor="let item of familyDetails.get('familyDetails').value  || [];let i = index">
                                <td>{{
                                  item.relationTypeId | DynamicPipe :
                                  masters[field_config_access['relationTypeId']['masterPropName'] ||
                                  'relationTypeList']
                                  || []:'id':'title' }}
                                </td>

                                <td>
                                  {{ item.name}}
                                </td>

                                <td>
                                  {{ item.age}}
                                </td>
                                <td>
                                  {{ item.qualificationId | DynamicPipe
                                  : masters[field_config_access['qualificationId']['masterPropName'] ||
                                  'educationLevelList'] || []:'id':'title' }}
                                </td>
                                <td>
                                  {{ item.companyName }}
                                </td>
                                <td>
                                  {{ item.occupation }}
                                </td>
                                <td>
                                  {{ item.designationId | DynamicPipe
                                  : masters[field_config_access['designationId']['masterPropName'] ||
                                  'jobTitleList'] || []:'id':'title' }}
                                </td>
                                <td>
                                  <button class="btn btn-sm btn-default mx-1 "
                                    (click)="editTableItem(i, familyDetails,'familyDetails',familyDetails_singleForm)">
                                    <i class="fa fa-pencil mx-1"></i>
                                    {{'BTN.edit'|translate}}
                                  </button>
                                  <button class="btn btn-sm btn-default mx-1 "
                                    (click)="deleteTableItem(i, familyDetails,'familyDetails',familyDetails_singleForm)">
                                    <i class="fa fa-trash orange mx-1"></i>
                                    {{'BTN.delete'|translate}}
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </form>

                  </mat-expansion-panel>
                  <mat-expansion-panel *ngIf="field_config_access['groupHealthInsurance']"
                    [disabled]="((field_config_access['groupHealthInsurance']['validators'] && field_config_access['groupHealthInsurance']['validators']['disable'] && field_config_access['groupHealthInsurance']['validators']['disable']!='0')?true:false)">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ field_config_access['groupHealthInsurance']['label'] | translate}}
                      </mat-panel-title>
                      <mat-panel-description>
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <form [formGroup]="groupHealthInsuranceForm">
                      <div class="row">
                        <div class="col-md-3" *ngIf="field_config_access['relationTypeId']">
                          <tm-select
                            [options]="masters[field_config_access['relationTypeId']['masterPropName'] || 'relationTypeList'] || []"
                            [form_group]="groupHealthInsuranceForm" form_control="relationTypeId" title_property="title"
                            id_property="id" float_label="always" [data]="groupHealthInsuranceForm.value.relationTypeId"
                            [label]="field_config_access['relationTypeId']['label'] |translate"
                            [placeholder]="((field_config_access['relationTypeId']['placeholder'])| translate)"
                            [mandatory]="(field_config_access['relationTypeId']['validators'] && field_config_access['relationTypeId']['validators']['mandatory']?true:false)"
                            [disabled]="((field_config_access['relationTypeId']['validators'] && field_config_access['relationTypeId']['validators']['disable'] && field_config_access['relationTypeId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                            [label_overflow]="1">
                          </tm-select>
                        </div>

                        <div class="col-md-3" *ngIf="field_config_access['name']">
                          <mat-form-field floatLabel="always">
                            <mat-label>
                              {{field_config_access['name']['label'] |translate}}
                            </mat-label>
                            <input matInput formControlName="name" name="name"
                              [placeholder]="((field_config_access['name']['placeholder'])| translate)"
                              [required]="(field_config_access['name']['validators'] && field_config_access['name']['validators']['mandatory']?true:false)"
                              [minlength]="(field_config_access['name']['validators'] && field_config_access['name']['validators']['minLength'])"
                              [maxlength]="(field_config_access['name']['validators'] && field_config_access['name']['validators']['maxLength'])"
                              [readonly]="((field_config_access['name']['validators'] && field_config_access['name']['validators']['disable'] && field_config_access['name']['validators']['disable']!='0')?true:false) ||disabled_fields "
                              [pattern]="(field_config_access['name']['validators'] &&
                                            field_config_access['name']['validators']['finalPattern'])" />

                            <mat-error *ngIf="groupHealthInsuranceForm.get('name').invalid">
                              <ng-container
                                *ngTemplateOutlet="error_message; context: {form_control:groupHealthInsuranceForm.get('name'),field_config_access:field_config_access['name']}">
                              </ng-container>
                            </mat-error>


                          </mat-form-field>
                        </div>

                        <div class="col-md-3" *ngIf="field_config_access['dob']">
                          <tm-date-picker [form]="groupHealthInsuranceForm" [controlName]="'dob'"
                            [placeholder]="((field_config_access['dob']['placeholder']) | translate) "
                            [label]="field_config_access['dob']['label'] |translate"
                            [value]="groupHealthInsuranceForm.value.dob"
                            [minValue]="(field_config_access['dob']['validators'] && field_config_access['dob']['validators']['minValue'])"
                            [maxValue]="(field_config_access['dob']['validators'] && field_config_access['dob']['validators']['maxValue'])">
                            [required]="(field_config_access['dob']['validators'] &&
                            field_config_access['dob']['validators']['mandatory']?true:false)"
                            [disabled]="((field_config_access['dob']['validators'] &&
                            field_config_access['dob']['validators']['disable'] &&
                            field_config_access['dob']['validators']['disable'] != '0')?true:false)
                            ||disabled_fields "

                          </tm-date-picker>
                        </div>
                        <div class="col-md-3" *ngIf="field_config_access['bloodGroup']">
                          <tm-select
                            [options]="masters[field_config_access['bloodGroup']['masterPropName'] || 'bloodGroupList'] || []"
                            [form_group]="groupHealthInsuranceForm" form_control="bloodGroup" title_property="title"
                            id_property="id" float_label="always" [data]="groupHealthInsuranceForm.value.bloodGroup"
                            [label]="field_config_access['bloodGroup']['label'] |translate"
                            [placeholder]="((field_config_access['bloodGroup']['placeholder'])| translate)"
                            [mandatory]="(field_config_access['bloodGroup']['validators'] && field_config_access['bloodGroup']['validators']['mandatory']?true:false)"
                            [disabled]="((field_config_access['bloodGroup']['validators'] && field_config_access['bloodGroup']['validators']['disable'] && field_config_access['bloodGroup']['validators']['disable']!='0')?true:false) ||disabled_fields "
                            [label_overflow]="1">
                          </tm-select>
                        </div>


                        <div class="col-md-12 text-right">
                          <button (click)="addToTable(familyDetails,'groupHealthInsurance',groupHealthInsuranceForm)"
                            class="btn btn-sm mat-mt js-btn-save">
                            <i class="fa fa-plus-square mx-1"></i>
                            {{'BTN.add'|translate}}
                          </button>
                        </div>

                        <div class="col-md-12 table-responsive tm-data-table">
                          <table class="table table-striped" *ngIf="familyDetails.get('groupHealthInsurance').value">
                            <thead>
                              <tr>
                                <th>
                                  {{field_config_access['relationTypeId']['label'] |translate}}
                                </th>

                                <th>
                                  {{field_config_access['name']['label'] |translate}}
                                </th>

                                <th>
                                  {{field_config_access['dob']['label'] |translate}}
                                </th>

                                <th>
                                  {{field_config_access['bloodGroup']['label'] |translate}}
                                </th>


                                <th class="text-center">
                                  Action
                                </th>
                              </tr>

                            </thead>
                            <tbody>
                              <tr
                                *ngFor="let item of familyDetails.get('groupHealthInsurance').value  || [];let i = index">
                                <td>{{
                                  item.relationTypeId | DynamicPipe :
                                  masters[field_config_access['relationTypeId']['masterPropName'] ||
                                  'relationTypeList']
                                  || []:'id':'title' }}
                                </td>

                                <td>
                                  {{ item.name}}
                                </td>

                                <td>
                                  {{ item.dob |UtcToLocalTime | date: 'dd-MMM-yyyy'}}
                                </td>

                                <td>
                                  {{ item.bloodGroup}}
                                </td>


                                <td>
                                  <button class="btn btn-sm btn-default mx-1 "
                                    (click)="editTableItem(i, familyDetails,'groupHealthInsurance',groupHealthInsuranceForm)">
                                    <i class="fa fa-pencil mx-1"></i>
                                    {{'BTN.edit'|translate}}
                                  </button>
                                  <button class="btn btn-sm btn-default mx-1 "
                                    (click)="deleteTableItem(i, familyDetails,'groupHealthInsurance',groupHealthInsuranceForm)">
                                    <i class="fa fa-trash orange mx-1"></i>
                                    {{'BTN.delete'|translate}}
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </form>

                  </mat-expansion-panel>

                  <mat-expansion-panel *ngIf="field_config_access['nomineeDetails']"
                    [disabled]="((field_config_access['nomineeDetails']['validators'] && field_config_access['nomineeDetails']['validators']['disable'] && field_config_access['nomineeDetails']['validators']['disable']!='0')?true:false)">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ field_config_access['nomineeDetails']['label'] | translate}}
                      </mat-panel-title>
                      <mat-panel-description>
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <form [formGroup]="nomineeDetailsForm">
                      <div class="row">
                        <div class="col-md-3" *ngIf="field_config_access['relationTypeId']">
                          <tm-select
                            [options]="masters[field_config_access['relationTypeId']['masterPropName'] || 'relationTypeList'] || []"
                            [form_group]="nomineeDetailsForm" form_control="relationTypeId" title_property="title"
                            id_property="id" float_label="always" [data]="nomineeDetailsForm.value.relationTypeId"
                            [label]="field_config_access['relationTypeId']['label'] |translate"
                            [placeholder]="((field_config_access['relationTypeId']['placeholder'])| translate)"
                            [mandatory]="(field_config_access['relationTypeId']['validators'] && field_config_access['relationTypeId']['validators']['mandatory']?true:false)"
                            [disabled]="((field_config_access['relationTypeId']['validators'] && field_config_access['relationTypeId']['validators']['disable'] && field_config_access['relationTypeId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                            [label_overflow]="1">
                          </tm-select>
                        </div>

                        <div class="col-md-3" *ngIf="field_config_access['name']">
                          <mat-form-field floatLabel="always">
                            <mat-label>
                              {{field_config_access['name']['label'] |translate}}
                            </mat-label>
                            <input matInput formControlName="name" name="name"
                              [placeholder]="((field_config_access['name']['placeholder'])| translate)"
                              [required]="(field_config_access['name']['validators'] && field_config_access['name']['validators']['mandatory']?true:false)"
                              [minlength]="(field_config_access['name']['validators'] && field_config_access['name']['validators']['minLength'])"
                              [maxlength]="(field_config_access['name']['validators'] && field_config_access['name']['validators']['maxLength'])"
                              [readonly]="((field_config_access['name']['validators'] && field_config_access['name']['validators']['disable'] && field_config_access['name']['validators']['disable']!='0')?true:false) ||disabled_fields "
                              [pattern]="(field_config_access['name']['validators'] &&
                                        field_config_access['name']['validators']['finalPattern'])" />

                            <mat-error *ngIf="nomineeDetailsForm.get('name').invalid">
                              <ng-container
                                *ngTemplateOutlet="error_message; context: {form_control:nomineeDetailsForm.get('name'),field_config_access:field_config_access['name']}">
                              </ng-container>
                            </mat-error>


                          </mat-form-field>
                        </div>

                        <div class="col-md-3" *ngIf="field_config_access['dob']">
                          <tm-date-picker [form]="nomineeDetailsForm" [controlName]="'dob'"
                            [placeholder]="((field_config_access['dob']['placeholder']) | translate) "
                            [label]="field_config_access['dob']['label'] |translate"
                            [value]="nomineeDetailsForm.value.dob"
                            [minValue]="(field_config_access['dob']['validators'] && field_config_access['dob']['validators']['minValue'])"
                            [maxValue]="(field_config_access['dob']['validators'] && field_config_access['dob']['validators']['maxValue'])">
                            [required]="(field_config_access['dob']['validators'] &&
                            field_config_access['dob']['validators']['mandatory']?true:false)"
                            [disabled]="((field_config_access['dob']['validators'] &&
                            field_config_access['dob']['validators']['disable'] &&
                            field_config_access['dob']['validators']['disable'] != '0')?true:false)
                            ||disabled_fields "

                          </tm-date-picker>
                        </div>
                        <div class="col-md-3" *ngIf="field_config_access['bloodGroup']">
                          <tm-select
                            [options]="masters[field_config_access['bloodGroup']['masterPropName'] || 'bloodGroupList'] || []"
                            [form_group]="nomineeDetailsForm" form_control="bloodGroup" title_property="title"
                            id_property="id" float_label="always" [data]="nomineeDetailsForm.value.bloodGroup"
                            [label]="field_config_access['bloodGroup']['label'] |translate"
                            [placeholder]="((field_config_access['bloodGroup']['placeholder'])| translate)"
                            [mandatory]="(field_config_access['bloodGroup']['validators'] && field_config_access['bloodGroup']['validators']['mandatory']?true:false)"
                            [disabled]="((field_config_access['bloodGroup']['validators'] && field_config_access['bloodGroup']['validators']['disable'] && field_config_access['bloodGroup']['validators']['disable']!='0')?true:false) ||disabled_fields "
                            [label_overflow]="1">
                          </tm-select>
                        </div>

                        <div class="col-md-3" *ngIf="field_config_access['address']">
                          <mat-form-field floatLabel="always">
                            <mat-label>
                              {{field_config_access['address']['label'] |translate}}
                            </mat-label>
                            <input matInput formControlName="address"
                              [placeholder]="(field_config_access['address']['placeholder'] | translate)"
                              [readonly]="((field_config_access['address']['validators'] && field_config_access['address']['validators']['disable'] && field_config_access['address']['validators']['disable']!='0')?true:false) ||disabled_fields "
                              [minlength]="(field_config_access['address']['validators'] && field_config_access['address']['validators']['minLength'])"
                              [maxlength]="(field_config_access['address']['validators'] && field_config_access['address']['validators']['maxLength'])"
                              [required]="(field_config_access['address']['validators'] && field_config_access['address']['validators']['mandatory']?true:false)"
                              [pattern]="(field_config_access['address']['validators'] &&
                            field_config_access['address']['validators']['finalPattern'])" />
                            <mat-error *ngIf="nomineeDetailsForm.get('address').invalid">
                              <ng-container
                                *ngTemplateOutlet="error_message; context: {form_control:nomineeDetailsForm.get('address'),field_config_access:field_config_access['address']}">
                              </ng-container>
                            </mat-error>
                          </mat-form-field>
                        </div>


                        <div class="col-md-2" *ngIf="field_config_access['percentageShare']">
                          <mat-form-field floatLabel="always">
                            <mat-label>
                              {{field_config_access['percentageShare']['label'] |translate}}
                            </mat-label>
                            <input matInput formControlName="percentageShare" type="number"
                              [placeholder]="(field_config_access['percentageShare']['placeholder'] | translate)"
                              [readonly]="((field_config_access['percentageShare']['validators'] && field_config_access['percentageShare']['validators']['disable'] && field_config_access['percentageShare']['validators']['disable']!='0')?true:false) ||disabled_fields "
                              [minlength]="(field_config_access['percentageShare']['validators'] && field_config_access['percentageShare']['validators']['minLength'])"
                              [maxlength]="(field_config_access['percentageShare']['validators'] && field_config_access['percentageShare']['validators']['maxLength'])"
                              [required]="(field_config_access['percentageShare']['validators'] && field_config_access['percentageShare']['validators']['mandatory']?true:false)"
                              [pattern]="(field_config_access['percentageShare']['validators'] &&
                            field_config_access['percentageShare']['validators']['finalPattern'])" />
                            <mat-error *ngIf="nomineeDetailsForm.get('percentageShare').invalid">
                              <ng-container
                                *ngTemplateOutlet="error_message; context: {form_control:nomineeDetailsForm.get('percentageShare'),field_config_access:field_config_access['percentageShare']}">
                              </ng-container>
                            </mat-error>
                          </mat-form-field>
                        </div>


                        <div class="col-md-12 text-right">
                          <button (click)="addToTable(familyDetails,'nomineeDetails',nomineeDetailsForm)"
                            class="btn btn-sm mat-mt js-btn-save">
                            <i class="fa fa-plus-square mx-1"></i>
                            {{'BTN.add'|translate}}
                          </button>
                        </div>

                        <div class="col-md-12 table-responsive tm-data-table">
                          <table class="table table-striped" *ngIf="familyDetails.get('nomineeDetails').value">
                            <thead>
                              <tr>
                                <th>
                                  {{field_config_access['relationTypeId']['label'] |translate}}
                                </th>

                                <th>
                                  {{field_config_access['name']['label'] |translate}}
                                </th>

                                <th>
                                  {{field_config_access['dob']['label'] |translate}}
                                </th>

                                <th>
                                  {{field_config_access['bloodGroup']['label'] |translate}}
                                </th>


                                <th class="text-center">
                                  Action
                                </th>
                              </tr>

                            </thead>
                            <tbody>
                              <tr *ngFor="let item of familyDetails.get('nomineeDetails').value  || [];let i = index">
                                <td>{{
                                  item.relationTypeId | DynamicPipe :
                                  masters[field_config_access['relationTypeId']['masterPropName'] ||
                                  'relationTypeList']
                                  || []:'id':'title' }}
                                </td>

                                <td>
                                  {{ item.name}}
                                </td>

                                <td>
                                  {{ item.dob |UtcToLocalTime | date: 'dd-MMM-yyyy'}}
                                </td>

                                <td>
                                  {{ item.bloodGroup}}
                                </td>


                                <td class="text-center">
                                  <button class="btn btn-sm btn-default mx-1 "
                                    (click)="editTableItem(i, familyDetails,'nomineeDetails',nomineeDetailsForm)">
                                    <i class="fa fa-pencil mx-1"></i>
                                    {{'BTN.edit'|translate}}
                                  </button>
                                  <button class="btn btn-sm btn-default mx-1 "
                                    (click)="deleteTableItem(i, familyDetails,'nomineeDetails',nomineeDetailsForm)">
                                    <i class="fa fa-trash orange mx-1"></i>
                                    {{'BTN.delete'|translate}}
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                    </form>

                  </mat-expansion-panel>

                </mat-accordion>
              </form>
            </ng-container>

            <ng-container *ngIf="section.id == 4">
              <form [formGroup]="workHistory_form">
                <div class="row">

                  <div class="col-md-3" *ngIf="field_config_access['totalExperience']">
                    <mat-form-field floatLabel="always">
                      <mat-label>
                        {{field_config_access['totalExperience']['label'] |translate}}
                      </mat-label>
                      <input matInput formControlName="totalExperience" name="totalExperience" type="number"
                        [placeholder]="((field_config_access['totalExperience']['placeholder'])| translate)"
                        [required]="(field_config_access['totalExperience']['validators'] && field_config_access['totalExperience']['validators']['mandatory']?true:false)"
                        [minlength]="(field_config_access['totalExperience']['validators'] && field_config_access['totalExperience']['validators']['minLength'])"
                        [maxlength]="(field_config_access['totalExperience']['validators'] && field_config_access['totalExperience']['validators']['maxLength'])"
                        [readonly]="((field_config_access['totalExperience']['validators'] && field_config_access['totalExperience']['validators']['disable'] && field_config_access['totalExperience']['validators']['disable']!='0')?true:false) ||disabled_fields "
                        [pattern]="(field_config_access['totalExperience']['validators'] && field_config_access['totalExperience']['validators']['finalPattern'])" />
                      <mat-error *ngIf="workHistory_form.get('totalExperience').invalid">
                        <ng-container
                          *ngTemplateOutlet="error_message; context: {form_control:workHistory_form.get('totalExperience'),field_config_access:field_config_access['totalExperience']}">
                        </ng-container>
                      </mat-error>


                    </mat-form-field>
                  </div>
                  <div class="col-md-3" *ngIf="field_config_access['relevantExperience']">
                    <mat-form-field floatLabel="always">
                      <mat-label>
                        {{field_config_access['relevantExperience']['label'] |translate}}
                      </mat-label>
                      <input matInput formControlName="relevantExperience" name="relevantExperience" type="number"
                        [placeholder]="((field_config_access['relevantExperience']['placeholder'])| translate)"
                        [required]="(field_config_access['relevantExperience']['validators'] && field_config_access['relevantExperience']['validators']['mandatory']?true:false)"
                        [minlength]="(field_config_access['relevantExperience']['validators'] && field_config_access['relevantExperience']['validators']['minLength'])"
                        [maxlength]="(field_config_access['relevantExperience']['validators'] && field_config_access['relevantExperience']['validators']['maxLength'])"
                        [readonly]="((field_config_access['relevantExperience']['validators'] && field_config_access['relevantExperience']['validators']['disable'] && field_config_access['relevantExperience']['validators']['disable']!='0')?true:false) ||disabled_fields "
                        [pattern]="(field_config_access['relevantExperience']['validators'] && field_config_access['relevantExperience']['validators']['finalPattern'])" />
                      <mat-error *ngIf="workHistory_form.get('relevantExperience').invalid">
                        <ng-container
                          *ngTemplateOutlet="error_message; context: {form_control:workHistory_form.get('relevantExperience'),field_config_access:field_config_access['relevantExperience']}">
                        </ng-container>
                      </mat-error>


                    </mat-form-field>
                  </div>


                  <mat-accordion class="example-headers-align" multi>
                    <mat-expansion-panel *ngIf="field_config_access['workHistory']"
                      [disabled]="((field_config_access['workHistory']['validators'] && field_config_access['workHistory']['validators']['disable'] && field_config_access['familyDetails']['validators']['disable']!='0')?true:false)">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          {{ field_config_access['workHistory']['label'] | translate}}
                        </mat-panel-title>
                        <mat-panel-description>


                        </mat-panel-description>
                      </mat-expansion-panel-header>

                      <form [formGroup]="workHistory">
                        <div class="row">
                          <div class="col-md-4" *ngIf="field_config_access['companyName']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['companyName']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="companyName" name="companyName"
                                [placeholder]="((field_config_access['companyName']['placeholder'])| translate)"
                                [required]="(field_config_access['companyName']['validators'] && field_config_access['companyName']['validators']['mandatory']?true:false)"
                                [minlength]="(field_config_access['companyName']['validators'] && field_config_access['companyName']['validators']['minLength'])"
                                [maxlength]="(field_config_access['companyName']['validators'] && field_config_access['companyName']['validators']['maxLength'])"
                                [readonly]="((field_config_access['companyName']['validators'] && field_config_access['companyName']['validators']['disable'] && field_config_access['companyName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [pattern]="(field_config_access['companyName']['validators'] && field_config_access['companyName']['validators']['finalPattern'])" />
                              <mat-error *ngIf="workHistory.get('companyName').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:workHistory.get('companyName'),field_config_access:field_config_access['companyName']}">
                                </ng-container>
                              </mat-error>


                            </mat-form-field>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['WH_designationId']">
                            <tm-select
                              [options]="masters[field_config_access['WH_designationId']['masterPropName'] || 'jobTitleList'] || []"
                              [form_group]="workHistory" form_control="designationId" title_property="title"
                              id_property="id" float_label="always" [data]="workHistory.value.designationId"
                              [label]="field_config_access['WH_designationId']['label'] |translate"
                              [placeholder]="((field_config_access['WH_designationId']['placeholder'])| translate)"
                              [mandatory]="(field_config_access['WH_designationId']['validators'] && field_config_access['WH_designationId']['validators']['mandatory']?true:false)"
                              [disabled]="((field_config_access['WH_designationId']['validators'] && field_config_access['WH_designationId']['validators']['disable'] && field_config_access['WH_designationId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                              [label_overflow]="1">
                            </tm-select>
                          </div>

                          <div class="col-md-2" *ngIf="field_config_access['fromDate']">
                            <tm-date-picker [form]="workHistory" [controlName]="'fromDate'"
                              [value]="workHistory.value.fromDate"
                              [label]="field_config_access['fromDate']['label'] |translate"
                              [placeholder]="((field_config_access['fromDate']['placeholder'])| translate)"
                              [required]="(field_config_access['fromDate']['validators'] && field_config_access['fromDate']['validators']['mandatory']?true:false)"
                              [disabled]="((field_config_access['fromDate']['validators'] && field_config_access['fromDate']['validators']['disable'] && field_config_access['fromDate']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                            </tm-date-picker>
                          </div>

                          <div class="col-md-2" *ngIf="field_config_access['toDate']">
                            <tm-date-picker [form]="workHistory" [controlName]="'toDate'"
                              [value]="workHistory.value.toDate"
                              [label]="field_config_access['toDate']['label'] |translate"
                              [placeholder]="((field_config_access['toDate']['placeholder'])| translate)"
                              [required]="(field_config_access['toDate']['validators'] && field_config_access['toDate']['validators']['mandatory']?true:false)"
                              [disabled]="((field_config_access['toDate']['validators'] && field_config_access['toDate']['validators']['disable'] && field_config_access['toDate']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                            </tm-date-picker>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['jobContent']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['jobContent']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="jobContent" name="jobContent"
                                [placeholder]="((field_config_access['jobContent']['placeholder'])| translate)"
                                [required]="(field_config_access['jobContent']['validators'] && field_config_access['jobContent']['validators']['mandatory']?true:false)"
                                [minlength]="(field_config_access['jobContent']['validators'] && field_config_access['jobContent']['validators']['minLength'])"
                                [maxlength]="(field_config_access['jobContent']['validators'] && field_config_access['jobContent']['validators']['maxLength'])"
                                [readonly]="((field_config_access['jobContent']['validators'] && field_config_access['jobContent']['validators']['disable'] && field_config_access['jobContent']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [pattern]="(field_config_access['jobContent']['validators'] && field_config_access['jobContent']['validators']['finalPattern'])" />
                              <mat-error *ngIf="workHistory.get('jobContent').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:workHistory.get('jobContent'),field_config_access:field_config_access['jobContent']}">
                                </ng-container>
                              </mat-error>


                            </mat-form-field>
                          </div>
                          <div class="col-md-1" *ngIf="field_config_access['annualCTCCurrencyId']">
                            <tm-select
                              [options]=" masters[field_config_access['annualCTCCurrencyId']['masterPropName'] || 'currencyList' ] || []"
                              [form_group]="workHistory" form_control="annualCTCCurrencyId" title_property="title"
                              id_property="id" float_label="always" [data]="workHistory.value.annualCTCCurrencyId"
                              [label_overflow]="1"
                              [label]="field_config_access['annualCTCCurrencyId']['label'] |translate"
                              [placeholder]="((field_config_access['annualCTCCurrencyId']['placeholder'])| translate)"
                              [mandatory]="(field_config_access['annualCTCCurrencyId']['validators'] && field_config_access['annualCTCCurrencyId']['validators']['mandatory']?true:false)"
                              [disabled]="((field_config_access['annualCTCCurrencyId']['validators'] && field_config_access['annualCTCCurrencyId']['validators']['disable'] && field_config_access['annualCTCCurrencyId']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                            </tm-select>
                          </div>
                          <div class="col-md-3" *ngIf="field_config_access['annualCTC']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['annualCTC']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="annualCTC" name="annualCTC" type="number"
                                [placeholder]="((field_config_access['annualCTC']['placeholder'])| translate)"
                                [required]="(field_config_access['annualCTC']['validators'] && field_config_access['annualCTC']['validators']['mandatory']?true:false)"
                                [minlength]="(field_config_access['annualCTC']['validators'] && field_config_access['annualCTC']['validators']['minLength'])"
                                [maxlength]="(field_config_access['annualCTC']['validators'] && field_config_access['annualCTC']['validators']['maxLength'])"
                                [readonly]="((field_config_access['annualCTC']['validators'] && field_config_access['annualCTC']['validators']['disable'] && field_config_access['annualCTC']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [pattern]="(field_config_access['annualCTC']['validators'] && field_config_access['annualCTC']['validators']['finalPattern'])" />
                              <mat-error *ngIf="workHistory.get('annualCTC').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:workHistory.get('annualCTC'),field_config_access:field_config_access['annualCTC']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['reasonOfLeaving']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['reasonOfLeaving']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="reasonOfLeaving" name="reasonOfLeaving"
                                [placeholder]="((field_config_access['reasonOfLeaving']['placeholder'])| translate)"
                                [required]="(field_config_access['reasonOfLeaving']['validators'] && field_config_access['reasonOfLeaving']['validators']['mandatory']?true:false)"
                                [minlength]="(field_config_access['reasonOfLeaving']['validators'] && field_config_access['reasonOfLeaving']['validators']['minLength'])"
                                [maxlength]="(field_config_access['reasonOfLeaving']['validators'] && field_config_access['reasonOfLeaving']['validators']['maxLength'])"
                                [readonly]="((field_config_access['reasonOfLeaving']['validators'] && field_config_access['reasonOfLeaving']['validators']['disable'] && field_config_access['reasonOfLeaving']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [pattern]="(field_config_access['reasonOfLeaving']['validators'] && field_config_access['reasonOfLeaving']['validators']['finalPattern'])" />
                              <mat-error *ngIf="workHistory.get('reasonOfLeaving').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:workHistory.get('reasonOfLeaving'),field_config_access:field_config_access['reasonOfLeaving']}">
                                </ng-container>
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['employeeNumber']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['employeeNumber']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="employeeNumber" name="employeeNumber"
                                [placeholder]="((field_config_access['employeeNumber']['placeholder'])| translate)"
                                [required]="(field_config_access['employeeNumber']['validators'] && field_config_access['employeeNumber']['validators']['mandatory']?true:false)"
                                [minlength]="(field_config_access['employeeNumber']['validators'] && field_config_access['employeeNumber']['validators']['minLength'])"
                                [maxlength]="(field_config_access['employeeNumber']['validators'] && field_config_access['employeeNumber']['validators']['maxLength'])"
                                [readonly]="((field_config_access['employeeNumber']['validators'] && field_config_access['employeeNumber']['validators']['disable'] && field_config_access['employeeNumber']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [pattern]="(field_config_access['employeeNumber']['validators'] && field_config_access['employeeNumber']['validators']['finalPattern'])" />
                              <mat-error *ngIf="workHistory.get('employeeNumber').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:workHistory.get('employeeNumber'),field_config_access:field_config_access['employeeNumber']}">
                                </ng-container>
                              </mat-error>


                            </mat-form-field>
                          </div>
                          <div class="col-md-4" *ngIf="field_config_access['HRName']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['HRName']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="HRName" name="HRName"
                                [placeholder]="((field_config_access['HRName']['placeholder'])| translate)"
                                [required]="(field_config_access['HRName']['validators'] && field_config_access['HRName']['validators']['mandatory']?true:false)"
                                [minlength]="(field_config_access['HRName']['validators'] && field_config_access['HRName']['validators']['minLength'])"
                                [maxlength]="(field_config_access['HRName']['validators'] && field_config_access['HRName']['validators']['maxLength'])"
                                [readonly]="((field_config_access['HRName']['validators'] && field_config_access['HRName']['validators']['disable'] && field_config_access['HRName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [pattern]="(field_config_access['HRName']['validators'] && field_config_access['HRName']['validators']['finalPattern'])" />
                              <mat-error *ngIf="workHistory.get('HRName').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:workHistory.get('HRName'),field_config_access:field_config_access['HRName']}">
                                </ng-container>
                              </mat-error>


                            </mat-form-field>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['HREmailId']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['HREmailId']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="HREmailId" name="HREmailId"
                                [placeholder]="((field_config_access['HREmailId']['placeholder'])| translate)"
                                [required]="(field_config_access['HREmailId']['validators'] && field_config_access['HREmailId']['validators']['mandatory']?true:false)"
                                [minlength]="(field_config_access['HREmailId']['validators'] && field_config_access['HREmailId']['validators']['minLength'])"
                                [maxlength]="(field_config_access['HREmailId']['validators'] && field_config_access['HREmailId']['validators']['maxLength'])"
                                [readonly]="((field_config_access['HREmailId']['validators'] && field_config_access['HREmailId']['validators']['disable'] && field_config_access['HREmailId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [pattern]="(field_config_access['HREmailId']['validators'] && field_config_access['HREmailId']['validators']['finalPattern'])" />
                              <mat-error *ngIf="workHistory.get('HREmailId').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:workHistory.get('HREmailId'),field_config_access:field_config_access['HREmailId']}">
                                </ng-container>
                              </mat-error>


                            </mat-form-field>
                          </div>

                          <div class="col-md-4"
                            *ngIf="field_config_access['HRContactIsd'] && field_config_access['HRContactNumber']">
                            <div class="prefix-control" style="width: 35%;">
                              <tm-select
                                [options]="masters[field_config_access['HRContactIsd']['masterPropName'] || 'isdCountryList'] || []"
                                [form_group]="workHistory" form_control="HRContactIsd" title_property="title"
                                id_property="id" float_label="always" [data]="workHistory.value.HRContactIsd"
                                [label_overflow]="1" [label]="field_config_access['HRContactIsd']['label'] |translate"
                                [placeholder]="((field_config_access['HRContactIsd']['placeholder'])| translate)"
                                [mandatory]="(field_config_access['HRContactIsd']['validators'] && field_config_access['HRContactIsd']['validators']['mandatory']?true:false)"
                                [disabled]="((field_config_access['HRContactIsd']['validators'] && field_config_access['HRContactIsd']['validators']['disable'] && field_config_access['HRContactIsd']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                              </tm-select>
                            </div>
                            <div class="main-control" style="width: 65%;">
                              <app-phone-number
                                [options]="masters[field_config_access['HRContactIsd']['masterPropName'] || 'isdCountryList'] || []"
                                [options_data]="workHistory.value.HRContactIsd" [form]="workHistory"
                                controlName="HRContactNumber" [data]="workHistory['controls']['HRContactNumber'].value"
                                [disabledDial]="1" [hide_label]="1"
                                [label]="field_config_access['HRContactNumber']['label'] |translate"
                                [placeholder]="((field_config_access['HRContactNumber']['placeholder'])| translate)"
                                [required]="(field_config_access['HRContactNumber']['validators'] && field_config_access['HRContactNumber']['validators']['mandatory']?true:false)"
                                [readonly]="((field_config_access['HRContactNumber']['validators'] && field_config_access['HRContactNumber']['validators']['disable'] && field_config_access['HRContactNumber']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                                [pattern_desc]="(field_config_access['HRContactNumber']['validators'] &&
                                field_config_access['HRContactNumber']['validators']['finalPattern']) || '^[0-9]*$'"
                                >
                              </app-phone-number>
                            </div>
                          </div>

                          <div class="col-md-12 text-right">
                            <button (click)="addToTable(workHistory_form,'workHistory',workHistory)"
                              class="btn btn-sm mat-mt js-btn-save">
                              <i class="fa fa-plus-square mx-1"></i>
                              {{'BTN.add'|translate}}
                            </button>
                          </div>


                          <div class="col-md-12 table-responsive tm-data-table">
                            <table class="table table-striped " *ngIf="workHistory_form.get('workHistory').value">
                              <thead>
                                <tr>
                                  <th>
                                    {{field_config_access['companyName']['label'] |translate}}
                                  </th>
                                  <th>
                                    {{field_config_access['WH_designationId']['label'] |translate}}
                                  </th>
                                  <th>
                                    {{field_config_access['fromDate']['label'] |translate}}
                                  </th>
                                  <th>
                                    {{field_config_access['toDate']['label'] |translate}}
                                  </th>
                                  <th>
                                    {{field_config_access['jobContent']['label'] |translate}}
                                  </th>

                                  <th>
                                    {{field_config_access['annualCTC']['label'] |translate}}
                                  </th>

                                  <th>
                                    {{field_config_access['reasonOfLeaving']['label'] |translate}}
                                  </th>

                                  <th class="text-center">
                                    Action
                                  </th>
                                </tr>

                              </thead>
                              <tbody>
                                <tr *ngFor="let item of workHistory_form.get('workHistory').value  || [];let i = index">
                                  <td>
                                    {{item.companyName}}
                                  </td>
                                  <td>
                                    {{ item.designationId | DynamicPipe
                                    : masters[field_config_access['WH_designationId']['masterPropName'] ||
                                    'jobTitleList'] || []:'id':'title' }}
                                  </td>



                                  <td>
                                    {{ item.fromDate |UtcToLocalTime | date: 'dd-MMM-yyyy'}}
                                  </td>


                                  <td>
                                    {{ item.toDate |UtcToLocalTime | date: 'dd-MMM-yyyy'}}
                                  </td>



                                  <td>
                                    {{ item.jobContent }}
                                  </td>

                                  <td>
                                    {{ item.annualCTC }}
                                  </td>

                                  <td>
                                    {{ item.reasonOfLeaving }}
                                  </td>


                                  <td class="text-center">
                                    <button class="btn btn-sm btn-default mx-1 "
                                      (click)="editTableItem(i,workHistory_form,'workHistory',workHistory)">
                                      <i class="fa fa-pencil mx-1"></i>
                                      {{'BTN.edit'|translate}}
                                    </button>
                                    <button class="btn btn-sm btn-default mx-1 "
                                      (click)="deleteTableItem(i,workHistory_form,'workHistory',workHistory)">
                                      <i class="fa fa-trash orange mx-1"></i>
                                      {{'BTN.delete'|translate}}
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </form>

                    </mat-expansion-panel>
                    <mat-expansion-panel *ngIf="field_config_access['previousEmployerDetails']"
                      [disabled]="((field_config_access['previousEmployerDetails']['validators'] && field_config_access['groupHealthInsurance']['validators']['disable'] && field_config_access['groupHealthInsurance']['validators']['disable']!='0')?true:false)">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          {{ field_config_access['previousEmployerDetails']['label'] | translate}}
                        </mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <form [formGroup]="workHistory_form.get('previousEmployerDetails')">
                        <div class="row">
                          <div class="col-md-4" *ngIf="field_config_access['companyName']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['companyName']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="companyName" name="companyName"
                                [placeholder]="((field_config_access['companyName']['placeholder'])| translate)"
                                [required]="(field_config_access['companyName']['validators'] && field_config_access['companyName']['validators']['mandatory']?true:false)"
                                [minlength]="(field_config_access['companyName']['validators'] && field_config_access['companyName']['validators']['minLength'])"
                                [maxlength]="(field_config_access['companyName']['validators'] && field_config_access['companyName']['validators']['maxLength'])"
                                [readonly]="((field_config_access['companyName']['validators'] && field_config_access['companyName']['validators']['disable'] && field_config_access['companyName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [pattern]="(field_config_access['companyName']['validators'] && field_config_access['companyName']['validators']['finalPattern'])" />
                              <mat-error
                                *ngIf="workHistory_form.get('previousEmployerDetails').get('companyName').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:workHistory_form.get('previousEmployerDetails').get('companyName'),field_config_access:field_config_access['companyName']}">
                                </ng-container>
                              </mat-error>


                            </mat-form-field>
                          </div>

                          <div class="col-md-6" *ngIf="field_config_access['companyAddress']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['companyAddress']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="companyAddress" name="companyAddress"
                                [placeholder]="((field_config_access['companyAddress']['placeholder'])| translate)"
                                [required]="(field_config_access['companyAddress']['validators'] && field_config_access['companyAddress']['validators']['mandatory']?true:false)"
                                [minlength]="(field_config_access['companyAddress']['validators'] && field_config_access['companyAddress']['validators']['minLength'])"
                                [maxlength]="(field_config_access['companyAddress']['validators'] && field_config_access['companyAddress']['validators']['maxLength'])"
                                [readonly]="((field_config_access['companyAddress']['validators'] && field_config_access['companyAddress']['validators']['disable'] && field_config_access['companyAddress']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [pattern]="(field_config_access['companyAddress']['validators'] && field_config_access['companyAddress']['validators']['finalPattern'])" />
                              <mat-error
                                *ngIf="workHistory_form.get('previousEmployerDetails').get('companyAddress').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:workHistory_form.get('previousEmployerDetails').get('companyAddress'),field_config_access:field_config_access['companyAddress']}">
                                </ng-container>
                              </mat-error>


                            </mat-form-field>
                          </div>

                          <div class="col-md-2" *ngIf="field_config_access['employeeNumber']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['employeeNumber']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="employeeNumber" name="employeeNumber"
                                [placeholder]="((field_config_access['employeeNumber']['placeholder'])| translate)"
                                [required]="(field_config_access['employeeNumber']['validators'] && field_config_access['employeeNumber']['validators']['mandatory']?true:false)"
                                [minlength]="(field_config_access['employeeNumber']['validators'] && field_config_access['employeeNumber']['validators']['minLength'])"
                                [maxlength]="(field_config_access['employeeNumber']['validators'] && field_config_access['employeeNumber']['validators']['maxLength'])"
                                [readonly]="((field_config_access['employeeNumber']['validators'] && field_config_access['employeeNumber']['validators']['disable'] && field_config_access['employeeNumber']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [pattern]="(field_config_access['employeeNumber']['validators'] && field_config_access['employeeNumber']['validators']['finalPattern'])" />
                              <mat-error
                                *ngIf="workHistory_form.get('previousEmployerDetails').get('employeeNumber').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:workHistory_form.get('previousEmployerDetails').get('employeeNumber'),field_config_access:field_config_access['employeeNumber']}">
                                </ng-container>
                              </mat-error>


                            </mat-form-field>
                          </div>

                          <div class="col-md-4"
                            *ngIf="field_config_access['companyContactIsd'] && field_config_access['companyContactNumber']">
                            <div class="prefix-control" style="width: 35%;">
                              <tm-select
                                [options]="masters[field_config_access['companyContactIsd']['masterPropName'] || 'isdCountryList'] || []"
                                [form_group]="workHistory_form.get('previousEmployerDetails')"
                                form_control="companyContactIsd" title_property="title" id_property="id"
                                float_label="always"
                                [data]="workHistory_form.get('previousEmployerDetails').value.companyContactIsd"
                                [label_overflow]="1"
                                [label]="field_config_access['companyContactIsd']['label'] |translate"
                                [placeholder]="((field_config_access['companyContactIsd']['placeholder'])| translate)"
                                [mandatory]="(field_config_access['companyContactIsd']['validators'] && field_config_access['companyContactIsd']['validators']['mandatory']?true:false)"
                                [disabled]="((field_config_access['companyContactIsd']['validators'] && field_config_access['companyContactIsd']['validators']['disable'] && field_config_access['companyContactIsd']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                              </tm-select>
                            </div>
                            <div class="main-control" style="width: 65%;">
                              <app-phone-number
                                [options]="masters[field_config_access['companyContactIsd']['masterPropName'] || 'isdCountryList'] || []"
                                [options_data]="workHistory_form.get('previousEmployerDetails').value.companyContactIsd"
                                [form]="workHistory_form.get('previousEmployerDetails')"
                                controlName="companyContactNumber"
                                [data]="workHistory_form.get('previousEmployerDetails')['controls']['companyContactNumber'].value"
                                [disabledDial]="1" [hide_label]="1"
                                [label]="field_config_access['companyContactNumber']['label'] |translate"
                                [placeholder]="((field_config_access['companyContactNumber']['placeholder'])| translate)"
                                [required]="(field_config_access['companyContactNumber']['validators'] && field_config_access['companyContactNumber']['validators']['mandatory']?true:false)"
                                [readonly]="((field_config_access['companyContactNumber']['validators'] && field_config_access['companyContactNumber']['validators']['disable'] && field_config_access['companyContactNumber']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                                [pattern_desc]="(field_config_access['companyContactNumber']['validators'] &&
                                field_config_access['companyContactNumber']['validators']['finalPattern']) ||
                                '^[0-9]*$'"
                                >
                              </app-phone-number>
                            </div>
                          </div>


                          <div class="col-md-4" *ngIf="field_config_access['WH_designationId']">
                            <tm-select
                              [options]="masters[field_config_access['WH_designationId']['masterPropName'] || 'jobTitleList'] || []"
                              [form_group]="workHistory_form.get('previousEmployerDetails')"
                              form_control="designationId" title_property="title" id_property="id" float_label="always"
                              [data]="workHistory.value.designationId"
                              [label]="field_config_access['WH_designationId']['label'] |translate"
                              [placeholder]="((field_config_access['WH_designationId']['placeholder'])| translate)"
                              [mandatory]="(field_config_access['WH_designationId']['validators'] && field_config_access['WH_designationId']['validators']['mandatory']?true:false)"
                              [disabled]="((field_config_access['WH_designationId']['validators'] && field_config_access['WH_designationId']['validators']['disable'] && field_config_access['WH_designationId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                              [label_overflow]="1">
                            </tm-select>
                          </div>

                          <div class="col-md-2" *ngIf="field_config_access['dateOfJoining']">
                            <tm-date-picker [form]="workHistory_form.get('previousEmployerDetails')"
                              [controlName]="'dateOfJoining'"
                              [value]="workHistory_form.get('previousEmployerDetails').value.dateOfJoining"
                              [label]="field_config_access['dateOfJoining']['label'] |translate"
                              [placeholder]="((field_config_access['dateOfJoining']['placeholder'])| translate)"
                              [required]="(field_config_access['dateOfJoining']['validators'] && field_config_access['dateOfJoining']['validators']['mandatory']?true:false)"
                              [disabled]="((field_config_access['dateOfJoining']['validators'] && field_config_access['dateOfJoining']['validators']['disable'] && field_config_access['dateOfJoining']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                            </tm-date-picker>
                          </div>

                          <div class="col-md-2" *ngIf="field_config_access['dateOfRelieving']">
                            <tm-date-picker [form]="workHistory_form.get('previousEmployerDetails')"
                              [controlName]="'dateOfRelieving'"
                              [value]="workHistory_form.get('previousEmployerDetails').value.dateOfRelieving"
                              [label]="field_config_access['dateOfRelieving']['label'] |translate"
                              [placeholder]="((field_config_access['dateOfRelieving']['placeholder'])| translate)"
                              [required]="(field_config_access['dateOfRelieving']['validators'] && field_config_access['dateOfRelieving']['validators']['mandatory']?true:false)"
                              [disabled]="((field_config_access['dateOfRelieving']['validators'] && field_config_access['dateOfRelieving']['validators']['disable'] && field_config_access['dateOfRelieving']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                            </tm-date-picker>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['HRName']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['HRName']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="HRName" name="HRName"
                                [placeholder]="((field_config_access['HRName']['placeholder'])| translate)"
                                [required]="(field_config_access['HRName']['validators'] && field_config_access['HRName']['validators']['mandatory']?true:false)"
                                [minlength]="(field_config_access['HRName']['validators'] && field_config_access['HRName']['validators']['minLength'])"
                                [maxlength]="(field_config_access['HRName']['validators'] && field_config_access['HRName']['validators']['maxLength'])"
                                [readonly]="((field_config_access['HRName']['validators'] && field_config_access['HRName']['validators']['disable'] && field_config_access['HRName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [pattern]="(field_config_access['HRName']['validators'] && field_config_access['HRName']['validators']['finalPattern'])" />
                              <mat-error *ngIf="workHistory_form.get('previousEmployerDetails').get('HRName').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:workHistory_form.get('previousEmployerDetails').get('HRName'),field_config_access:field_config_access['HRName']}">
                                </ng-container>
                              </mat-error>


                            </mat-form-field>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['HREmailId']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['HREmailId']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="HREmailId" name="HREmailId"
                                [placeholder]="((field_config_access['HREmailId']['placeholder'])| translate)"
                                [required]="(field_config_access['HREmailId']['validators'] && field_config_access['HREmailId']['validators']['mandatory']?true:false)"
                                [minlength]="(field_config_access['HREmailId']['validators'] && field_config_access['HREmailId']['validators']['minLength'])"
                                [maxlength]="(field_config_access['HREmailId']['validators'] && field_config_access['HREmailId']['validators']['maxLength'])"
                                [readonly]="((field_config_access['HREmailId']['validators'] && field_config_access['HREmailId']['validators']['disable'] && field_config_access['HREmailId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [pattern]="(field_config_access['HREmailId']['validators'] && field_config_access['HREmailId']['validators']['finalPattern'])" />
                              <mat-error
                                *ngIf="workHistory_form.get('previousEmployerDetails').get('HREmailId').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:workHistory_form.get('previousEmployerDetails').get('HREmailId'),field_config_access:field_config_access['HREmailId']}">
                                </ng-container>
                              </mat-error>


                            </mat-form-field>
                          </div>

                          <div class="col-md-4"
                            *ngIf="field_config_access['HRContactIsd'] && field_config_access['HRContactNumber']">
                            <div class="prefix-control" style="width: 35%;">
                              <tm-select
                                [options]="masters[field_config_access['HRContactIsd']['masterPropName'] || 'isdCountryList'] || []"
                                [form_group]="workHistory_form.get('previousEmployerDetails')"
                                form_control="HRContactIsd" title_property="title" id_property="id" float_label="always"
                                [data]="workHistory_form.get('previousEmployerDetails').value.HRContactIsd"
                                [label_overflow]="1" [label]="field_config_access['HRContactIsd']['label'] |translate"
                                [placeholder]="((field_config_access['HRContactIsd']['placeholder'])| translate)"
                                [mandatory]="(field_config_access['HRContactIsd']['validators'] && field_config_access['HRContactIsd']['validators']['mandatory']?true:false)"
                                [disabled]="((field_config_access['HRContactIsd']['validators'] && field_config_access['HRContactIsd']['validators']['disable'] && field_config_access['HRContactIsd']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                              </tm-select>
                            </div>
                            <div class="main-control" style="width: 65%;">
                              <app-phone-number
                                [options]="masters[field_config_access['HRContactIsd']['masterPropName'] || 'isdCountryList'] || []"
                                [options_data]="workHistory_form.get('previousEmployerDetails').value.HRContactIsd"
                                [form]="workHistory_form.get('previousEmployerDetails')" controlName="HRContactNumber"
                                [data]="workHistory_form.get('previousEmployerDetails')['controls']['HRContactNumber'].value"
                                [disabledDial]="1" [hide_label]="1"
                                [label]="field_config_access['HRContactNumber']['label'] |translate"
                                [placeholder]="((field_config_access['HRContactNumber']['placeholder'])| translate)"
                                [required]="(field_config_access['HRContactNumber']['validators'] && field_config_access['HRContactNumber']['validators']['mandatory']?true:false)"
                                [readonly]="((field_config_access['HRContactNumber']['validators'] && field_config_access['HRContactNumber']['validators']['disable'] && field_config_access['HRContactNumber']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                                [pattern_desc]="(field_config_access['HRContactNumber']['validators'] &&
                                field_config_access['HRContactNumber']['validators']['finalPattern']) || '^[0-9]*$'"
                                >
                              </app-phone-number>
                            </div>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['RMName']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['RMName']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="RMName" name="RMName"
                                [placeholder]="((field_config_access['RMName']['placeholder'])| translate)"
                                [required]="(field_config_access['RMName']['validators'] && field_config_access['RMName']['validators']['mandatory']?true:false)"
                                [minlength]="(field_config_access['RMName']['validators'] && field_config_access['RMName']['validators']['minLength'])"
                                [maxlength]="(field_config_access['RMName']['validators'] && field_config_access['RMName']['validators']['maxLength'])"
                                [readonly]="((field_config_access['RMName']['validators'] && field_config_access['RMName']['validators']['disable'] && field_config_access['RMName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [pattern]="(field_config_access['RMName']['validators'] && field_config_access['RMName']['validators']['finalPattern'])" />
                              <mat-error *ngIf="workHistory_form.get('previousEmployerDetails').get('RMName').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:workHistory_form.get('previousEmployerDetails').get('RMName'),field_config_access:field_config_access['RMName']}">
                                </ng-container>
                              </mat-error>


                            </mat-form-field>
                          </div>


                          <div class="col-md-4" *ngIf="field_config_access['RMDesignationId']">
                            <tm-select
                              [options]="masters[field_config_access['RMDesignationId']['masterPropName'] || 'jobTitleList'] || []"
                              [form_group]="workHistory_form.get('previousEmployerDetails')"
                              form_control="designationId" title_property="title" id_property="id" float_label="always"
                              [data]="workHistory.value.designationId"
                              [label]="field_config_access['RMDesignationId']['label'] |translate"
                              [placeholder]="((field_config_access['RMDesignationId']['placeholder'])| translate)"
                              [mandatory]="(field_config_access['RMDesignationId']['validators'] && field_config_access['RMDesignationId']['validators']['mandatory']?true:false)"
                              [disabled]="((field_config_access['RMDesignationId']['validators'] && field_config_access['RMDesignationId']['validators']['disable'] && field_config_access['RMDesignationId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                              [label_overflow]="1">
                            </tm-select>
                          </div>

                          <div class="col-md-4" *ngIf="field_config_access['durationOfReporting']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['durationOfReporting']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="durationOfReporting" name="durationOfReporting"
                                [placeholder]="((field_config_access['durationOfReporting']['placeholder'])| translate)"
                                [required]="(field_config_access['durationOfReporting']['validators'] && field_config_access['durationOfReporting']['validators']['mandatory']?true:false)"
                                [minlength]="(field_config_access['durationOfReporting']['validators'] && field_config_access['durationOfReporting']['validators']['minLength'])"
                                [maxlength]="(field_config_access['durationOfReporting']['validators'] && field_config_access['durationOfReporting']['validators']['maxLength'])"
                                [readonly]="((field_config_access['durationOfReporting']['validators'] && field_config_access['durationOfReporting']['validators']['disable'] && field_config_access['durationOfReporting']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [pattern]="(field_config_access['durationOfReporting']['validators'] && field_config_access['durationOfReporting']['validators']['finalPattern'])" />
                              <mat-error
                                *ngIf="workHistory_form.get('previousEmployerDetails').get('durationOfReporting').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:workHistory_form.get('previousEmployerDetails').get('durationOfReporting'),field_config_access:field_config_access['durationOfReporting']}">
                                </ng-container>
                              </mat-error>


                            </mat-form-field>
                          </div>


                          <div class="col-md-4" *ngIf="field_config_access['RMContactEmailId']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['RMContactEmailId']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="RMContactEmailId" name="RMContactEmailId"
                                [placeholder]="((field_config_access['RMContactEmailId']['placeholder'])| translate)"
                                [required]="(field_config_access['RMContactEmailId']['validators'] && field_config_access['RMContactEmailId']['validators']['mandatory']?true:false)"
                                [minlength]="(field_config_access['RMContactEmailId']['validators'] && field_config_access['RMContactEmailId']['validators']['minLength'])"
                                [maxlength]="(field_config_access['RMContactEmailId']['validators'] && field_config_access['RMContactEmailId']['validators']['maxLength'])"
                                [readonly]="((field_config_access['RMContactEmailId']['validators'] && field_config_access['RMContactEmailId']['validators']['disable'] && field_config_access['RMContactEmailId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [pattern]="(field_config_access['RMContactEmailId']['validators'] && field_config_access['RMContactEmailId']['validators']['finalPattern'])" />
                              <mat-error
                                *ngIf="workHistory_form.get('previousEmployerDetails').get('RMContactEmailId').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:workHistory_form.get('previousEmployerDetails').get('RMContactEmailId'),field_config_access:field_config_access['RMContactEmailId']}">
                                </ng-container>
                              </mat-error>


                            </mat-form-field>
                          </div>


                          <div class="col-md-4"
                            *ngIf="field_config_access['RMContactIsd'] && field_config_access['RMContactNumber']">
                            <div class="prefix-control" style="width: 35%;">
                              <tm-select
                                [options]="masters[field_config_access['RMContactIsd']['masterPropName'] || 'isdCountryList'] || []"
                                [form_group]="workHistory_form.get('previousEmployerDetails')"
                                form_control="RMContactIsd" title_property="title" id_property="id" float_label="always"
                                [data]="workHistory_form.get('previousEmployerDetails').value.RMContactIsd"
                                [label_overflow]="1" [label]="field_config_access['RMContactIsd']['label'] |translate"
                                [placeholder]="((field_config_access['RMContactIsd']['placeholder'])| translate)"
                                [mandatory]="(field_config_access['RMContactIsd']['validators'] && field_config_access['RMContactIsd']['validators']['mandatory']?true:false)"
                                [disabled]="((field_config_access['RMContactIsd']['validators'] && field_config_access['RMContactIsd']['validators']['disable'] && field_config_access['RMContactIsd']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                              </tm-select>
                            </div>
                            <div class="main-control" style="width: 65%;">
                              <app-phone-number
                                [options]="masters[field_config_access['RMContactIsd']['masterPropName'] || 'isdCountryList'] || []"
                                [options_data]="workHistory_form.get('previousEmployerDetails').value.RMContactIsd"
                                [form]="workHistory_form.get('previousEmployerDetails')" controlName="RMContactNumber"
                                [data]="workHistory_form.get('previousEmployerDetails')['controls']['RMContactNumber'].value"
                                [disabledDial]="1" [hide_label]="1"
                                [label]="field_config_access['RMContactNumber']['label'] |translate"
                                [placeholder]="((field_config_access['RMContactNumber']['placeholder'])| translate)"
                                [required]="(field_config_access['RMContactNumber']['validators'] && field_config_access['RMContactNumber']['validators']['mandatory']?true:false)"
                                [readonly]="((field_config_access['RMContactNumber']['validators'] && field_config_access['RMContactNumber']['validators']['disable'] && field_config_access['RMContactNumber']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                                [pattern_desc]="(field_config_access['RMContactNumber']['validators'] &&
                                field_config_access['RMContactNumber']['validators']['finalPattern']) || '^[0-9]*$'"
                                >
                              </app-phone-number>
                            </div>
                          </div>

                          <div class="col-md-2" *ngIf="field_config_access['lastDrawnCTCCurrencyId']">
                            <tm-select
                              [options]=" masters[field_config_access['lastDrawnCTCCurrencyId']['masterPropName'] || 'currencyList' ] || []"
                              [form_group]="workHistory_form.get('previousEmployerDetails')"
                              form_control="lastDrawnCTCCurrencyId" title_property="title" id_property="id"
                              float_label="always"
                              [data]="workHistory_form.get('previousEmployerDetails').value.lastDrawnCTCCurrencyId"
                              [label_overflow]="1"
                              [label]="field_config_access['lastDrawnCTCCurrencyId']['label'] |translate"
                              [placeholder]="((field_config_access['lastDrawnCTCCurrencyId']['placeholder'])| translate)"
                              [mandatory]="(field_config_access['lastDrawnCTCCurrencyId']['validators'] && field_config_access['lastDrawnCTCCurrencyId']['validators']['mandatory']?true:false)"
                              [disabled]="((field_config_access['lastDrawnCTCCurrencyId']['validators'] && field_config_access['lastDrawnCTCCurrencyId']['validators']['disable'] && field_config_access['lastDrawnCTCCurrencyId']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                            </tm-select>
                          </div>
                          <div class="col-md-2" *ngIf="field_config_access['lastDrawnCTC']">
                            <mat-form-field floatLabel="always">
                              <mat-label>
                                {{field_config_access['lastDrawnCTC']['label'] |translate}}
                              </mat-label>
                              <input matInput formControlName="lastDrawnCTC" name="lastDrawnCTC" type="number"
                                [placeholder]="((field_config_access['lastDrawnCTC']['placeholder'])| translate)"
                                [required]="(field_config_access['lastDrawnCTC']['validators'] && field_config_access['lastDrawnCTC']['validators']['mandatory']?true:false)"
                                [minlength]="(field_config_access['lastDrawnCTC']['validators'] && field_config_access['lastDrawnCTC']['validators']['minLength'])"
                                [maxlength]="(field_config_access['lastDrawnCTC']['validators'] && field_config_access['lastDrawnCTC']['validators']['maxLength'])"
                                [readonly]="((field_config_access['lastDrawnCTC']['validators'] && field_config_access['lastDrawnCTC']['validators']['disable'] && field_config_access['lastDrawnCTC']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [pattern]="(field_config_access['lastDrawnCTC']['validators'] && field_config_access['lastDrawnCTC']['validators']['finalPattern'])" />
                              <mat-error
                                *ngIf="workHistory_form.get('previousEmployerDetails').get('lastDrawnCTC').invalid">
                                <ng-container
                                  *ngTemplateOutlet="error_message; context: {form_control:workHistory_form.get('previousEmployerDetails').get('lastDrawnCTC'),field_config_access:field_config_access['lastDrawnCTC']}">
                                </ng-container>
                              </mat-error>


                            </mat-form-field>
                          </div>

                        </div>
                      </form>
                    </mat-expansion-panel>




                  </mat-accordion>

                </div>

              </form>
            </ng-container>

            <ng-container *ngIf="section.id == 5">

              <form [formGroup]="ref_and_other_details_form">
                <div class="row">
                  <div class="col-md-12">
                    <mat-accordion class="example-headers-align" multi>

                      <mat-expansion-panel *ngIf="field_config_access['checklist']"
                        [disabled]="((field_config_access['checklist']['validators'] && field_config_access['checklist']['validators']['disable'] && field_config_access['checklist']['validators']['disable']!='0')?true:false)">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{ field_config_access['checklist']['label'] | translate}}
                          </mat-panel-title>
                          <mat-panel-description>


                          </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div [formGroup]="ref_and_other_details_form">

                          <div class="table-responsive" *ngIf="masters.checklist && masters.checklist.length">
                            <table class="table table-striped">
                              <thead>
                                <th class="col-md-6 col-width-100">
                                  {{ "ALERT.questions" | translate }}
                                </th>
                                <th class="col-md-3">
                                  {{ "ALERT.response" | translate }}
                                </th>


                              </thead>
                              <tbody>
                                <ng-container formArrayName="checklist"
                                  *ngFor="let question of ref_and_other_details_form.get('checklist')['controls']; let i = index;">
                                  <tr [formGroupName]="i">
                                    <td style="white-space: normal !important; vertical-align: middle;"
                                      [title]="question.title">
                                      <span class="multi-line-truncate-2">
                                        {{masters.checklist[i].title | translate}}
                                      </span>
                                    </td>
                                    <td style="vertical-align: middle;" *ngIf="masters.checklist[i].optionType == 1">
                                      <mat-radio-group formControlName="selectedOptionCode">
                                        <mat-radio-button class="mx-1" *ngFor="let item of masters.checklist[i].options"
                                          [value]="item.optionCode">
                                          {{item.title | translate}}
                                        </mat-radio-button>
                                      </mat-radio-group>
                                    </td>
                                    <td *ngIf="masters.checklist[i].optionType == 2 && false">
                                      <input type="text" disabled class="form-control"
                                        formControlName="inputAnswerOne" />
                                    </td>

                                    <td *ngIf="masters.checklist[i].optionType == 2">
                                      <input type="text" class="form-control" formControlName="inputAnswerTwo" />
                                    </td>
                                  </tr>
                                </ng-container>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </mat-expansion-panel>
                      <mat-expansion-panel *ngIf="field_config_access['primaryReferences']"
                        [disabled]="((field_config_access['primaryReferences']['validators'] && field_config_access['primaryReferences']['validators']['disable'] && field_config_access['primaryReferences']['validators']['disable']!='0')?true:false)">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{ field_config_access['primaryReferences']['label'] | translate}}
                          </mat-panel-title>
                          <mat-panel-description>


                          </mat-panel-description>
                        </mat-expansion-panel-header>

                        <form [formGroup]="primaryReferences">
                          <div class="row">

                            <div class="col-md-4" *ngIf="field_config_access['prFirstName']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['prFirstName']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="firstName" name="firstName"
                                  [placeholder]="((field_config_access['prFirstName']['placeholder'])| translate)"
                                  [required]="(field_config_access['prFirstName']['validators'] && field_config_access['prFirstName']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['prFirstName']['validators'] && field_config_access['prFirstName']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['prFirstName']['validators'] && field_config_access['prFirstName']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['prFirstName']['validators'] && field_config_access['prFirstName']['validators']['disable'] && field_config_access['prFirstName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['prFirstName']['validators'] && field_config_access['prFirstName']['validators']['finalPattern'])" />

                                <mat-error *ngIf="primaryReferences.get('firstName').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:primaryReferences.get('firstName'),field_config_access:field_config_access['prFirstName']}">
                                  </ng-container>
                                </mat-error>


                              </mat-form-field>
                            </div>

                            <div class="col-md-4" *ngIf="field_config_access['prLastName']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['prLastName']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="lastName" name="lastName"
                                  [placeholder]="((field_config_access['prLastName']['placeholder'])| translate)"
                                  [required]="(field_config_access['prLastName']['validators'] && field_config_access['prLastName']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['prLastName']['validators'] && field_config_access['prLastName']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['prLastName']['validators'] && field_config_access['prLastName']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['prLastName']['validators'] && field_config_access['prLastName']['validators']['disable'] && field_config_access['prLastName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['prLastName']['validators'] &&
                    field_config_access['prLastName']['validators']['finalPattern'])" />

                                <mat-error *ngIf="primaryReferences.get('lastName').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:primaryReferences.get('lastName'),field_config_access:field_config_access['prLastName']}">
                                  </ng-container>
                                </mat-error>


                              </mat-form-field>
                            </div>

                            <div class="col-md-4"
                              *ngIf="field_config_access['prMobileIsd'] && field_config_access['prMobileNumber']">
                              <div class="prefix-control" style="width: 35%;">
                                <tm-select
                                  [options]="masters[field_config_access['prMobileIsd']['masterPropName'] || 'isdCountryList'] || []"
                                  [form_group]="primaryReferences" form_control="mobileIsd" title_property="title"
                                  id_property="id" float_label="always" [data]="primaryReferences.value.mobileIsd"
                                  [label_overflow]="1" [label]="field_config_access['prMobileIsd']['label'] |translate"
                                  [placeholder]="((field_config_access['prMobileIsd']['placeholder'])| translate)"
                                  [mandatory]="(field_config_access['prMobileIsd']['validators'] && field_config_access['prMobileIsd']['validators']['mandatory']?true:false)"
                                  [disabled]="((field_config_access['prMobileIsd']['validators'] && field_config_access['prMobileIsd']['validators']['disable'] && field_config_access['prMobileIsd']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                                </tm-select>
                              </div>
                              <div class="main-control" style="width: 65%;">
                                <app-phone-number
                                  [options]="masters[field_config_access['prMobileIsd']['masterPropName'] || 'isdCountryList'] || []"
                                  [options_data]="primaryReferences.value.mobileIsd" [form]="primaryReferences"
                                  controlName="mobileNumber" [data]="primaryReferences.controls['mobileNumber'].value"
                                  [disabledDial]="1" [hide_label]="1"
                                  [label]="field_config_access['prMobileNumber']['label'] |translate"
                                  [placeholder]="((field_config_access['prMobileNumber']['placeholder'])| translate)"
                                  [required]="(field_config_access['prMobileNumber']['validators'] && field_config_access['prMobileNumber']['validators']['mandatory']?true:false)"
                                  [readonly]="((field_config_access['prMobileNumber']['validators'] && field_config_access['prMobileNumber']['validators']['disable'] && field_config_access['prMobileNumber']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                                  [pattern_desc]="(field_config_access['prMobileNumber']['validators'] &&
                                  field_config_access['prMobileNumber']['validators']['finalPattern'] )|| '^[0-9]*$'" >
                                </app-phone-number>
                              </div>
                            </div>

                            <div class="col-md-4" *ngIf="field_config_access['prAddress']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['prAddress']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="address" name="address"
                                  [placeholder]="((field_config_access['prAddress']['placeholder'])| translate)"
                                  [required]="(field_config_access['prAddress']['validators'] && field_config_access['prAddress']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['prAddress']['validators'] && field_config_access['prAddress']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['prAddress']['validators'] && field_config_access['prAddress']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['prAddress']['validators'] && field_config_access['prAddress']['validators']['disable'] && field_config_access['prAddress']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['prAddress']['validators'] &&
                    field_config_access['prAddress']['validators']['finalPattern'])" />

                                <mat-error *ngIf="primaryReferences.get('address').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:primaryReferences.get('address'),field_config_access:field_config_access['prAddress']}">
                                  </ng-container>
                                </mat-error>


                              </mat-form-field>
                            </div>

                            <div class="col-md-4" *ngIf="field_config_access['prEmailId']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['prEmailId']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="emailId" name="emailId"
                                  [placeholder]="((field_config_access['prEmailId']['placeholder'])| translate)"
                                  [required]="(field_config_access['prEmailId']['validators'] && field_config_access['prEmailId']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['prEmailId']['validators'] && field_config_access['prEmailId']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['prEmailId']['validators'] && field_config_access['prEmailId']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['prEmailId']['validators'] && field_config_access['prEmailId']['validators']['disable'] && field_config_access['prEmailId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['prEmailId']['validators'] &&
                                field_config_access['prEmailId']['validators']['finalPattern'])" />

                                <mat-error *ngIf="primaryReferences.get('emailId').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:primaryReferences.get('emailId'),field_config_access:field_config_access['prEmailId']}">
                                  </ng-container>
                                </mat-error>

                              </mat-form-field>
                            </div>

                            <div class="col-md-4" *ngIf="field_config_access['prCompanyName']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['prCompanyName']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="companyName" name="companyName"
                                  [placeholder]="((field_config_access['prCompanyName']['placeholder'])| translate)"
                                  [required]="(field_config_access['prCompanyName']['validators'] && field_config_access['prCompanyName']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['prCompanyName']['validators'] && field_config_access['prCompanyName']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['prCompanyName']['validators'] && field_config_access['prCompanyName']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['prCompanyName']['validators'] && field_config_access['prCompanyName']['validators']['disable'] && field_config_access['prCompanyName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['prCompanyName']['validators'] &&
                                            field_config_access['prCompanyName']['validators']['finalPattern'])" />

                                <mat-error *ngIf="primaryReferences.get('companyName').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:primaryReferences.get('companyName'),field_config_access:field_config_access['prCompanyName']}">
                                  </ng-container>
                                </mat-error>
                              </mat-form-field>
                            </div>

                            <div class="col-md-4" *ngIf="field_config_access['prDesignationId']">
                              <tm-select
                                [options]="masters[field_config_access['prDesignationId']['masterPropName'] || 'jobTitleList'] || []"
                                [form_group]="primaryReferences" form_control="designationId" title_property="title"
                                id_property="id" float_label="always" [data]="primaryReferences.value.designationId"
                                [label]="field_config_access['prDesignationId']['label'] |translate"
                                [placeholder]="((field_config_access['prDesignationId']['placeholder'])| translate)"
                                [mandatory]="(field_config_access['prDesignationId']['validators'] && field_config_access['prDesignationId']['validators']['mandatory']?true:false)"
                                [disabled]="((field_config_access['prDesignationId']['validators'] && field_config_access['prDesignationId']['validators']['disable'] && field_config_access['prDesignationId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [label_overflow]="1">
                              </tm-select>
                            </div>

                            <div class="col-md-12 text-right">
                              <button
                                (click)="addToTable(ref_and_other_details_form,'primaryReferences',primaryReferences)"
                                class="btn btn-sm mat-mt js-btn-save">
                                <i class="fa fa-plus-square mx-1"></i>
                                {{'BTN.add'|translate}}
                              </button>
                            </div>


                            <div class="col-md-12 table-responsive tm-data-table">
                              <table class="table table-striped "
                                *ngIf="ref_and_other_details_form.get('primaryReferences').value">
                                <thead>
                                  <tr>
                                    <th>
                                      {{field_config_access['prFirstName']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['prLastName']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['prMobileIsd']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['prAddress']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['prEmailId']['label'] |translate}}
                                    </th>

                                    <th>
                                      {{field_config_access['prCompanyName']['label'] |translate}}
                                    </th>

                                    <th>
                                      {{field_config_access['prDesignationId']['label'] |translate}}
                                    </th>

                                    <th class="text-center">
                                      Action
                                    </th>
                                  </tr>

                                </thead>
                                <tbody>
                                  <tr
                                    *ngFor="let item of ref_and_other_details_form.get('primaryReferences').value  || [];let i = index">
                                    <td>{{item.firstName }}
                                    </td>
                                    <td>
                                      {{ item.lastName }}
                                    </td>

                                    <td>
                                      {{ item.mobileIsd | DynamicPipe
                                      : masters[field_config_access['prMobileIsd']['masterPropName'] ||
                                      'isdCountryList'] || []:'id':'title'}} {{item.mobileIsd}}
                                    </td>


                                    <td>
                                      {{ item.address }}
                                    </td>



                                    <td>
                                      {{ item.emailId }}
                                    </td>

                                    <td>
                                      {{ item.companyName }}
                                    </td>

                                    <td>
                                      {{ item.designationId | DynamicPipe
                                      : masters[field_config_access['collegeCode']['masterPropName'] ||
                                      'jobTitleList'] || []:'id':'title' }}
                                    </td>


                                    <td class="text-center">
                                      <button class="btn btn-sm btn-default mx-1 "
                                        (click)="editTableItem(i,ref_and_other_details_form,'primaryReferences',primaryReferences)">
                                        <i class="fa fa-pencil mx-1"></i>
                                        {{'BTN.edit'|translate}}
                                      </button>
                                      <button class="btn btn-sm btn-default mx-1 "
                                        (click)="deleteTableItem(i,ref_and_other_details_form,'primaryReferences',primaryReferences)">
                                        <i class="fa fa-trash orange mx-1"></i>
                                        {{'BTN.delete'|translate}}
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </form>

                      </mat-expansion-panel>

                      <mat-expansion-panel *ngIf="field_config_access['secondaryReferences']"
                        [disabled]="((field_config_access['secondaryReferences']['validators'] && field_config_access['secondaryReferences']['validators']['disable'] && field_config_access['secondaryReferences']['validators']['disable']!='0')?true:false)">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{ field_config_access['secondaryReferences']['label'] | translate}}
                          </mat-panel-title>
                          <mat-panel-description>


                          </mat-panel-description>
                        </mat-expansion-panel-header>

                        <form [formGroup]="secondaryReferences">
                          <div class="row">

                            <div class="col-md-4" *ngIf="field_config_access['srFirstName']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['srFirstName']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="firstName" name="firstName"
                                  [placeholder]="((field_config_access['srFirstName']['placeholder'])| translate)"
                                  [required]="(field_config_access['srFirstName']['validators'] && field_config_access['srFirstName']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['srFirstName']['validators'] && field_config_access['srFirstName']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['srFirstName']['validators'] && field_config_access['srFirstName']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['srFirstName']['validators'] && field_config_access['srFirstName']['validators']['disable'] && field_config_access['srFirstName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['srFirstName']['validators'] &&
                          field_config_access['srFirstName']['validators']['finalPattern'])" />

                                <mat-error *ngIf="secondaryReferences.get('firstName').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:secondaryReferences.get('firstName'),field_config_access:field_config_access['srFirstName']}">
                                  </ng-container>
                                </mat-error>


                              </mat-form-field>
                            </div>

                            <div class="col-md-4" *ngIf="field_config_access['srLastName']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['srLastName']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="lastName" name="lastName"
                                  [placeholder]="((field_config_access['srLastName']['placeholder'])| translate)"
                                  [required]="(field_config_access['srLastName']['validators'] && field_config_access['srLastName']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['srLastName']['validators'] && field_config_access['srLastName']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['srLastName']['validators'] && field_config_access['srLastName']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['srLastName']['validators'] && field_config_access['srLastName']['validators']['disable'] && field_config_access['srLastName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['srLastName']['validators'] &&
                          field_config_access['srLastName']['validators']['finalPattern'])" />

                                <mat-error *ngIf="secondaryReferences.get('lastName').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:secondaryReferences.get('lastName'),field_config_access:field_config_access['srLastName']}">
                                  </ng-container>
                                </mat-error>


                              </mat-form-field>
                            </div>

                            <div class="col-md-4"
                              *ngIf="field_config_access['srMobileIsd'] && field_config_access['srMobileNumber']">
                              <div class="prefix-control" style="width: 35%;">
                                <tm-select
                                  [options]="masters[field_config_access['srMobileIsd']['masterPropName'] || 'isdCountryList'] || []"
                                  [form_group]="secondaryReferences" form_control="mobileIsd" title_property="title"
                                  id_property="id" float_label="always" [data]="secondaryReferences.value.mobileIsd"
                                  [label_overflow]="1" [label]="field_config_access['srMobileIsd']['label'] |translate"
                                  [placeholder]="((field_config_access['srMobileIsd']['placeholder'])| translate)"
                                  [mandatory]="(field_config_access['srMobileIsd']['validators'] && field_config_access['srMobileIsd']['validators']['mandatory']?true:false)"
                                  [disabled]="((field_config_access['srMobileIsd']['validators'] && field_config_access['srMobileIsd']['validators']['disable'] && field_config_access['srMobileIsd']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                                </tm-select>
                              </div>
                              <div class="main-control" style="width: 65%;">
                                <app-phone-number
                                  [options]="masters[field_config_access['srMobileIsd']['masterPropName'] || 'isdCountryList'] || []"
                                  [options_data]="secondaryReferences.value.mobileIsd" [form]="secondaryReferences"
                                  controlName="mobileNumber" [data]="secondaryReferences.controls['mobileNumber'].value"
                                  [disabledDial]="1" [hide_label]="1"
                                  [label]="field_config_access['srMobileNumber']['label'] |translate"
                                  [placeholder]="((field_config_access['srMobileNumber']['placeholder'])| translate)"
                                  [required]="(field_config_access['srMobileNumber']['validators'] && field_config_access['srMobileNumber']['validators']['mandatory']?true:false)"
                                  [readonly]="((field_config_access['srMobileNumber']['validators'] && field_config_access['srMobileNumber']['validators']['disable'] && field_config_access['srMobileNumber']['validators']['disable']!='0')?true:false) ||disabled_fields ">
                                  [pattern_desc]="(field_config_access['srMobileNumber']['validators'] &&
                                  field_config_access['srMobileNumber']['validators']['finalPattern'] )|| '^[0-9]*$'" >
                                </app-phone-number>
                              </div>
                            </div>

                            <div class="col-md-4" *ngIf="field_config_access['srAddress']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['srAddress']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="address" name="address"
                                  [placeholder]="((field_config_access['srAddress']['placeholder'])| translate)"
                                  [required]="(field_config_access['srAddress']['validators'] && field_config_access['srAddress']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['srAddress']['validators'] && field_config_access['srAddress']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['srAddress']['validators'] && field_config_access['srAddress']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['srAddress']['validators'] && field_config_access['srAddress']['validators']['disable'] && field_config_access['srAddress']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['srAddress']['validators'] &&
                          field_config_access['srAddress']['validators']['finalPattern'])" />

                                <mat-error *ngIf="secondaryReferences.get('address').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:secondaryReferences.get('address'),field_config_access:field_config_access['srAddress']}">
                                  </ng-container>
                                </mat-error>


                              </mat-form-field>
                            </div>

                            <div class="col-md-4" *ngIf="field_config_access['srEmailId']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['srEmailId']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="emailId" name="emailId"
                                  [placeholder]="((field_config_access['srEmailId']['placeholder'])| translate)"
                                  [required]="(field_config_access['srEmailId']['validators'] && field_config_access['srEmailId']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['srEmailId']['validators'] && field_config_access['srEmailId']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['srEmailId']['validators'] && field_config_access['srEmailId']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['srEmailId']['validators'] && field_config_access['srEmailId']['validators']['disable'] && field_config_access['srEmailId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['srEmailId']['validators'] &&
                                field_config_access['srEmailId']['validators']['finalPattern'])" />

                                <mat-error *ngIf="secondaryReferences.get('emailId').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:secondaryReferences.get('emailId'),field_config_access:field_config_access['srEmailId']}">
                                  </ng-container>
                                </mat-error>

                              </mat-form-field>
                            </div>

                            <div class="col-md-4" *ngIf="field_config_access['srCompanyName']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['srCompanyName']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="companyName" name="companyName"
                                  [placeholder]="((field_config_access['srCompanyName']['placeholder'])| translate)"
                                  [required]="(field_config_access['srCompanyName']['validators'] && field_config_access['srCompanyName']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['srCompanyName']['validators'] && field_config_access['srCompanyName']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['srCompanyName']['validators'] && field_config_access['srCompanyName']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['srCompanyName']['validators'] && field_config_access['srCompanyName']['validators']['disable'] && field_config_access['srCompanyName']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['srCompanyName']['validators'] &&
                                            field_config_access['srCompanyName']['validators']['finalPattern'])" />

                                <mat-error *ngIf="secondaryReferences.get('companyName').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:secondaryReferences.get('companyName'),field_config_access:field_config_access['srCompanyName']}">
                                  </ng-container>
                                </mat-error>
                              </mat-form-field>
                            </div>

                            <div class="col-md-4" *ngIf="field_config_access['srDesignationId']">
                              <tm-select
                                [options]="masters[field_config_access['srDesignationId']['masterPropName'] || 'jobTitleList'] || []"
                                [form_group]="secondaryReferences" form_control="designationId" title_property="title"
                                id_property="id" float_label="always" [data]="secondaryReferences.value.designationId"
                                [label]="field_config_access['srDesignationId']['label'] |translate"
                                [placeholder]="((field_config_access['srDesignationId']['placeholder'])| translate)"
                                [mandatory]="(field_config_access['srDesignationId']['validators'] && field_config_access['srDesignationId']['validators']['mandatory']?true:false)"
                                [disabled]="((field_config_access['srDesignationId']['validators'] && field_config_access['srDesignationId']['validators']['disable'] && field_config_access['srDesignationId']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                [label_overflow]="1">
                              </tm-select>
                            </div>

                            <div class="col-md-12 text-right">
                              <button
                                (click)="addToTable(ref_and_other_details_form,'secondaryReferences',secondaryReferences)"
                                class="btn btn-sm mat-mt js-btn-save">
                                <i class="fa fa-plus-square mx-1"></i>
                                {{'BTN.add'|translate}}
                              </button>
                            </div>


                            <div class="col-md-12 table-responsive tm-data-table">
                              <table class="table table-striped "
                                *ngIf="ref_and_other_details_form.get('secondaryReferences').value">
                                <thead>
                                  <tr>
                                    <th>
                                      {{field_config_access['srFirstName']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['srLastName']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['srMobileIsd']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['srAddress']['label'] |translate}}
                                    </th>
                                    <th>
                                      {{field_config_access['srEmailId']['label'] |translate}}
                                    </th>

                                    <th>
                                      {{field_config_access['srCompanyName']['label'] |translate}}
                                    </th>

                                    <th>
                                      {{field_config_access['srDesignationId']['label'] |translate}}
                                    </th>

                                    <th class="text-center">
                                      Action
                                    </th>
                                  </tr>

                                </thead>
                                <tbody>
                                  <tr
                                    *ngFor="let item of ref_and_other_details_form.get('secondaryReferences').value  || [];let i = index">
                                    <td>{{item.firstName }}
                                    </td>
                                    <td>
                                      {{ item.lastName }}
                                    </td>

                                    <td>
                                      {{ item.mobileIsd | DynamicPipe
                                      : masters[field_config_access['srMobileIsd']['masterPropName'] ||
                                      'isdCountryList'] || []:'id':'title'}} {{item.mobileIsd}}
                                    </td>


                                    <td>
                                      {{ item.address }}
                                    </td>



                                    <td>
                                      {{ item.emailId }}
                                    </td>

                                    <td>
                                      {{ item.companyName }}
                                    </td>

                                    <td>
                                      {{ item.designationId | DynamicPipe
                                      : masters[field_config_access['collegeCode']['masterPropName'] ||
                                      'jobTitleList'] || []:'id':'title' }}
                                    </td>


                                    <td class="text-center">
                                      <button class="btn btn-sm btn-default mx-1 "
                                        (click)="editTableItem(i,ref_and_other_details_form,'secondaryReferences',secondaryReferences)">
                                        <i class="fa fa-pencil mx-1"></i>
                                        {{'BTN.edit'|translate}}
                                      </button>
                                      <button class="btn btn-sm btn-default mx-1 "
                                        (click)="deleteTableItem(i,ref_and_other_details_form,'secondaryReferences',secondaryReferences)">
                                        <i class="fa fa-trash orange mx-1"></i>
                                        {{'BTN.delete'|translate}}
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </form>



                      </mat-expansion-panel>

                      <mat-expansion-panel *ngIf="field_config_access['otherDetails']"
                        [disabled]="((field_config_access['otherDetails']['validators'] && field_config_access['otherDetails']['validators']['disable'] && field_config_access['assessment']['validators']['disable']!='0')?true:false)">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{ field_config_access['otherDetails']['label'] | translate}}
                          </mat-panel-title>
                          <mat-panel-description>


                          </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div [formGroup]="ref_and_other_details_form">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="table-responsive"
                                *ngIf="masters.assessmentList && masters.assessmentList.length">
                                <table class="table table-striped">
                                  <thead>
                                    <th class="col-md-6 col-width-100">
                                      {{ "ALERT.questions" | translate }}
                                    </th>
                                    <th class="col-md-3">
                                      {{ "ALERT.response" | translate }}
                                    </th>
                                  </thead>
                                  <tbody>
                                    <ng-container formArrayName="assessment"
                                      *ngFor="let question of ref_and_other_details_form.get('assessment')['controls']; let i = index;">
                                      <tr [formGroupName]="i">
                                        <td style="white-space: normal !important; vertical-align: middle;"
                                          [title]="question.title">
                                          <span class="multi-line-truncate-2">
                                            {{masters.assessmentList[i].title | translate}}
                                          </span>
                                        </td>
                                        <td style="vertical-align: middle;">
                                          <mat-radio-group formControlName="optionCode">
                                            <mat-radio-button class="mx-1"
                                              *ngFor="let item of masters.assessmentList[i].options"
                                              [value]="item.optionCode">
                                              {{item.title | translate}}
                                            </mat-radio-button>
                                          </mat-radio-group>
                                        </td>
                                        <td *ngIf="masters.assessmentList[i].optionType == 2">
                                          <input type="text" class="form-control" formControlName="inputAnswer" />
                                        </td>
                                      </tr>
                                    </ng-container>
                                  </tbody>
                                </table>
                              </div>

                            </div>
                            <div class="col-md-6" *ngIf="field_config_access['extraCurrActivities']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['extraCurrActivities']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="extraCurrActivities" name="extraCurrActivities"
                                  [placeholder]="((field_config_access['extraCurrActivities']['placeholder'])| translate)"
                                  [required]="(field_config_access['extraCurrActivities']['validators'] && field_config_access['extraCurrActivities']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['extraCurrActivities']['validators'] && field_config_access['extraCurrActivities']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['extraCurrActivities']['validators'] && field_config_access['extraCurrActivities']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['extraCurrActivities']['validators'] && field_config_access['extraCurrActivities']['validators']['disable'] && field_config_access['extraCurrActivities']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['extraCurrActivities']['validators'] &&
  field_config_access['extraCurrActivities']['validators']['finalPattern'])" />

                                <mat-error *ngIf="ref_and_other_details_form.get('extraCurrActivities').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:ref_and_other_details_form.get('extraCurrActivities'),field_config_access:field_config_access['extraCurrActivities']}">
                                  </ng-container>
                                </mat-error>
                              </mat-form-field>
                            </div>

                            <div class="col-md-6" *ngIf="field_config_access['favFood']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['favFood']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="favFood" name="favFood"
                                  [placeholder]="((field_config_access['favFood']['placeholder'])| translate)"
                                  [required]="(field_config_access['favFood']['validators'] && field_config_access['favFood']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['favFood']['validators'] && field_config_access['favFood']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['favFood']['validators'] && field_config_access['favFood']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['favFood']['validators'] && field_config_access['favFood']['validators']['disable'] && field_config_access['favFood']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['favFood']['validators'] &&
                              field_config_access['favFood']['validators']['finalPattern'])" />

                                <mat-error *ngIf="ref_and_other_details_form.get('favFood').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:ref_and_other_details_form.get('favFood'),field_config_access:field_config_access['favFood']}">
                                  </ng-container>
                                </mat-error>
                              </mat-form-field>
                            </div>

                            <div class="col-md-6" *ngIf="field_config_access['favQuoteWithAuthor']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['favQuoteWithAuthor']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="favQuoteWithAuthor" name="favQuoteWithAuthor"
                                  [placeholder]="((field_config_access['favQuoteWithAuthor']['placeholder'])| translate)"
                                  [required]="(field_config_access['favQuoteWithAuthor']['validators'] && field_config_access['favQuoteWithAuthor']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['favQuoteWithAuthor']['validators'] && field_config_access['favQuoteWithAuthor']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['favQuoteWithAuthor']['validators'] && field_config_access['favQuoteWithAuthor']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['favQuoteWithAuthor']['validators'] && field_config_access['favQuoteWithAuthor']['validators']['disable'] && field_config_access['favQuoteWithAuthor']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['favQuoteWithAuthor']['validators'] &&
                              field_config_access['favQuoteWithAuthor']['validators']['finalPattern'])" />

                                <mat-error *ngIf="ref_and_other_details_form.get('favQuoteWithAuthor').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:ref_and_other_details_form.get('favQuoteWithAuthor'),field_config_access:field_config_access['favQuoteWithAuthor']}">
                                  </ng-container>
                                </mat-error>
                              </mat-form-field>
                            </div>
                            <div class="col-md-6" *ngIf="field_config_access['favHobbies']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['favHobbies']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="favHobbies" name="favHobbies"
                                  [placeholder]="((field_config_access['favHobbies']['placeholder'])| translate)"
                                  [required]="(field_config_access['favHobbies']['validators'] && field_config_access['favHobbies']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['favHobbies']['validators'] && field_config_access['favHobbies']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['favHobbies']['validators'] && field_config_access['favHobbies']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['favHobbies']['validators'] && field_config_access['favHobbies']['validators']['disable'] && field_config_access['favHobbies']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['favHobbies']['validators'] &&
                              field_config_access['favHobbies']['validators']['finalPattern'])" />

                                <mat-error *ngIf="ref_and_other_details_form.get('favHobbies').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:ref_and_other_details_form.get('favHobbies'),field_config_access:field_config_access['favHobbies']}">
                                  </ng-container>
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      </mat-expansion-panel>
                      <mat-expansion-panel *ngIf="field_config_access['describeWhyWorkWithUsLabel']"
                        [disabled]="((field_config_access['describeWhyWorkWithUsLabel']['validators'] && field_config_access['describeWhyWorkWithUsLabel']['validators']['disable'] && field_config_access['describeWhyWorkWithUsLabel']['validators']['disable']!='0')?true:false)">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{ field_config_access['describeWhyWorkWithUsLabel']['label'] | translate}}
                          </mat-panel-title>

                        </mat-expansion-panel-header>
                        <div class="row">
                          <div class="col-md-12" *ngIf="field_config_access['describeWhyWorkWithUs']">

                            <app-html-text-editor [form]="ref_and_other_details_form"
                              controlName='describeWhyWorkWithUs'
                              [label]="field_config_access['describeWhyWorkWithUs']['label'] |translate"
                              [required]="(field_config_access['describeWhyWorkWithUs']['validators'] && field_config_access['describeWhyWorkWithUs']['validators']['mandatory']?true:false)">
                            </app-html-text-editor>

                          </div>


                        </div>

                      </mat-expansion-panel>


                      <mat-expansion-panel *ngIf="field_config_access['personalSW']"
                        [disabled]="((field_config_access['personalSW']['validators'] && field_config_access['personalSW']['validators']['disable'] && field_config_access['personalSW']['validators']['disable']!='0')?true:false)">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{ field_config_access['personalSW']['label'] | translate}}
                          </mat-panel-title>
                          <mat-panel-description>

                          </mat-panel-description>
                        </mat-expansion-panel-header>

                        <form [formGroup]="personalSW">
                          <div class="row">
                            <div class="col-md-5" *ngIf="field_config_access['pswTitle']">
                              <mat-form-field floatLabel="always">
                                <mat-label>
                                  {{field_config_access['pswTitle']['label'] |translate}}
                                </mat-label>
                                <input matInput formControlName="title" name="title"
                                  [placeholder]="((field_config_access['pswTitle']['placeholder'])| translate)"
                                  [required]="(field_config_access['pswTitle']['validators'] && field_config_access['pswTitle']['validators']['mandatory']?true:false)"
                                  [minlength]="(field_config_access['pswTitle']['validators'] && field_config_access['pswTitle']['validators']['minLength'])"
                                  [maxlength]="(field_config_access['pswTitle']['validators'] && field_config_access['pswTitle']['validators']['maxLength'])"
                                  [readonly]="((field_config_access['pswTitle']['validators'] && field_config_access['pswTitle']['validators']['disable'] && field_config_access['pswTitle']['validators']['disable']!='0')?true:false) ||disabled_fields "
                                  [pattern]="(field_config_access['pswTitle']['validators'] &&
                    field_config_access['pswTitle']['validators']['finalPattern'])" />

                                <mat-error *ngIf="personalSW.get('title').invalid">
                                  <ng-container
                                    *ngTemplateOutlet="error_message; context: {form_control:personalSW.get('title'),field_config_access:field_config_access['pswTitle']}">
                                  </ng-container>
                                </mat-error>
                              </mat-form-field>
                            </div>

                            <div class="col-md-7" *ngIf="field_config_access['rating']">
                              <mat-star-rating [form_group]="personalSW" [form_control]="'rating'"
                                [rating]="this.personalSW.value.rating ||1">
                              </mat-star-rating>
                            </div>



                            <div class="col-md-12 text-right">
                              <button (click)="addToTable(ref_and_other_details_form,'personalSW',personalSW)"
                                class="btn btn-sm mat-mt js-btn-save">
                                <i class="fa fa-plus-square mx-1"></i>
                                {{'BTN.add'|translate}}
                              </button>
                            </div>


                            <div class="col-md-12 table-responsive tm-data-table">
                              <table class="table table-striped "
                                *ngIf="ref_and_other_details_form.get('personalSW').value">
                                <thead>
                                  <tr>

                                    <th>
                                      {{field_config_access['pswTitle']['label'] |translate}}
                                    </th>

                                    <th>
                                      {{ field_config_access['rating']['label'] }}
                                    </th>

                                    <th class="text-center">
                                      Action
                                    </th>
                                  </tr>

                                </thead>
                                <tbody>
                                  <tr
                                    *ngFor="let item of ref_and_other_details_form.get('personalSW').value  || [];let i = index">

                                    <td>
                                      {{ item.title}}
                                    </td>

                                    <td>
                                      <mat-star-rating [rating]="item.rating ||1 " disabled>
                                      </mat-star-rating>
                                    </td>

                                    <td class="text-center">
                                      <button class="btn btn-sm btn-default mx-1 "
                                        (click)="editTableItem(i,ref_and_other_details_form,'personalSW',personalSW)">
                                        <i class="fa fa-pencil mx-1"></i>
                                        {{'BTN.edit'|translate}}
                                      </button>
                                      <button class="btn btn-sm btn-default mx-1 "
                                        (click)="deleteTableItem(i,ref_and_other_details_form,'personalSW',personalSW)">
                                        <i class="fa fa-trash orange mx-1"></i>
                                        {{'BTN.delete'|translate}}
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </form>
                      </mat-expansion-panel>


                    </mat-accordion>

                  </div>
                </div>
              </form>
            </ng-container>

            <ng-container *ngIf="section.id == 6">
              <form [formGroup]="extendedData">
                <div class="row"
                  *ngIf="masters.extendedData && masters.extendedData.length && field_config_access['onboarding_documents']">
                  <ng-container formArrayName="extendedData"
                    *ngFor="let question of extendedData.get('extendedData')['controls']; let i = index;">
                    <div [formGroupName]="i" class="col-md-6">

                      <tm-files-v2 [form_group]="extendedData.get('extendedData')['controls'][i]"
                        [form_control]="'attachValue'"
                        [result]="(extendedData.get('extendedData')['controls'][i].value.attachValue)"
                        [label]="masters.extendedData[i].title" [multiple]="1"
                        [disabled]="((masters.extendedData[i] && masters.extendedData[i]['UIValidationObjStruct'] && (masters.extendedData[i]['UIValidationObjStruct']['downloadOnly'] && masters.extendedData[i]['UIValidationObjStruct']['downloadOnly'].value == 1)) ? 1 :0) || disabled_fields"
                        [required]="(masters.extendedData[i] && masters.extendedData[i]['UIValidationObjStruct'] && (masters.extendedData[i]['UIValidationObjStruct']['mandatory'] && masters.extendedData[i]['UIValidationObjStruct']['mandatory'].value == 1)) ? true:false"
                        [UIValidationObjStruct]="masters.extendedData[i]['UIValidationObjStruct']"
                        [sample_download_ref_label]="masters.extendedData[i].attachLabel"
                        [sample_download_ref]="masters.extendedData[i] && masters.extendedData[i].masterAttachment && masters.extendedData[i].masterAttachment[0] ?masters.extendedData[i].masterAttachment[0]:null ">
                      </tm-files-v2>
                    </div>

                  </ng-container>
                </div>
                <div class="row" *ngIf="masters.offerDocuments && masters.offerDocuments.length">
                  <ng-container formArrayName="offerDocuments"
                    *ngFor="let question of extendedData.get('offerDocuments')['controls']; let i = index;">
                    <div [formGroupName]="i" class="col-md-6">
                      <tm-files-v2 [form_group]="extendedData.get('offerDocuments')['controls'][i]"
                        [form_control]="'attachValue'"
                        [result]="(extendedData.get('offerDocuments')['controls'][i].value.attachValue)"
                        [label]="masters.offerDocuments[i].title" [multiple]="1"
                        [disabled]="((masters.offerDocuments[i] && masters.offerDocuments[i]['UIValidationObjStruct'] && (masters.offerDocuments[i]['UIValidationObjStruct']['downloadOnly'] && masters.offerDocuments[i]['UIValidationObjStruct']['downloadOnly'].value == 1)) ? 1 :0) || disabled_fields"
                        [required]="(masters.offerDocuments[i] && masters.offerDocuments[i]['UIValidationObjStruct'] && (masters.offerDocuments[i]['UIValidationObjStruct']['mandatory'] && masters.offerDocuments[i]['UIValidationObjStruct']['mandatory'].value == 1)) ? true:false"
                        [UIValidationObjStruct]="masters.offerDocuments[i]['UIValidationObjStruct']"
                        [sample_download_ref_label]="masters.offerDocuments[i].attachLabel"
                        [sample_download_ref]="masters.offerDocuments[i] && masters.offerDocuments[i].masterAttachment && masters.offerDocuments[i].masterAttachment[0] ?masters.offerDocuments[i].masterAttachment[0]:null ">
                      </tm-files-v2>
                    </div>
                  </ng-container>
                </div>
              </form>
            </ng-container>

            <ng-container *ngIf="section.id == 7">
              <form [formGroup]="declaration_form">
                <div class="row">
                  <div class="col-md-12">

                    <div class="form-check">
                      <label class="form-check-label" for="exampleCheck1">
                        <span [innerHTML]="field_config_access['declaration']['label']"></span>
                      </label>
                      <app-checkbox [form]="declaration_form" [controlName]="declaration"
                        [label]="'I hereby accept above statement'"
                        [disabled]="((field_config_access['declaration']['validators'] && field_config_access['declaration']['validators']['disable'] && field_config_access['declaration']['validators']['disable']!='0')?true:false) ||disabled_fields"
                        [required]="(field_config_access['declaration']['validators'] && field_config_access['declaration']['validators']['mandatory']?true:false)">
                      </app-checkbox>
                    </div>
                  </div>

                  <div class="col-md-3">

                  </div>

                  <div class="col-md-3 align-self-center">
                    <div class="d-flex">
                      <dt class="lbl">Date : </dt>

                      <dd class="val"> {{(declaration_form.value.declarationDt ? declaration_form.value.declarationDt :
                        current_date)
                        | UtcToLocalTime | date: 'dd-MMM-yyyy' }}
                      </dd>
                    </div>
                  </div>

                  <div class="col-md-3 align-self-center">
                    <div class="d-flex">
                      <dt class="lbl"> Place : </dt>

                      <dd class="val">
                        {{(declaration_form.value.declarationPlace ? declaration_form.value.declarationPlace : ip.city)
                        }}
                      </dd>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div *ngIf="!disabled_fields" style="text-align: center">
                      <ng-container *ngIf="sign_upload_type == 1 || !sign_upload_type;">
                        <app-digital-signature form_control="declarationSignature" [form_group]="declaration_form"
                          [label]="field_config_access['declarationSignature']['label']"
                          [placeholder]="field_config_access['declarationSignature']['placeholder']" width="100%"
                          [disabled]="((field_config_access['declarationSignature']['validators'] && field_config_access['declarationSignature']['validators']['disable'] && field_config_access['declarationSignature']['validators']['disable']!='0')?true:false) ||disabled_fields"
                          [height]="150">
                        </app-digital-signature>
                      </ng-container>
                      <ng-container *ngIf="sign_upload_type == 2;">
                        <app-file-upload-and-preview form_control="declarationSignature" [form_group]="declaration_form"
                          [label]="field_config_access['declarationSignature']['label']"
                          [placeholder]="field_config_access['declarationSignature']['placeholder']" width="100%"
                          [disabled]="((field_config_access['declarationSignature']['validators'] && field_config_access['declarationSignature']['validators']['disable'] && field_config_access['declarationSignature']['validators']['disable']!='0')?true:false) ||disabled_fields"
                          width="100%" [height]="150">
                        </app-file-upload-and-preview>
                      </ng-container>

                      <div class="link mb-2 text-center" (click)="toggleSignatureType()">
                        {{
                        (sign_upload_type && sign_upload_type == 2 ?'OFFER.digital_sign' : 'OFFER.upload_sign')
                        | translate
                        }}
                      </div>
                    </div>

                    <div *ngIf="disabled_fields" style="text-align: center">

                      <app-file-upload-and-preview form_control="declarationSignature" [form_group]="declaration_form"
                        [label]="field_config_access['declarationSignature']['label']"
                        [placeholder]="field_config_access['declarationSignature']['placeholder']" width="100%"
                        [disabled]="((field_config_access['declarationSignature']['validators'] && field_config_access['declarationSignature']['validators']['disable'] && field_config_access['declarationSignature']['validators']['disable']!='0')?true:false) ||disabled_fields"
                        width="100%" [height]="150">
                      </app-file-upload-and-preview>


                      <div class="link mb-2 text-center" (click)="toggleSignatureType()" *ngIf="!disable_action">
                        {{
                        (sign_upload_type && sign_upload_type == 2 ?'OFFER.digital_sign' : 'OFFER.upload_sign')
                        |translate
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </form>

            </ng-container>

            <ng-container *ngIf="section.id == 8">
              <form [formGroup]="otherDetailsSection">
                <div class="row">

                  <div class="col-md-4" *ngIf="field_config_access['division']">
                    <tm-select
                      [options]="masters[field_config_access['division']['masterPropName'] || 'divisionList'] || []"
                      [form_group]="otherDetailsSection" form_control="division" title_property="title" id_property="id"
                      float_label="always" [label]="field_config_access['division']['label'] |translate"
                      [data]="otherDetailsSection.value.division"
                      [placeholder]="((field_config_access['division']['placeholder'])| translate)"
                      [label_overflow]="1">
                    </tm-select>
                  </div>
                  <div class="col-md-4" *ngIf="field_config_access['bandId']">
                    <tm-select [options]="masters[field_config_access['bandId']['masterPropName'] || 'bandList'] || []"
                      [form_group]="otherDetailsSection" form_control="bandId" title_property="title" id_property="id"
                      float_label="always" [label]="field_config_access['bandId']['label'] |translate"
                      [data]="otherDetailsSection.value.bandId"
                      [placeholder]="((field_config_access['bandId']['placeholder'])| translate)" [label_overflow]="1">
                    </tm-select>
                  </div>

                  <div class="col-md-4" *ngIf="field_config_access['offerAcceptanceExpiryDate']">
                    <tm-date-picker [form]="otherDetailsSection" [controlName]="'offerAcceptanceExpiryDate'"
                      [placeholder]="((field_config_access['offerAcceptanceExpiryDate']['placeholder']) | translate) "
                      [label]="field_config_access['offerAcceptanceExpiryDate']['label'] |translate"
                      [value]="otherDetailsSection.value.offerAcceptanceExpiryDate"
                      [minValue]="(field_config_access['offerAcceptanceExpiryDate']['validators'] && field_config_access['offerAcceptanceExpiryDate']['validators']['minValue'])"
                      [maxValue]="(field_config_access['offerAcceptanceExpiryDate']['validators'] && field_config_access['offerAcceptanceExpiryDate']['validators']['maxValue'])">
                      [required]="(field_config_access['offerAcceptanceExpiryDate']['validators'] &&
                      field_config_access['offerAcceptanceExpiryDate']['validators']['mandatory']?true:false)"
                      [disabled]="((field_config_access['offerAcceptanceExpiryDate']['validators'] &&
                      field_config_access['offerAcceptanceExpiryDate']['validators']['disable'] &&
                      field_config_access['offerAcceptanceExpiryDate']['validators']['disable'] != '0')?true:false)
                      ||disabled_fields " [consider_time]="1"

                    </tm-date-picker>
                  </div>

                </div>

              </form>
            </ng-container>


          </div>
          <div class="row mt-3">
            <div class="col-md-12 text-right form-group">
              <button style="min-width: 100px;" class="ml-auto  btn-sm blob-btn-cancel btn mx-1 mx-1 tallite-action"
                matStepperPrevious *ngIf="stepper.selectedIndex !=0">
                {{ 'BTN.previous' | translate}}
                <span class="blob-btn-cancel__inner">
                  <span class="blob-btn-cancel__blobs">
                    <span class="blob-btn-cancel__blob"></span>
                    <span class="blob-btn-cancel__blob"></span>
                    <span class="blob-btn-cancel__blob"></span>
                    <span class="blob-btn-cancel__blob"></span>
                  </span>
                </span>
              </button>

              <button style="min-width: 100px;" class="blob-btn btn-sm  btn   mx-1 tallite-action my-auto"
                (click)="saveDetails(section,stepper.selectedIndex == stepper.steps.length -1)" type="submit">
                {{ stepper.selectedIndex == stepper.steps.length -1 ? ('BTN.save' | translate) :
                ('BTN.saveBTN' | translate) }}
                <span class="blob-btn__inner">
                  <span class="blob-btn__blobs">
                    <span class="blob-btn__blob"></span>
                    <span class="blob-btn__blob"></span>
                    <span class="blob-btn__blob"></span>
                    <span class="blob-btn__blob"></span>
                  </span>
                </span>
              </button>
            </div>
          </div>
        </ng-template>

      </mat-step>
    </ng-container>
  </mat-stepper>


</div>

<div *ngIf="!field_config_access" class="text-center mt-3">
  <i class="fa fa-spinner fa-spin"></i> Loading
</div>

<ng-template #error_message let-form_control="form_control" let-field_config_access="field_config_access">

  <ng-container *ngIf="form_control.hasError('required'); else min">
    <span
      *ngIf="field_config_access['validators'] && field_config_access['validators']['mandatoryErrorMessage'];else mandatory_static_msg">
      {{field_config_access['validators']['mandatoryErrorMessage'] | translate}}
    </span>
    <ng-template #mandatory_static_msg>
      <span>
        {{'ERROR.field_is_mandatory' | translate}}
      </span>
    </ng-template>

  </ng-container>
  <ng-template #min>
    <ng-container *ngIf="form_control.hasError('min'); else max">

      <span
        *ngIf="field_config_access['validators'] && field_config_access['validators']['minValueErrorMessage'];else min_static_msg">
        {{field_config_access['validators']['minValueErrorMessage'] | translate}}
      </span>
      <ng-template #min_static_msg>
        <span>
          {{'ERROR.min_value' +field_config_access['validators']['minValue'] | translate}}
        </span>
      </ng-template>

    </ng-container>
    <ng-template #max>
      <ng-container *ngIf="form_control.hasError('max'); else minlength">

        <span
          *ngIf="field_config_access['validators'] && field_config_access['validators']['maxValueErrorMessage'];else max_static_msg">
          {{field_config_access['validators']['maxValueErrorMessage'] | translate}}
        </span>
        <ng-template #max_static_msg>
          <span>
            {{'ERROR.max_value' +field_config_access['validators']['maxValue'] | translate}}
          </span>
        </ng-template>

      </ng-container>
      <ng-template #minlength>
        <ng-container *ngIf="form_control.hasError('minlength'); else maxlength">

          <span
            *ngIf="field_config_access['validators'] && field_config_access['validators']['minLengthErrorMessage'];else minLength_static_msg">
            {{field_config_access['validators']['minLengthErrorMessage'] | translate}}
          </span>
          <ng-template #minLength_static_msg>
            <span>
              {{'ERROR.min_length' +field_config_access['validators']['minLength'] | translate}}
            </span>
          </ng-template>

        </ng-container>
        <ng-template #maxlength>
          <ng-container *ngIf="form_control.hasError('maxlength'); else pattern">

            <span
              *ngIf="field_config_access['validators'] && field_config_access['validators']['maxLengthErrorMessage'];else maxLength_static_msg">
              {{field_config_access['validators']['maxLengthErrorMessage'] | translate}}
            </span>
            <ng-template #maxLength_static_msg>
              <span>
                {{'ERROR.max_length' +field_config_access['validators']['maxLength'] | translate}}
              </span>
            </ng-template>

          </ng-container>
          <ng-template #pattern>
            <ng-container *ngIf="form_control.hasError('pattern'); else common">

              <span
                *ngIf="field_config_access['validators'] && field_config_access['validators']['finalPatternErrorMessage'];else pattern_static_msg">
                {{field_config_access['validators']['finalPatternErrorMessage'] | translate}}
              </span>
              <ng-template #pattern_static_msg>
                <span>
                  {{'ERROR.invalid_input' | translate}}
                </span>
              </ng-template>

            </ng-container>
            <ng-template #common>

              <span
                *ngIf="field_config_access['validators'] && field_config_access['validators']['generalErrorMessage'];else common_static_msg">
                {{field_config_access['validators']['generalErrorMessage'] | translate}}
              </span>
              <ng-template #common_static_msg>
                <span>
                  {{'ERROR.invalid_input' | translate}}
                </span>
              </ng-template>

            </ng-template>

          </ng-template>

        </ng-template>

      </ng-template>

    </ng-template>

  </ng-template>

</ng-template>

<div class="camera" id='camera'>
  <video id="video"></video>
  <span class="btn-container">
    <button class="btn btn-sm js-btn-cancel mx-1" id="cancelButton">Cancel</button>
    <button id="startbutton" class="btn btn-sm js-btn-save mx-1">Take photo</button>
  </span>

</div> -->

<div class="right-container" *ngIf="masters && dynamic_sections && form_details">
  <tm-dynamic-form-v3 [sections]="dynamic_sections" [masters]="masters" [dynamic_form_group]="dynamic_form"
    [display_type]="5" (formDetails)="formDetails($event)" [verificationRequired]="verificationRequired"
    [alertId]="alertId" [verificationObj]="verificationObj" [verification_status_list]="masters.dataStatusList"
    [callbackFn]="callbackFn" [disable_button]="disable_button" [sec_data]="form_details"
    [extended_fields_titles]="extended_fields_titles" [all_form]="dynamic_form">
  </tm-dynamic-form-v3>
</div>

<div *ngIf="!(masters && dynamic_sections)" class="text-center mt-3">
  <i class="fa fa-spinner fa-spin"></i> Loading
</div>